/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace, push } from 'react-router-redux';
import qs from 'qs';
import clone from 'clone';
import moment from 'moment-timezone';
import _ from 'lodash';
import { required, stringLength, email, identity as validateIdentity, phoneNumber, matchRegex } from '@mhub/web-validations';
import {
  Button,
  Checkbox,
  Container,
  Dimmer,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Message,
  Modal,
  Popup,
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import config from '../../../../config';
import i18n from '../../../i18n';
// actions
import { fetchM } from '../../../actions/fetchM';
import { flashMessage, flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import { promptChangesMessage } from '../../../actions/prompt';
import { fetchAddressSettings } from '../../../actions/addressSettings';
import { fetchCustomOptions } from '../../../actions/customOptions';
// components
import AppForm from '../../../components/AppForm';
import BookingCreditCheck from '../../../components/BookingCreditCheck';
import BookingTitle from '../../../components/Bookings/BookingTitle';
import ESigningModal from '../../../components/SignaturePad/ESigningModal';
import TinFieldInput from '../../../components/AppForm/TinFieldInput';
import InputBirthdate from '../../../components/InputBirthdate';
import LPPSAChecker from '../../../components/LPPSAChecker';
import Phone from '../../../components/Phone';
import PhoneInput from '../../../components/AppForm/PhoneInput';
import Timestamp from '../../../components/Timestamp';
import SearchHimsDistricts from '../../../components/SearchHimsDistricts';
import SearchHimsPostcodes from '../../../components/SearchHimsPostcodes';
// constants
import CUSTOMER_TITLES from '../../../constants/customerTitles';
import INTL_CALL_CODES from '../../../constants/intlCallCodes';
import STATES from '../../../constants/states';
import { CANCEL_PROMPT } from '../../../constants/promptMessages';
import { MARITAL_STATUS } from '../../../constants/maritalStatus';
import { RELATIONSHIP_TYPE } from '../../../constants/relationshipType';
import { RACE } from '../../../constants/race';
import { GENDER } from '../../../constants/gender';
import { BUMI } from '../../../constants/bumi';
import { isCountryVietnam, SELECT_COUNTRIES, SELECT_NATIONALITY } from '../../../constants/countries';
import { EXTRA_PURCHASER_CUSTOM_FIELDS, PURCHASER_CUSTOM_FIELDS } from '../../../constants/defaultBookingFields';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { REGEX_POSTCODE_MY, REGEX_TIN_VALID, REGEX_NPWP_ID } from '../../../constants/regex';
// containers
import UploadForm from '../../CreditCheck/UploadForm';
// modals
import BookingStatusNotes from '../../modals/BookingStatusNotes';
import ShareESign from '../../modals/ShareESign';
// structs
import BOOKING_DEFAULT from '../../../structs/booking';
import BOOKING_CUSTOMER_DEFAULT from '../../../structs/booking_customer';
// utils
import dateFromIC from '../../../utils/dateFromIC';
import { decodeSearch, encodeSearch } from '../../../utils/url';
import { getCountryName } from '../../../utils/countries';
import { isNumeric } from '../../../utils/numbers/isNumber';
import { getPhoneValidRegex, mobileValidation, normalizeMobileFields } from '../../../utils/validations/phone';
import { isForeignCompany } from '../../../utils/companies';
import INTL_FLAG_CODES from '../../../constants/intlFlagCodes';
import { getIdentityTypeOpts, getSubmitIdentityTypeID } from '../../../utils/identityTypes';
import { vnFullNameValidations, vnIdentityValidation, vnPreferredNameValidations, idDocumentComplete, idDocumentSides, idDocumentUploads, vnCRMSearchField } from '../../../utils/vietnam';
import { translateModels } from '../../../utils/translation';
import { AUTOFILL_COMPANY, AUTOFILL_IDENTITY_TYPES, AUTOFILL_MSISDN, AUTOFILL_NRIC, AUTOFILL_PASSPORT, AUTOFILL_PRESET, AUTOFILL_PRS, CRM_SEARCH_FIELD_MAPPINGS } from '../../../constants/autofillTypes';
import { FOREIGN_BUYER_GENERIC_TIN, GENERIC_TIN_UNMATCHED_ERROR_MSG, GENERIC_TIN_VALUES, getAutoFillTin, getGenericTinByIdTypeAndTinNo, GOVERNMENT_GENERIC_TIN, isForeignIdType, isGenericTinFound } from '../../../constants/tin';
import { IDENTITY_TYPE_BRN, IDENTITY_TYPE_NRIC } from '../../../constants/defaultIdentityTypeOpts';
import { checkRegex } from '../../../components/RegexDropdownPicker';

const isPRS = config.get('prs');
// CPI-976: "Country of Citizen (Others by default)" - the value book-api and the CRM already use.
const CITIZEN_COUNTRY_OTHERS = 'OTHERS';
// A Vietnamese isolated purchaser's identity picture ends up on their CRM Customer, which only
// takes images.
const VN_IDENTITY_ACCEPT = 'image/jpeg, image/png';

// The ID snapshot and E-Signature cards share one row. When E-Signature is hidden (Vietnam uses
// wet-sign only), the snapshot card takes the whole row instead of leaving half of it empty.
export const getIDSnapshotColumnWidth = (showsESignature, isNarrow) => (
  (showsESignature && !isNarrow) ? 8 : 16
);

export const getRequiredIdentityLabel = (isVietnam, identityType, t) => (
  isVietnam && identityType === IDENTITY_TYPE_NRIC
    ? 'CCCD'
    : t(identityType === 4 ? (isVietnam ? 'Enterprise Registration Certificate' : 'Company Registration Number') : 'Identity')
);

class Purchaser extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisor: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      creditCheckAccess: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    onCheck: PropTypes.func,
    checkHasChanges: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        leadV2IsEnabled: PropTypes.bool,
        himsIsEnabled: PropTypes.bool,
        settings: PropTypes.shape({
          uppercasePurchaserInfoIsEnabled: PropTypes.bool,
        }),
      }),
    }),
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    fetchNewBooking: PropTypes.func,
    isMobile: PropTypes.bool,
    addressSettings: PropTypes.shape({
      data: PropTypes.array,
    }),
    customOptions: PropTypes.shape({
      data: PropTypes.array,
    }),
    combinedPrintTmplOnly: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
    addressSettings: state.addressSettings,
    identityPresets: state.identityPresets,
    phoneValidationPresets: state.phoneValidationPresets,
    customOptions: state.customOptions,
  })
  static defaultCustomerModal = {
    isOpen: false,
    header: '',
    headerIcon: 'warning sign',
    message: '',
    customerID: '',
    bookingCustomerID: '',
    bookingID: '',
    customerName: '',
    type: '',
  };
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = Object.assign({}, BOOKING_DEFAULT, props.data);
    const projectBookingCustomFields = props.projectBookingCustomFields || [];
    data.isCancelPending = true;
    if (!data.bankCases) {
      data.bankCases = [];
    }
    const errMessages = [];
    const tinMessage = null;
    const modal = Object.assign({}, Purchaser.defaultCustomerModal);
    const searchingID = false;
    const searchingIDByMobile = false;
    const autofillOptions = [];
    const existingCustomer = {};
    const externalCustomer = {};
    const leadCustomer = {};
    const identityError = false;
    const tinErrorAdd = null;
    const tinErrorEdit = null;
    const windowWidth = window.innerWidth;
    const widthIsLessThan1200 = windowWidth < 1200;
    const isCRMEnabled = props.appConfig && props.appConfig.data && props.appConfig.data.leadV2IsEnabled;

    const identityPresets = props.identityPresets.data;
    const identityTypeOpts = getIdentityTypeOpts(props.auth, identityPresets);
    const phoneValidationPresets = props.phoneValidationPresets.data;

    let hideTitle = false;
    const customOptions = props.customOptions.data;
    if (customOptions.length > 0) {
      const hideTitleOpt = customOptions.find(o => o.name === 'hide_purchaser_title');
      if (hideTitleOpt) {
        hideTitle = hideTitleOpt.value === 'true';
      }
    }

    return {
      data,
      oriData: clone(data),
      loading,
      errMessages,
      tinMessage,
      modal,
      searchingID,
      searchingIDByMobile,
      autofillOptions,
      existingCustomer,
      externalCustomer,
      leadCustomer,
      identityError,
      tinErrorAdd,
      tinErrorEdit,
      widthIsLessThan1200,
      identityPresets,
      identityTypeOpts,
      phoneValidationPresets,
      projectBookingCustomFields,
      isCRMEnabled,
      hideTitle,
    };
  }
  constructor(props) {
    super(props);
    const state = Purchaser.getPropsToState(props);
    const bookingCustomerDefaultData = BOOKING_CUSTOMER_DEFAULT;
    const auth = props.auth;
    this.identityInputRef = React.createRef();

    if (auth && isForeignCompany(auth.company)) {
      const idx = INTL_FLAG_CODES.findIndex(f => f.countryCode === auth.company.countryCode);
      if (idx !== -1) {
        const defaultCountryPhoneCode = INTL_FLAG_CODES[idx].value;
        bookingCustomerDefaultData.mobilePrefix = defaultCountryPhoneCode;
        bookingCustomerDefaultData.phonePrefix = defaultCountryPhoneCode;
        bookingCustomerDefaultData.emergencyContactMobilePrefix = defaultCountryPhoneCode;
        bookingCustomerDefaultData.country = INTL_FLAG_CODES[idx].countryCode;
      }
    }

    if (state.hideTitle) {
      BOOKING_CUSTOMER_DEFAULT.title = 'Not Applicable';
      bookingCustomerDefaultData.title = 'Not Applicable';
    }

    this.state = {
      ...state,
      isEditingCustomer: 0,
      editingCustomer: Object.assign({}, BOOKING_CUSTOMER_DEFAULT),
      customerAdd: Object.assign({}, BOOKING_CUSTOMER_DEFAULT),
      customerAddArea: false,
      customerAddChanges: false,
      customerChanges: false,
      customerICChanges: false,
      addCustomerICChanges: false,
      documentToken: null,
      icFront: null,
      icBack: null,
      icFrontAddCustomer: null,
      icBackAddCustomer: null,
      identity: '',
      identityType: isPRS ? 1 : '',
      identityPresetID: '',
      identityPresetLabel: '',
      identityPresetRegex: '',
      prsID: '',
      editingBooking: false,
      editingPayment: false,
      identityLock: false,
      mobileLock: false,
      bookingStatusModal: false,
      showNoAutofill: false,
      fetchDataErrorMessage: '',
      showCustomFields: false,
      showSignModal: false,
      showShareESignModal: false,
      existingLeadCustomer: null,
      isIOS: null,
      bookingCustomerDefaultData,
      shareESignData: null,
      isRenew: false,
      reviewedDeferredPurchaserIDs: [],
      taxIdentificationNo: '',
      taxTinValidationStatus: '', // currently not used
      tinEditFound: false,
      tinAddFound: false,
      screenWidth: window.innerWidth,
      showSoldConfirmation: false,
      // CPI-1332: per purchaser customer ID, book-api's answer on their CRM identity, with the
      // object URLs of the CRM pictures loaded for it (images.front / images.back).
      crmIdentities: {},
    };
    this.validation = {
      title: createRef(),
      name: createRef(),
      preferredName: createRef(),
      email: createRef(),
      mobilePrefix: createRef(),
      mobile: createRef(),
      phone: createRef(),
      country: createRef(),
      taxIdentificationNo: createRef(),
      prsID: createRef(),
      identityType: createRef(),
      identity: createRef(),
      emergencyContactMobilePrefix: createRef(),
      emergencyContactMobile: createRef(),
      emergencyContactEmail: createRef(),
      raceOther: createRef(),
      himsKodDaerah: createRef(),
      himsKodPoskod: createRef(),
      address8: createRef(),
      address9: createRef(),
    };
    // add validateRef for all enabled address settings
    const enabledAddressSettings = props.addressSettings.data.filter(as => as.enabled);
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach((as) => {
        const key = _.camelCase(as.columnName);
        this.validation[key] = createRef();
      });
    }
    this.loanBox = null;
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchAddressSettings());
    store.dispatch(fetchCustomOptions());
  }
  componentDidMount() {
    // Set moment locale based on current language
    const languageMap = {
      en: 'en-gb',
      vi: 'vi',
      id: 'id',
    };
    moment.locale(languageMap[i18n.language] || 'en-gb');
    this.getOpportunity();
    this.fetchCRMIdentities();
    window.addEventListener('resize', this.handleResize, false);
    this.checkIOS();
  }
  componentWillReceiveProps(nextProps) {
    const state = Purchaser.getPropsToState(nextProps);
    const stateIsSame = JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData);
    if (stateIsSame) {
      state.data = this.state.data;
      state.tinErrorAdd = this.state.tinErrorAdd;
      state.tinErrorEdit = this.state.tinErrorEdit;
      state.tinMessage = this.state.tinMessage;
    }
    const tinEditFound = !!(nextProps.data && nextProps.data.customer && nextProps.data.customer.taxIdentificationNo);
    this.setState({ ...state, tinEditFound }, () => {
      if (!stateIsSame) {
        this.getOpportunity();
        this.fetchCRMIdentities();
      }
    });
  }
  componentDidUpdate(prevProps, prevState) {
    // Sync moment locale when language changes
    if (prevProps && prevProps.i18n && prevProps.i18n.language !== this.props.i18n.language) {
      const languageMap = {
        en: 'en-gb',
        vi: 'vi',
        id: 'id',
      };
      moment.locale(languageMap[this.props.i18n.language] || 'en-gb');
      // Force re-render of children to update moment-based month names
      this.forceUpdate();
    }
    if (prevState && prevState.editingCustomer !== this.state.editingCustomer) {
      this.updateTinFieldState();
    }
  }
  componentWillUnmount() {
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
    window.removeEventListener('resize', this.handleResize);
    this.crmIdentityLoad = -1;
    this.revokeCRMIdentityImages(this.state.crmIdentities);
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  // need to bind this to allow LoanTracker to setLoading
  setLoading = (loading = false, loadingType) => new Promise((res) => {
    if (loadingType === 'validatingTIN') {
      this.setState({ validatingTin: loading }, res);
    } else {
      this.setState({ loading }, res);
    }
  })
  setSearchingID(searching = false, searchingType = 'searchingID') {
    let { identityLock, mobileLock } = this.state;
    const searchByID = searchingType === 'searchingID';
    const searchByMobile = searchingType === 'searchingIDByMobile';
    if (searching) {
      if (searchByID) identityLock = true;
      if (searchByMobile) mobileLock = true;
    } else {
      if (searchByID) identityLock = false;
      if (searchByMobile) mobileLock = false;
    }
    return new Promise((res) => {
      this.setState({
        searchingID: searchByID ? searching : this.state.searchingID,
        searchingIDByMobile: searchByMobile ? searching : this.state.searchingIDByMobile,
        identityLock,
        mobileLock },
        res,
      );
    });
  }
  getMPBucketName = () => {
    const { data = {} } = this.props;
    const bucketName = config.get('mpBucket');
    return data.origin.includes('marketplace') ? bucketName : null;
  }
  getIdentityPlaceholder = (isIndonesia) => {
    const { identityType, identityPresetLabel } = this.state;
    const { t } = this.props;
    if (identityType === '') {
      return t('Select Identity Type first');
    }
    if (typeof (identityType) === 'string') {
      const { identityTypeOpts } = this.state;
      const idx = identityTypeOpts.findIndex(i => i.value === identityType);
      if (idx !== -1) {
        return t('{{identity}} number', { identity: identityTypeOpts[idx].text });
      }
    }
    switch (identityType) {
      case 2:
        return t('Passport Number');
      case 4:
        return isIndonesia ? 'e.g. 1234567890123' : 'e.g. 202401012345';
      case 6:
        return t('{{identity}} number', { identity: identityPresetLabel });
      default:
        return t('Identity Number');
    }
  }
  getIdentityInputLabel = (isHidden) => {
    switch (this.state.identityType) {
      case 4:
        return isHidden ? null : 'Enter 12-digit Company Registration Number';
      default:
        return null;
    }
  }
  getIdentityTypeText = (identityTypeID, presetID, presetLabel) => {
    const { identityPresets } = this.state;
    const { auth, t } = this.props;
    const isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';
    if ((identityTypeID > 4 || typeof (identityTypeID) === 'string')) {
      if (identityPresets && identityPresets.length > 0) {
        const idx = identityPresets.findIndex(i => i.id === presetID);
        if (idx !== -1) {
          return identityPresets[idx].label;
        } else if (presetLabel) {
          return presetLabel;
        }
      }
      return t('ID Number');
    }
    switch (identityTypeID) {
      case 1:
        return isVietnam ? 'CCCD' : 'MyKad (NRIC)';
      case 2:
        return t('Passport Number');
      case 3:
        return t('Military / Police');
      case 4:
        return isVietnam ? t('Enterprise Registration Certificate') : t('Company Registration Number');
      default:
        return '';
    }
  }
  // How many images a purchaser's identity document has, and what to call it on screen.
  // Vietnam: a CCCD has a front and a back; a passport or an Enterprise Registration Certificate
  // is one image, stored in the front slot. Everywhere else the card is what it always was: NRIC,
  // front and back, with the MyKad samples.
  idDocumentShape = (identityTypeID) => {
    const { auth, t } = this.props;
    if (!isCountryVietnam(auth && auth.company && auth.company.countryCode)) {
      return { label: t('NRIC'), sides: 2, sample: true };
    }
    return {
      label: this.getIdentityTypeText(identityTypeID) || t('ID'),
      sides: idDocumentSides(identityTypeID, true),
      sample: false,
    };
  }

  getPrimaryBookingCustomer = (data) => {
    if (data.bookingCustomers && data.bookingCustomers.length > 0) {
      const primaryCustomer = data.bookingCustomers.find(f => f.customerID === data.customerID);
      if (primaryCustomer) {
        return primaryCustomer;
      }
    }
    return {};
  }
  getDocumentToken(editingCustomer, callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/bookings/${editingCustomer.bookingID}/customers/${editingCustomer.customerID}/documents/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then((res) => {
        const documentToken = res.headers.get('X-Csrf-Token');
        this.setState({
          documentToken,
        }, () => {
          if (callback) {
            callback();
          }
        });
      });
  }
  getRace = (race) => {
    if (race) {
      const preset = RACE.find(d => d.value.toLowerCase() === race.toLowerCase());
      if (!preset) {
        return 'Others';
      }
      return preset.value;
    }
    return '';
  }
  getBirthDate = (birthDate, nric) => {
    if (nric !== '' && nric.length === 12) {
      const dfIC = dateFromIC(nric.substring(0, 6));
      if (dfIC) {
        const mBirthdate = moment.tz(dfIC, config.get('tzName'));
        if (mBirthdate.isValid()) {
          return mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    const date = new Date(birthDate);
    if ((date !== 'Invalid Date') && !isNaN(date)) {
      return birthDate;
    }
    return '';
  }
  getMinimumPurchaserAgeMessage = () => this.props.t('Booking cannot be created. Purchaser must be at least 18 years old.');
  isUnderagePurchaser = (birthdate) => {
    if (!birthdate || birthdate === '') return false;

    const mBirthdate = moment(birthdate, 'YYYY-MM-DD', true).tz(config.get('tzName'), true);
    if (!mBirthdate.isValid()) return false;

    const age = moment.tz(config.get('tzName')).diff(mBirthdate, 'years');
    return age < 18;
  }
  isUnderageNRICPurchaser = (identityTypeID, identity) => {
    if (identityTypeID !== IDENTITY_TYPE_NRIC) return false;

    const dfIC = dateFromIC((identity || '').substring(0, 6));
    if (!dfIC) return false;

    const mBirthdate = moment.tz(dfIC, config.get('tzName'));
    if (!mBirthdate.isValid()) return false;

    return moment.tz(config.get('tzName')).diff(mBirthdate, 'years') < 18;
  }
  getMaritalStatus = (maritalStatus) => {
    if (maritalStatus) {
      const preset = MARITAL_STATUS.find(d => d.value.toLowerCase() === maritalStatus.toLowerCase());
      if (preset) {
        return preset.value;
      }
    }
    return '';
  }
  getAutofillIdentityTypeName = (typeID) => {
    if (!isNumeric(typeID)) return AUTOFILL_PRESET;
    if (typeID > 0 && typeID <= 6) {
      const idx = AUTOFILL_IDENTITY_TYPES.findIndex(a => a.id === typeID);
      if (idx > -1) return AUTOFILL_IDENTITY_TYPES[idx].name;
    }
    return AUTOFILL_NRIC;
  }
  getAutofillIdentityTypeID = (typeName) => {
    if (typeName !== '') {
      const idx = AUTOFILL_IDENTITY_TYPES.findIndex(a => a.name === typeName);
      if (idx > -1) return AUTOFILL_IDENTITY_TYPES[idx].id;
    }
    return 1;
  }
  getPhoneInputIcon = (mobile) => {
    const { t } = this.props;
    if (this.state.searchingIDByMobile) {
      return <Icon loading name="spinner" />;
    }
    if (this.hasResetMobileIcon(mobile)) {
      return (
        <Icon
          link
          name="x"
          onClick={this.handleResetAutofill}
          title={t('Clear Form')}
        />
      );
    }
    return null;
  }
  async getOpportunity() {
    const { data = {} } = this.props;
    if (
      (data && data.origin && data.origin !== 'lead') ||
      ((data && data.origin && data.originID === '') || !(data && data.originID))
    ) {
      return;
    }
    const opportunity = await this.fetchData(`/leads/opportunity/${data.originID}/`, 'isFetching');
    if (!opportunity) {
      return;
    }
    const { customer_ids: customerIDs, primary_customer: primaryCustomer } = opportunity.data;
    let existingLeadCustomer;
    if (data.bookingCustomers && data.bookingCustomers.length > 0) {
      let purchasers = [];
      if (primaryCustomer && primaryCustomer.purchasers && primaryCustomer.purchasers.length > 0) {
        purchasers = primaryCustomer.purchasers.filter(c => !data.bookingCustomers.some(bc => bc.customer.identity === c.identity));

        if (purchasers.length > 0) {
          existingLeadCustomer = purchasers[0];
        }
      }

      if (customerIDs && customerIDs.length > 0) {
        const availableCustomers = customerIDs.filter(c => !data.bookingCustomers.some(bc => bc.leadCustomerID === c));
        if (availableCustomers.length > 0) {
          let leadCustomers = await Promise.all(availableCustomers.map(id => this.fetchData(`/leads/customers/${id}/`, 'isFetching')));
          if (leadCustomers.length > 0) {
            leadCustomers = leadCustomers.filter(c => c && c.data).map(c => c.data);

            if (purchasers.length > 0) {
              const leadCus = leadCustomers.find(c => purchasers.some(p => c.identity === p.identity));
              if (leadCus) {
                existingLeadCustomer = leadCus.customer;
                existingLeadCustomer.leadCustomerID = leadCus.id;
              }
            } else {
              existingLeadCustomer = leadCustomers[0].customer;
              existingLeadCustomer.leadCustomerID = leadCustomers[0].id;
            }
          }
        }
      }
    }
    this.setState({ existingLeadCustomer });
  }
  getEmailValidation = () => {
    const emailValidation = [email];
    if (this.checkIsEmailRequired()) {
      emailValidation.push(required);
    }
    return emailValidation;
  }
  getDataAttributes = (purchaserIdx, daname, davalue) => {
    let newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    const purchaserDatasetName = `data-bot-purchaser${purchaserIdx + 1}${daname}`;
    return {
      [purchaserDatasetName]: newDavalue,
      'data-bot-target': 'purchasers',
    };
  }
  checkIOS = () => {
    if (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes('Mac'))) {
      this.setState({
        isIOS: true,
      });
    } else {
      this.setState({
        isIOS: false,
      });
    }
  }
  async updateBooking(booking, type = 'update', xid = this.state.data.id) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    if (type === 'update') {
      const validations = await AppForm.validate(this.validation, this.state.data);
      const errMessages = validations.filter(v => !v.isValid);
      await this.setComponentState({
        errMessages,
      });
      if (errMessages.length > 0) {
        await this.setLoading(false);
        store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errMessages.map(l => l.message) }));
        return;
      }
    }
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${xid}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(booking),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const data = await res.json();
    const query = decodeSearch(this.props.location.search);
    await this.setLoading(false);
    await this.setComponentState({
      editingPayment: type === 'payment' ? false : this.state.editingPayment,
      editingBooking: type !== 'payment' ? false : this.state.editingBooking,
    });
    if (type === 'primary') {
      store.dispatch(replace(`/bookings/${this.state.data.id}/?${encodeSearch(query)}`));
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Primary purchaser has been successfully updated.', { ns: TRANSLATION_FILES.translation }),
      }));
    } else {
      this.handleResetCheck(type === 'payment' ? 'paymentChanges' : 'bookingChanges');
      store.dispatch(push(`/bookings/${xid}/?${encodeSearch(query)}`));
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Booking {{code}} successfully updated', { code: data.code, ns: TRANSLATION_FILES.translation }),
      }));
    }
  }
  async fetchData(fetchPath, loaderName, includeCredentials = true, extraHeaders = {}, showError = true) {
    const { store } = this.context;
    const { t } = this.props;
    await this.setSearchingID(true, loaderName);
    let res = null;
    let extraRequest = {};
    if (includeCredentials) {
      extraRequest = {
        credentials: 'include',
      };
    }
    try {
      res = await store.dispatch(fetchM(fetchPath, {
        ...extraRequest,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...extraHeaders,
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        if (showError) store.dispatch(flashErrorMessage({ message }));
        if (!showError) this.setComponentState({ fetchDataErrorMessage: message });
        await this.setSearchingID(false, loaderName);
        return null;
      }
      await this.setSearchingID(false, loaderName);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return null;
    }
    if (!res.ok) {
      await this.setSearchingID(false, loaderName);
      Bugsnag.notifyException(new Error(`Server error during booking: ${res.status}`));
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return null;
    }
    await this.setSearchingID(false, loaderName);
    const data = {};
    const json = await res.json();
    if (json) {
      data.data = json;
    }
    return data;
  }
  async searchAutofillCustomer(searchValue, searchType, identityPresetID = '') {
    const { data } = this.state;
    const { t } = this.props;
    let existingCustomerData;
    let externalCustomerData;
    let leadCustomerData;

    let searchingBy = 'searchingID';
    if (searchType === AUTOFILL_MSISDN) searchingBy = 'searchingIDByMobile';

    if (isPRS) {
      existingCustomerData = await this.fetchData(
        `/search/prs/?search=${searchValue}&prsID=${this.state.prsID}&projectID=${data.projectID}&projectUnitID=${data.projectUnitID}`,
        searchingBy,
        true,
        {},
        false,
      );
    } else {
      const query = {
        search: searchValue,
        identityTypeID: this.getAutofillIdentityTypeID(searchType),
        projectBranchOwnerID: data.project.maOwnerCompanyBranchID,
      };
      if (searchType === AUTOFILL_PRESET) query.presetID = identityPresetID;

      existingCustomerData = await this.fetchData(`/customers/?${qs.stringify(query)}`, searchingBy);
    }

    // search external
    if (data.project.autofillFromUrl) {
      const headers = {
        'x-mhub-registration-code': process.env.CRM_KEY,
      };
      externalCustomerData = await this.fetchData(`${data.project.externalAutofillUrl}/customers/search/identity_type/${this.getAutofillIdentityTypeID(searchType)}/identity/${searchValue}/`, searchingBy, false, headers);
    }

    // search crm
    const crmIsVietnam = isCountryVietnam(this.props.auth && this.props.auth.company && this.props.auth.company.countryCode);
    const crmEnabledSearchTypes = [AUTOFILL_NRIC, AUTOFILL_PASSPORT, AUTOFILL_MSISDN, AUTOFILL_PRESET];
    if (crmIsVietnam) {
      crmEnabledSearchTypes.push(AUTOFILL_COMPANY);
    }
    if (crmEnabledSearchTypes.includes(searchType) && this.state.isCRMEnabled) {
      // A Vietnamese identity is stored in the CRM as cccd / passport / other_identity, never nric:
      // searching by the Malaysian field name found nobody and every Vietnamese buyer read as new.
      let crmSearchField = vnCRMSearchField(searchType, crmIsVietnam);
      if (searchType === AUTOFILL_PRESET) {
        const preset = this.state.identityPresets.find(p => p.id === identityPresetID);
        if (preset && preset.label) {
          const mapping = CRM_SEARCH_FIELD_MAPPINGS.find(map => map.label === preset.label);
          crmSearchField = mapping ? mapping.searchField : searchType;
        }
      }
      const crmQuery = {
        search: searchValue,
        searchField: crmSearchField,
      };
      if (searchType === AUTOFILL_PRESET) {
        crmQuery.presetID = identityPresetID;
      }
      leadCustomerData = await this.fetchData(`/leads/customers/search/?${qs.stringify(crmQuery)}`, searchingBy);
    }

    if (!existingCustomerData && !externalCustomerData && !leadCustomerData) {
      this.setState({ showNoAutofill: true });
      return;
    }
    let { existingCustomer, externalCustomer, leadCustomer } = {};
    const autofillOptions = [];
    const replacedByField = searchType === AUTOFILL_MSISDN ? 'msisdn' : 'identity';

    // if existing customer exists
    const customerIsExisting = existingCustomerData && existingCustomerData.data && existingCustomerData.data.length > 0;
    if (customerIsExisting) {
      existingCustomer = Object.assign({}, existingCustomerData.data[0]);
      delete existingCustomer.customerDetail.createdAt;
      delete existingCustomer.customerDetail.updatedAt;
      if (isPRS) {
        const isValidPhonePrefix = INTL_CALL_CODES.find(
          d => d.value === existingCustomer.customerDetail.mobilePrefix,
        );
        if (!isValidPhonePrefix) {
          const message = <span>Mobile prefix is invalid! Please inform the customer to update it in <a href="http://www.pr1ma.my" target="_blank">PRS system (www.pr1ma.my).</a></span>;
          this.setState({ fetchDataErrorMessage: message, showNoAutofill: true });
          return;
        }
      }
      autofillOptions.push({
        key: 'existing',
        text: t('Previous entry'),
        onClick: (e) => {
          e.preventDefault();
          this.replaceWithAutofill('existing', replacedByField);
        },
      });
    }

    // if external customer exists
    const externalCustomerExists = externalCustomerData && externalCustomerData.data;
    if (externalCustomerExists) {
      externalCustomer = Object.assign({}, externalCustomerData.data);
      delete externalCustomer.id;
      delete externalCustomer.customerDetailID;
      delete externalCustomer.customerDetail.id;
      delete externalCustomer.customerDetail.customerID;
      delete externalCustomer.customerDetail.createdAt;
      delete externalCustomer.customerDetail.updatedAt;
    }

    if (leadCustomerData && leadCustomerData.data && leadCustomerData.data.length > 0) {
      leadCustomer = Object.assign({}, leadCustomerData.data[0]);
      autofillOptions.push({
        key: 'lead',
        text: 'CRM',
        onClick: (e) => {
          e.preventDefault();
          this.replaceWithAutofill('lead', replacedByField);
        },
      });
    }

    const showNoAutofill = autofillOptions.length < 1;
    this.setState({
      existingCustomer,
      externalCustomer,
      leadCustomer,
      autofillOptions,
      showNoAutofill,
    }, () => {
      if (isPRS && customerIsExisting) this.replaceWithAutofill('existing', replacedByField);
    });
  }
  async removeCustomer(customerID, bookingID, silentLoad = false) {
    const { store } = this.context;
    const { t } = this.props;
    if (!silentLoad) {
      await this.setLoading(true);
    }
    try {
      await store.dispatch(fetchM(`/bookings/${bookingID}/customers/${customerID}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const modal = Object.assign({}, this.state.modal);
    modal.unitID = '';
    modal.customerID = '';
    this.setState({ modal }, () => {
      const query = decodeSearch(this.props.location.search);
      store.dispatch(replace(`/bookings/${this.state.data.id}/?${encodeSearch(query)}`));
    });
    await this.setLoading(false);
    store.dispatch(flashMessage({
      header: t('Purchaser Removed', { ns: TRANSLATION_FILES.translation }),
      message: `${t('Purchaser {{name}} was successfully removed', { name: modal.customerName, ns: TRANSLATION_FILES.translation })}.`,
      icon: 'x',
      type: 'success',
      autoHideDuration: 5000,
    }));
  }
  // Returns null once the upload is saved, or the error message it showed when it was not.
  async uploadDocument(body, bookingCustomer) {
    await this.setLoading(true);
    const { documentToken } = this.state;
    const { t } = this.props;
    const { store } = this.context;
    try {
      await store.dispatch(fetchM(`/bookings/${bookingCustomer.bookingID}/customers/${bookingCustomer.customerID}/documents/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': documentToken,
        },
        body,
      }));
      // CPI-1332: a linked purchaser's upload replaced their CRM Customer's pictures; show those.
      this.fetchCRMIdentities();
      return null;
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      const message = (err.res && err.res.status >= 400 && err.res.status < 500 && await err.res.text()) ||
        `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.`;
      store.dispatch(flashErrorMessage({ message }));
      return message;
    }
  }
  async updateBookingCustomer() {
    const { t, auth } = this.props;
    await this.setLoading(true);
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    // CPI-976: no TIN field in Vietnam, so the BRN "Invalid TIN" precondition must not apply.
    const isVietnam = isCountryVietnam(auth && auth.company && auth.company.countryCode);
    const bookingCustomer = this.state.editingCustomer;
    bookingCustomer.monthlyIncome = parseFloat(bookingCustomer.monthlyIncome);
    bookingCustomer.race = bookingCustomer.race.toUpperCase() === 'Others'.toUpperCase() ? bookingCustomer.raceOther : bookingCustomer.race;
    bookingCustomer.taxIdentificationNo = bookingCustomer.customer.taxIdentificationNo;
    bookingCustomer.isForeignCompany = bookingCustomer.customer.isForeignCompany;
    // CPI-976 (M4): send the citizenship the screen shows, or a legacy row round-trips ''. VN only.
    if (isVietnam) {
      bookingCustomer.citizenship = this.getCitizenship(bookingCustomer);
    }
    const validations = await AppForm.validate(this.validation, bookingCustomer);
    const errMessages = validations.filter(v => !v.isValid);
    const { store } = this.context;
    await this.setComponentState({
      errMessages,
    });
    if (errMessages.length > 0) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errMessages.map(l => l.message) }));
      return;
    }
    if (!isVietnam && this.isUnderagePurchaser(bookingCustomer.birthdate)) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: this.getMinimumPurchaserAgeMessage() }));
      return;
    }
    if (!isVietnam && this.isUnderageNRICPurchaser(bookingCustomer.customer.identityTypeID, bookingCustomer.customer.identity)) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: this.getMinimumPurchaserAgeMessage() }));
      return;
    }
    bookingCustomer.customer.taxIdentificationNo = bookingCustomer.taxIdentificationNo;
    bookingCustomer.customer.isForeignCompany = bookingCustomer.isForeignCompany;
    bookingCustomer.customer.taxTinValidationStatus = this.state.tinErrorEdit === false ? 'success' : 'failed';
    if (!isIndonesia && !isVietnam && bookingCustomer.customer.taxTinValidationStatus !== 'success' && bookingCustomer.customer.identityTypeID === IDENTITY_TYPE_BRN && !bookingCustomer.customer.isForeignCompany) {
      await this.setLoading(false);
      store.dispatch(flashMessage({
        header: 'Invalid TIN',
        message: 'Tax Identification Number is invalid',
        icon: 'warning sign',
        type: 'error',
        autoHideDuration: 5000,
      }));
      return;
    }

    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${bookingCustomer.bookingID}/customers/${bookingCustomer.customerID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(bookingCustomer),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const data = await res.json();
    if (this.state.customerICChanges) {
      await this.getDocumentToken(bookingCustomer, async () => {
        const formData = await this.handleCreateFormData();
        // CPI-1426: the purchaser's details are saved, but a refused picture keeps the edit open
        // with the refusal shown, instead of closing it under a success message.
        if (await this.uploadDocument(formData, bookingCustomer)) return;
        await this.setLoading(false);
        if (this.icFrontUpload) await this.icFrontUpload.resetFiles();
        if (this.icBackUpload) await this.icBackUpload.resetFiles();
        await this.setComponentState({
          isEditingCustomer: 0,
          icFront: null,
          icBack: null,
        });
        this.handleResetCheck('customerICChanges', () => {
          if (this.state.customerChanges) {
            this.handleResetCheck('customerChanges', () => {
              this.handleOnCheck();
            });
          } else {
            this.handleOnCheck();
          }
        });
        const query = this.queryAfterDeferredPurchaserSave(bookingCustomer);
        const previousQuery = decodeSearch(this.props.location.search);
        // Keep review saves on one history entry, including intermediate purchasers.
        const navigate = isVietnam && this.state.data.purchasersIsolated &&
          previousQuery.reviewPurchasers === '1' ? replace : push;
        store.dispatch(navigate(`/bookings/${this.state.data.id}/?${encodeSearch(query)}`));
        if (data !== null) {
          store.dispatch(flashSuccessMessage({
            header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
            message: `${t('Booking Customer {{name}} has been successfully updated', { name: data.preferredName, ns: TRANSLATION_FILES.translation })}.`,
          }));
        } else {
          store.dispatch(flashSuccessMessage({
            header: t('Upload Success', { ns: TRANSLATION_FILES.translation }),
            message: `${t('Booking Customer {{name}}\'s IC photos has been successfully uploaded', { name: data.preferredName, ns: TRANSLATION_FILES.translation })}.`,
          }));
        }
      });
    } else {
      await this.setLoading(false);
      await this.setComponentState({
        isEditingCustomer: 0,
      });
      this.handleResetCheck('customerChanges', () => {
        const query = this.queryAfterDeferredPurchaserSave(bookingCustomer);
        store.dispatch(replace(`/bookings/${this.state.data.id}/?${encodeSearch(query)}`));
        store.dispatch(flashSuccessMessage({
          header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
          message: `${t('Booking Customer {{name}} has been successfully updated', { name: data.preferredName, ns: TRANSLATION_FILES.translation })}.`,
        }));
      });
    }
  }
  async updateBookingCustomerSignature(bookingID, customerID, signature) {
    await this.setLoading(true);
    const bookingCustomer = {};
    bookingCustomer.signature = signature;
    const { store } = this.context;
    const { t } = this.props;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${bookingID}/customers/${customerID}/signature/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(bookingCustomer),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const data = await res.json();
    this.setState({
      showSignModal: false,
      editingCustomer: Object.assign({}, this.state.bookingCustomerDefaultData),
    });
    await this.setLoading(false);
    await this.signatureModal.handleOnCancel();
    const query = decodeSearch(this.props.location.search);
    await store.dispatch(replace(`/bookings/${this.state.data.id}/?${encodeSearch(query)}`));
    await store.dispatch(flashSuccessMessage({
      header: t('Sign Success', { ns: TRANSLATION_FILES.translation }),
      message: `${t('Customer {{name}} has been sign the booking form', { name: data.preferredName, ns: TRANSLATION_FILES.translation })}.`,
    }));
  }
  async submitCustomer() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t, auth } = this.props;
    const { customerAdd, identityType } = this.state;
    const trimmedIdentity = this.state.identity ? this.state.identity.trim() : '';
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    const isVietnam = isCountryVietnam(auth && auth.company && auth.company.countryCode);
    const requiredIdentityLabel = getRequiredIdentityLabel(isVietnam, identityType, t);

    // Validate the same identity that is sent, including after autofill or reset.
    customerAdd.identity = trimmedIdentity;
    customerAdd.customer.taxTinValidationStatus = this.state.tinErrorAdd === false ? 'success' : 'failed';
    if (!isIndonesia && !isVietnam && customerAdd.customer.taxTinValidationStatus !== 'success' && this.state.identityType === IDENTITY_TYPE_BRN && !customerAdd.customer.isForeignCompany) {
      await this.setLoading(false);
      store.dispatch(flashMessage({
        header: 'Invalid TIN',
        message: 'Tax Identification Number is invalid',
        icon: 'warning sign',
        type: 'error',
        autoHideDuration: 5000,
      }));
      return;
    }
    customerAdd.taxIdentificationNo = customerAdd.customer.taxIdentificationNo;
    const validations = await AppForm.validate(this.validation, { ...customerAdd, identityType });
    const errMessages = validations.filter(v => !v.isValid);
    // Custom preset IDs are strings and must still map to API identity type 6.
    // Validate the selection before that mapping, independently of mounted form refs.
    if ((!identityType || (typeof identityType === 'string' && identityType.trim() === '')) &&
      !errMessages.some(error => error.key === 'identityType')) {
      errMessages.unshift({
        isValid: false,
        key: 'identityType',
        message: t('Please select Identity Type'),
      });
    }
    if (!trimmedIdentity && !errMessages.some(error => error.key === 'identity')) {
      errMessages.push({
        isValid: false,
        key: 'identity',
        message: `${requiredIdentityLabel} ${t('is required', { ns: TRANSLATION_FILES.translation })}`,
      });
    }
    const postCustomer = {
      address1: customerAdd.address1,
      address2: customerAdd.address2,
      address3: customerAdd.address3,
      address4: customerAdd.address4,
      address5: customerAdd.address5,
      address6: customerAdd.address6,
      address7: customerAdd.address7,
      address8: customerAdd.address8,
      address9: customerAdd.address9,
      address10: customerAdd.address10,
      himsKodPoskod: customerAdd.himsKodPoskod,
      himsKodBandar: customerAdd.himsKodBandar,
      himsKodDaerah: customerAdd.himsKodDaerah,
      himsKodNegeri: customerAdd.himsKodNegeri,
      himsKodNegara: customerAdd.himsKodNegara,
      country: customerAdd.country,
      email: customerAdd.email,
      mobile: customerAdd.mobile,
      mobilePrefix: customerAdd.mobilePrefix,
      name: customerAdd.name,
      phone: customerAdd.phone,
      phonePrefix: customerAdd.phonePrefix,
      preferredName: customerAdd.preferredName,
      title: this.state.hideTitle ? 'Not Applicable' : customerAdd.title,
      customerID: customerAdd.customerID,
      jobTitle: customerAdd.jobTitle,
      monthlyIncome: parseFloat(customerAdd.monthlyIncome),
      nationality: customerAdd.nationality,
      // CPI-976 (M4): post the resolved 'local' | 'foreigner'; not sent outside Vietnam.
      citizenship: isVietnam ? this.getCitizenship(customerAdd) : '',
      birthdate: customerAdd.birthdate,
      gender: customerAdd.gender,
      race: customerAdd.race.toUpperCase() === 'Others'.toUpperCase() ? customerAdd.raceOther : customerAdd.race,
      bumi: customerAdd.bumi,
      maritalStatus: customerAdd.maritalStatus,
      // Related purchaser's relationship to the primary purchaser (VN only; see renderRelationshipTypeSelect).
      relationshipType: isVietnam ? this.getRelationshipType(customerAdd) : '',
      emergencyContactName: customerAdd.emergencyContactName,
      emergencyContactRelation: customerAdd.emergencyContactRelation,
      emergencyContactMobile: customerAdd.emergencyContactMobile,
      emergencyContactMobilePrefix: customerAdd.emergencyContactMobilePrefix,
      emergencyContactEmail: customerAdd.emergencyContactEmail,
      emergencyContactIdentity: customerAdd.emergencyContactIdentity,
      customer: {
        identity: trimmedIdentity,
        identityTypeID: getSubmitIdentityTypeID(identityType, this.state.identityPresetID, this.state.identityPresets),
        identityPresetID: this.state.identityPresetID,
        identityPresetLabel: this.state.identityPresetLabel,
        identityPresetRegex: this.state.identityPresetRegex,
        specifications: customerAdd.specifications,
        taxIdentificationNo: customerAdd.customer.taxIdentificationNo,
        taxTinValidationStatus: customerAdd.customer.taxTinValidationStatus,
        isForeignCompany: customerAdd.customer.isForeignCompany,
      },
      leadCustomerID: customerAdd.leadCustomerID,
      leadICFrontURL: customerAdd.leadICFrontURL,
      leadICBackURL: customerAdd.leadICBackURL,
    };
    // Diagnostic: submit-time state when title/identity are blank (orphan-customer investigation).
    if (!postCustomer.title || !postCustomer.customer.identity) {
      Bugsnag.notifyException(new Error('submitCustomer: blank title/identity at submit time'), 'Purchaser diagnostic', {
        diagnostic: {
          bookingID: this.state.data && this.state.data.id,
          title: postCustomer.title,
          identity: postCustomer.customer.identity,
          identityTypeID: postCustomer.customer.identityTypeID,
          leadCustomerID: postCustomer.leadCustomerID,
          identityLock: this.state.identityLock,
          mobileLock: this.state.mobileLock,
          hideTitle: this.state.hideTitle,
          errMessages: JSON.stringify(errMessages.map(m => m.message)),
          willBeBlocked: errMessages.length > 0,
        },
      });
    }
    await this.setComponentState({
      errMessages,
    });
    if (errMessages.length > 0) {
      let header = t('Please fix form errors', { ns: TRANSLATION_FILES.translation });
      if (isPRS && !this.state.addCustomerICChanges) header = <span>Please fix form errors or inform the customer to update their details in <a href="http://www.pr1ma.my" target="_blank">PRS system (www.pr1ma.my)</a></span>;
      await this.setLoading(false);
      store.dispatch(flashMessage({
        header,
        list: errMessages.map(l => l.message),
        icon: 'warning sign',
        type: 'error',
        autoHideDuration: 5000,
      }));
      // Scroll
      const body = document.getElementsByTagName('body')[0];
      const customerAddGrid = document.getElementsByClassName('customer add');
      if (customerAddGrid.length > 0) {
        window.scrollTo(0, body.scrollHeight - customerAddGrid[0].scrollHeight - 190);
      }
      return;
    }
    if (!isVietnam && this.isUnderagePurchaser(postCustomer.birthdate)) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: this.getMinimumPurchaserAgeMessage() }));
      return;
    }
    if (!isVietnam && this.isUnderageNRICPurchaser(postCustomer.customer.identityTypeID, trimmedIdentity)) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: this.getMinimumPurchaserAgeMessage() }));
      return;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.state.data.id}/customers/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(postCustomer),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const data = await res.json();
    if (this.state.addCustomerICChanges) {
      await this.getDocumentToken(data, async () => {
        const formData = await this.handleCreateFormData(true);
        const uploadError = await this.uploadDocument(formData, data);
        await this.setLoading(false);
        await this.resetCustomerAddDocumentState();
        await this.setComponentState({
          customerAdd: Object.assign({}, this.state.bookingCustomerDefaultData),
          customerAddArea: false,
          autofillOptions: [],
          identity: '',
          identityType: '',
          identityLock: false,
          mobileLock: false,
          prsID: '',
          isEditingCustomer: 0,
          existingCustomer: {},
          taxIdentificationNo: '',
        });
        this.handleResetCheck('addCustomerICChanges', () => {
          if (this.state.customerAddChanges) {
            this.handleResetCheck('customerAddChanges', () => {
              this.handleOnCheck();
            });
          } else {
            this.handleOnCheck();
          }
        });
        const query = decodeSearch(this.props.location.search);
        store.dispatch(replace(`/bookings/${this.state.data.id}/?${encodeSearch(query)}`));
        // CPI-1426: the purchaser is added either way, so the form still closes (submitting it
        // again would add them twice), but a refused picture is shown again after navigating
        // cleared it, rather than a success message.
        if (uploadError) {
          store.dispatch(flashErrorMessage({ message: uploadError }));
          return;
        }
        store.dispatch(flashMessage({
          header: t('Purchaser Added', { ns: TRANSLATION_FILES.translation }),
          message: `${t('Purchaser {{name}} was successfully added', { name: customerAdd.name, ns: TRANSLATION_FILES.translation })}.`,
          icon: 'check',
          type: 'success',
          autoHideDuration: 5000,
        }));
      });
    } else {
      await this.resetCustomerAddDocumentState();
      await this.setComponentState({
        customerAdd: Object.assign({}, this.state.bookingCustomerDefaultData),
        customerAddArea: false,
        autofillOptions: [],
        identity: '',
        identityType: '',
        identityLock: false,
        mobileLock: false,
        existingCustomer: {},
        taxIdentificationNo: '',
      });
      await this.setLoading(false);
      this.handleResetCheck('customerAddChanges', async () => {
        const query = decodeSearch(this.props.location.search);
        await store.dispatch(replace(`/bookings/${this.state.data.id}/?${encodeSearch(query)}`));
        await store.dispatch(flashMessage({
          header: t('Purchaser Added', { ns: TRANSLATION_FILES.translation }),
          message: `${t('Purchaser {{name}} was successfully added', { name: customerAdd.name, ns: TRANSLATION_FILES.translation })}.`,
          icon: 'check',
          type: 'success',
          autoHideDuration: 5000,
        }));
      });
    }
    if (this.props.checkHasChanges()) {
      this.props.onCheck(false);
    }
  }
  async updateLPPSA(customerData) {
    const { t } = this.props;
    const data = customerData;
    delete data.lppsaResult;
    delete data.customerDetail;
    await this.setLoading(true);
    const { store } = this.context;
    try {
      await store.dispatch(fetchM(`/bookings/${this.state.data.id}/customer/${data.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(data),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
  }
  async fetchGenerateESignToken(body) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t, token } = this.props;
    const { editingCustomer, isRenew } = this.state;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${editingCustomer.bookingID}/customers/${editingCustomer.customerID}/signature_tokens/${isRenew ? 'new/' : ''}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
        body: JSON.stringify(body),
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      this.setState({ shareESignData: data });
    }
    await this.setLoading(false);
  }
  async fetchExistingESignToken() {
    await this.setLoading(true);
    const { editingCustomer } = this.state;
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${editingCustomer.bookingID}/customers/${editingCustomer.customerID}/signature_tokens/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      this.setState({ shareESignData: data });
    }
    await this.setLoading(false);
  }
  async sendESignToken(type) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t, token } = this.props;
    const { editingCustomer, shareESignData } = this.state;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${editingCustomer.bookingID}/customers/${editingCustomer.customerID}/signature_tokens/${shareESignData.id}/?type=${type}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      store.dispatch(flashSuccessMessage({
        header: t('Send Success', { ns: TRANSLATION_FILES.translation }),
        // CPI-976: the email channel (Vietnam) gets its own wording; SMS keeps the URL-and-PIN text.
        message: type === 'email'
          ? t('The e-signing invitation has been emailed to the purchaser', { ns: TRANSLATION_FILES.translation })
          : t('The URL and PIN have been sent to the purchaser', { ns: TRANSLATION_FILES.translation }),
      }));
    }
    await this.setLoading(false);
  }
  hasAccess(check = false, admin = true, dhq = true, dbl = true, internal = false) {
    const auth = this.props.auth;
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  hasCustomerManageAccess(allowAgentManageBookingCustomer, bookingStatus) {
    const auth = this.props.auth;
    if (auth.companyBranch.isExternal && !allowAgentManageBookingCustomer) {
      return false;
    }
    if (auth.companyBranch.isExternal && allowAgentManageBookingCustomer && bookingStatus !== 'reserved') {
      return false;
    }
    return true;
  }
  // CPI-976: Vietnam E-Sign is held back after the client demo; wet-sign upload is the only route.
  hasPurchaserSignPadAccess(allowAgentManageBookingCustomer, bookingStatus) {
    const { auth } = this.props;
    if (isCountryVietnam(auth && auth.company && auth.company.countryCode)) {
      return false;
    }
    return this.hasCustomerManageAccess(allowAgentManageBookingCustomer, bookingStatus);
  }
  renderSignPadUnavailableTooltip = () => {
    const { t, auth } = this.props;
    if (!isCountryVietnam(auth && auth.company && auth.company.countryCode)) return null;
    return (
      <Popup
        content={t(
          'Sign on paper and upload it in the Documents tab',
          { ns: TRANSLATION_FILES.translation },
        )}
        position="top center"
        trigger={<Icon name="info circle" style={{ cursor: 'help', marginLeft: '0.35em' }} />}
      />
    );
  }
  hasChangePrimaryPurchaserAccess(allowAgentChangePrimaryPurchaser, bookingStatus) {
    const auth = this.props.auth;
    if (
      auth && auth.companyBranch && auth.companyBranch.isExternal &&
      allowAgentChangePrimaryPurchaser && bookingStatus === 'reserved'
    ) {
      return true;
    }
    return false;
  }
  hasShareESignAccess() {
    const { data } = this.state;
    const { auth } = this.props;
    if (isCountryVietnam(auth && auth.company && auth.company.countryCode)) {
      return false;
    }
    if (data.project && data.project.shareESignIsEnabled) {
      if (auth.companyBranch.isExternal && !data.project.allowAgentShareESign) {
        return false;
      }
      if (auth.companyBranch.isExternal && data.project.allowAgentShareESign && data.statusID !== 'reserved') {
        return false;
      }
      return true;
    }
    return false;
  }
  handleOnCheck = (callback) => {
    if (this.props.onCheck) {
      const hasChanges = (
        this.state.customerChanges ||
        this.state.customerAddChanges ||
        this.state.customerICChanges ||
        this.state.addCustomerICChanges
      );
      this.props.onCheck(hasChanges, callback);
    }
  }
  handleCheckChanges = (value, callback) => {
    const state = this.state;
    if (state[value] === false) {
      state[value] = true;
      this.setState({ [value]: state[value] }, () => {
        this.handleOnCheck(callback);
      });
    }
  }
  handleResetCheck = (value, callback) => {
    const state = this.state;
    if (state[value] === true) {
      state[value] = false;
      this.setState({ [value]: state[value] }, () => {
        this.handleOnCheck(callback);
      });
    }
  }
  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const widthIsLessThan1200 = windowWidth < 1200;
    if (widthIsLessThan1200 !== this.state.widthIsLessThan1200) {
      state.widthIsLessThan1200 = widthIsLessThan1200;
    }
    const keys = Object.keys(state);
    if (keys.length > 0) {
      this.setState({ ...state });
    }
    this.setState({ screenWidth: window.innerWidth });
  }
  handleGetIC = (ic, direction = 'Front', changes) => {
    // UploadForm.resetFiles emits its empty upload object through onChange. Store it as null so a
    // reset cannot be mistaken for an add-purchaser document or mark that form as changed. Keep
    // the established edit-purchaser behavior for MY/ID controls.
    const isAddCustomerDocument = direction === 'FrontAddCustomer' || direction === 'BackAddCustomer';
    const upload = isAddCustomerDocument && (!ic || !ic.file) ? null : ic;
    this.setState({ [`ic${direction}`]: upload }, () => {
      if (!isAddCustomerDocument || upload) this.handleCheckChanges(changes);
    });
  }

  resetCustomerAddDocumentState = async () => {
    // Clear parent state before resetting the child forms. Their onChange callbacks report an
    // empty upload object, which handleGetIC normalizes back to null above.
    await this.setComponentState({
      icFrontAddCustomer: null,
      icBackAddCustomer: null,
    });
    if (this.icFrontUploadAddCustomer) this.icFrontUploadAddCustomer.resetFiles();
    if (this.icBackUploadAddCustomer) this.icBackUploadAddCustomer.resetFiles();
  }

  handleCreateFormData = (addCustomer = false) => {
    const formData = new FormData();
    const { icFront, icBack, icFrontAddCustomer, icBackAddCustomer, editingCustomer } = this.state;
    const { auth } = this.props;
    const isVietnam = isCountryVietnam(auth && auth.company && auth.company.countryCode);
    const identityTypeID = addCustomer
      ? this.state.identityType
      : ((editingCustomer.customer && editingCustomer.customer.identityTypeID) || editingCustomer.identityTypeID);
    // A one-image document has no back. The back control unmounts when the agent switches from
    // CCCD to a passport, but a file picked before the switch is still in state; it must not be
    // sent as "IC Back" against a passport.
    const uploads = idDocumentUploads(
      addCustomer ? icFrontAddCustomer : icFront,
      addCustomer ? icBackAddCustomer : icBack,
      idDocumentSides(identityTypeID, isVietnam),
    );
    uploads.forEach(({ index, upload }) => {
      formData.append(`files_${index}`, upload.file);
      formData.append(`tags_${index}`, upload.tags);
      formData.append(`names_${index}`, upload.name);
      formData.append(`degrees_${index}`, upload.degree);
      formData.append(`mark_${index}`, true);
    });
    return formData;
  }
  handleUpdatePrimaryCustomer = (newCustomerID, newBookingCustomerID) => {
    const booking = {
      customerID: newCustomerID,
      bookingcustomerID: newBookingCustomerID,
    };
    this.updateBooking(booking, 'primary');
  }
  handleShowSign = (e, data) => {
    e.preventDefault();
    const { auth } = this.props;
    if (isCountryVietnam(auth && auth.company && auth.company.countryCode)) return;
    const editingCustomer = Object.assign({}, this.state.bookingCustomerDefaultData, data);
    this.setState({ showSignModal: true, showShareESignModal: false, editingCustomer });
  }
  handleProceedShareESign = (e, data) => {
    e.preventDefault();
    this.fetchGenerateESignToken(data);
  }
  handleRenewESign = (e) => {
    this.setState({ shareESignData: null, isRenew: true }, () => {
      this.handleShowShareESign(e, this.state.editingCustomer);
    });
  }
  handleShowShareESign = (e, customer) => {
    e.persist();
    if (!this.hasShareESignAccess()) return;
    const { data, isRenew } = this.state;
    const editingCustomer = Object.assign({}, this.state.bookingCustomerDefaultData, customer);
    const hasFormStep = data.project && data.project.shareESignAllowPreviewForm;
    this.setState({ showShareESignModal: true, editingCustomer }, () => {
      if (!isRenew && hasFormStep) {
        // hide form dropdown if token exists
        this.fetchExistingESignToken();
      }
      if (!hasFormStep) {
        this.fetchGenerateESignToken({
          printTemplateIDs: [],
          docxTemplateIDs: [],
          allowSendFormsEmail: false,
        });
      }
    });
  }
  handleSendESignToken = (e, type) => {
    e.preventDefault();
    this.sendESignToken(type);
  }
  handleOnCloseShareESign = (e) => {
    e.preventDefault();
    this.setState({ showShareESignModal: false, shareESignData: null, isRenew: false });
  }
  handleOnCancel = (e) => {
    e.preventDefault();
    this.signatureModal.handleOnCancel();
    this.setState({
      editingCustomer: Object.assign({}, this.state.bookingCustomerDefaultData),
      showSignModal: false,
    });
  }
  handleOpenModal = (
    customerName,
    customerID,
    bookingCustomerID,
    bookingID,
    headerIcon,
    header,
    message,
    type,
  ) => {
    const modal = Object.assign({}, this.state.modal);
    modal.customerID = customerID;
    modal.bookingCustomerID = bookingCustomerID;
    modal.bookingID = bookingID;
    modal.isOpen = true;
    modal.header = header;
    modal.message = message;
    modal.headerIcon = headerIcon;
    modal.customerName = customerName;
    modal.type = type;
    this.setState({ modal });
  }
  handleCloseModal = () => {
    const modal = Purchaser.defaultCustomerModal;
    modal.isOpen = false;
    this.setState({ modal });
  }
  handleConfirm = () => {
    const modal = Object.assign({}, this.state.modal);
    modal.isOpen = false;
    this.setState({ modal }, () => {
      if (modal.type === 'remove') {
        this.removeCustomer(modal.customerID, modal.bookingID);
      } else if (modal.type === 'primary') {
        this.handleUpdatePrimaryCustomer(modal.customerID, modal.bookingCustomerID);
      }
    });
  }
  handleIdentityChange = (e) => {
    const identity = this.toUppercaseFormat(e.target.value);
    let { searchingID } = this.state;
    const { customerAdd, identityType, identityPresetID } = this.state;
    if (identityType === 1 && identity.length === 12) {
      const dfIC = dateFromIC(identity.substring(0, 6));
      if (dfIC) {
        const mBirthdate = moment.tz(dfIC, config.get('tzName'));
        if (mBirthdate.isValid()) {
          customerAdd.birthdate = mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    if (isNumeric(identity) || identity === '') {
      if (identity.length !== 12) {
        customerAdd.customerDetailID = null;
        customerAdd.customerID = null;
      } else if (this.state.identityType === 1 && identity.length === 12) {
        if (!isPRS || (isPRS && this.state.prsID && this.state.prsID.length === 13)) {
          searchingID = true;
        }
      }
    }
    this.setState({ identity, customerAdd, autofillOptions: [], searchingID }, () => {
      if (this.state.identityType === 1 && identity.length === 12 && this.state.searchingID) {
        if (this.identityInputRef.current) {
          this.identityInputRef.current.blur();
        }
        this.searchAutofillCustomer(identity, this.getAutofillIdentityTypeName(this.state.identityType));
      }
      if (this.state.identityType !== 1 && identity.length > 0) {
        clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          if (this.state.identityLock &&
            (this.state.autofillOptions && this.state.autofillOptions.length > 0)
          ) {
            this.setState({ identity: customerAdd.identity });
          } else {
            this.searchAutofillCustomer(identity, this.getAutofillIdentityTypeName(this.state.identityType), identityPresetID);
          }
        }, 1000);
      }
      this.handleCheckChanges('customerAddChanges');
    });
  }
  handlePRSIDChange = (e) => {
    const { customerAdd } = this.state;
    const value = e.target.value;
    customerAdd.prsID = value;
    if (value.length > 13) return;
    this.setState({ prsID: value, customerAdd }, () => {
      this.handleCheckChanges();
      if (value.length === 13 && this.state.identity.length === 12) {
        this.searchAutofillCustomer(this.state.identity, AUTOFILL_PRS);
      }
    });
  }
  handleIDTypeChange = (e, { value }) => {
    const { auth } = this.props;
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const identity = this.state.identity;
    const { customerAdd, identityPresets } = this.state;
    // Switching from CCCD to a one-image type unmounts the back upload but leaves its file in
    // state. Clear it here as well, so the control and the state agree.
    if (idDocumentSides(value, isCountryVietnam(auth && auth.company && auth.company.countryCode)) === 1 &&
      this.state.icBackAddCustomer) {
      this.setState({ icBackAddCustomer: null });
      if (this.icBackUploadAddCustomer) this.icBackUploadAddCustomer.resetFiles();
    }
    if (value === IDENTITY_TYPE_BRN) {
      customerAdd.title = 'Not Applicable';
      customerAdd.nationality = 'Not Applicable';
      customerAdd.gender = 'Not Applicable';
      customerAdd.race = 'Not Applicable';
      customerAdd.bumi = 'Not Applicable';
      customerAdd.maritalStatus = 'Not Applicable';
      customerAdd.birthdate = '';
    }
    if (this.state.identity.length === 0) {
      customerAdd.customerDetailID = null;
      customerAdd.customerID = null;
    }
    let newPresetID = '';
    let newPresetLabel = '';
    let newPresetRegex = '';
    if (value === 6 || !isNumeric(value)) {
      if (identityPresets && identityPresets.length > 0) {
        const idx = identityPresets.findIndex(i => i.id === value);
        if (idx !== -1) {
          newPresetID = identityPresets[idx].id;
          newPresetLabel = identityPresets[idx].label;
          newPresetRegex = identityPresets[idx].regex;
        }
      }
    }
    if (isMalaysia) {
      customerAdd.customer.isForeignCompany = false;
      customerAdd.customer.taxIdentificationNo = getAutoFillTin(value, customerAdd.customer.isForeignCompany);
    }
    this.setState({
      customerAdd,
      identity,
      identityType: value,
      identityPresetID: newPresetID,
      identityPresetLabel: newPresetLabel,
      identityPresetRegex: newPresetRegex,
      autofillOptions: [],
      showNoAutofill: false,
      tinAddError: false,
      tinAddFound: false,
      tinMessage: null,
    }, () => {
      if (this.validation.identity && this.validation.identity.current && identity !== '') {
        this.validation.identity.current.validate(identity);
      }
      if (this.validation.preferredName && this.validation.preferredName.current && customerAdd.preferredName !== '') {
        this.validation.preferredName.current.validate(customerAdd.preferredName);
      }
      // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
      if (this.validation.name && this.validation.name.current && customerAdd.name !== '') {
        this.validation.name.current.validate(customerAdd.name);
      }
      if (value === 1 && identity.length === 12) {
        if (!this.state.searchingID) {
          this.searchAutofillCustomer(this.state.identity, this.getAutofillIdentityTypeName(this.state.identityType));
        }
      } else if (value !== 1 && identity.length > 0) {
        clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          if (this.state.identityLock &&
            (this.state.autofillOptions && this.state.autofillOptions.length > 0)
          ) {
            const { existingCustomer } = this.state;
            this.setState({ identity: existingCustomer.identity });
          } else {
            this.searchAutofillCustomer(identity, this.getAutofillIdentityTypeName(this.state.identityType), this.state.newPresetID);
          }
        }, 1000);
      }
      this.handleCheckChanges('customerAddChanges');
    });
  }
  handleCustomerAddSelectChange = (event, data) => {
    if (isPRS) return;
    const { customerAdd, isCRMEnabled } = this.state;
    customerAdd[data.name] = data.value;
    normalizeMobileFields(customerAdd, this.state.phoneValidationPresets);
    this.setState({ customerAdd }, () => {
      if (data.name === 'mobilePrefix') {
        this.validation.mobile.current.validate(customerAdd.mobile);
        if (isCRMEnabled && customerAdd.mobile !== '') {
          const msisdn = data.value + customerAdd.mobile;
          clearTimeout(this.setTimer);
          this.setTimer = setTimeout(() => {
            if (!this.state.mobileLock && (!this.state.autofillOptions || this.state.autofillOptions.length === 0)) {
              this.searchAutofillCustomer(msisdn, AUTOFILL_MSISDN);
            }
          }, 1000);
        }
      }
      if (data.name === 'phonePrefix') {
        this.validation.phone.current.validate(customerAdd.phone);
      }
      this.handleCheckChanges('customerAddChanges');
    });
  }
  handleCustomerAddSelectHimsDistrict = (himsDistrict) => {
    const { customerAdd } = this.state;
    customerAdd.himsKodDaerah = himsDistrict ? himsDistrict.value : '';

    this.setState({ customerAdd }, () => {
      this.handleCheckChanges('customerAddChanges');
    });
  }
  handleCustomerAddSelectHimsPostcode = (himsPostcode) => {
    const { customerAdd } = this.state;
    const { addressSettings } = this.props;

    customerAdd.himsKodPoskod = himsPostcode ? himsPostcode.value : '';
    customerAdd.himsKodBandar = himsPostcode ? himsPostcode.kod_bandar_id : '';
    customerAdd.himsKodNegeri = himsPostcode ? himsPostcode.kod_negeri_id : '';

    // update postcode, city and state as well based on the HIMS postcode
    const enabledAddressSettings = addressSettings.data.filter(as => as.enabled);
    const addressFields = enabledAddressSettings.reduce((acc, as) => {
      const labelKey = as.label.toLowerCase();
      return {
        ...acc,
        ...(labelKey === 'postcode' && { postcode: as }),
        ...(labelKey === 'city' && { city: as }),
        ...(labelKey === 'state' && { state: as }),
      };
    }, {});

    if (addressFields.postcode && addressFields.postcode.columnName !== '') {
      const key = _.camelCase(addressFields.postcode.columnName);
      customerAdd[key] = himsPostcode ? himsPostcode.text : '';
    }

    if (addressFields.city && addressFields.city.columnName !== '') {
      const key = _.camelCase(addressFields.city.columnName);
      customerAdd[key] = himsPostcode ? himsPostcode.bandar : '';
    }

    if (addressFields.state && addressFields.state.columnName !== '') {
      const key = _.camelCase(addressFields.state.columnName);
      const himsState = himsPostcode ? himsPostcode.kod_negeri_id : '';
      const srState = STATES.find(s => s.kod_negeri_id === himsState);
      customerAdd[key] = srState ? srState.value : '';
    }

    this.setState({ customerAdd }, () => {
      this.handleCheckChanges('customerAddChanges');
    });
  }
  handleCustomerAddInputChange = (event) => {
    if (isPRS) return;
    const { customerAdd, isCRMEnabled } = this.state;
    customerAdd[event.target.name] = event.target.name.toLowerCase().includes('email') ? event.target.value : this.toUppercaseFormat(event.target.value);
    normalizeMobileFields(customerAdd, this.state.phoneValidationPresets);
    const hasMobileChanges = event && event.target && event.target.name === 'mobile';
    this.setState({ customerAdd }, () => {
      if (isCRMEnabled && hasMobileChanges && customerAdd.mobilePrefix !== '' && customerAdd.mobile !== '') {
        const msisdn = customerAdd.mobilePrefix + customerAdd.mobile;
        clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          if (!this.state.mobileLock && (!this.state.autofillOptions || this.state.autofillOptions.length === 0)) {
            this.searchAutofillCustomer(msisdn, AUTOFILL_MSISDN);
          }
        }, 1000);
      }
      this.handleCheckChanges('customerAddChanges');
    });
  }
  handleCloseCustomerAddArea = async (e) => {
    e.preventDefault();
    await this.resetCustomerAddDocumentState();
    await this.setComponentState({
      customerAdd: Object.assign({}, this.state.bookingCustomerDefaultData),
      customerAddArea: false,
      customerAddChanges: false,
      addCustomerICChanges: false,
      autofillOptions: [],
      identity: '',
      identityType: isPRS ? 1 : '',
      identityLock: false,
      mobileLock: false,
      existingCustomer: {},
    });
    this.handleOnCheck();
  }
  handleOpenCustomerAddArea = async (e) => {
    e.preventDefault();
    await this.resetCustomerAddDocumentState();
    this.handleResetCheck('addCustomerICChanges');
    const { existingLeadCustomer } = this.state;
    let { customerAdd, identityType, identity } = this.state;
    if (existingLeadCustomer) {
      if (existingLeadCustomer.identity) {
        identity = existingLeadCustomer.identity.trim();
      }
      if (existingLeadCustomer.identityTypeID) {
        identityType = existingLeadCustomer.identityTypeID;
      }
      // autofill lead opportunity 2nd purchaser
      customerAdd = Object.assign(customerAdd, existingLeadCustomer.customerDetail);
      customerAdd.leadCustomerID = existingLeadCustomer.leadCustomerID;
      customerAdd.race = this.getRace(existingLeadCustomer.customerDetail.race);
      customerAdd.raceOther = customerAdd.race === 'Others' ? existingLeadCustomer.customerDetail.race : '';
      customerAdd.customerDetailID = existingLeadCustomer.customerDetailID;
      customerAdd.customerID = existingLeadCustomer.id;
      customerAdd.identity = existingLeadCustomer.identity.trim();
      customerAdd.identityTypeID = existingLeadCustomer.identityTypeID;
      customerAdd.birthdate = this.getBirthDate(existingLeadCustomer.customerDetail.birthdate, identityType === 1 ? identity : '');
      customerAdd.customerSpecification = existingLeadCustomer.specifications;
      if (existingLeadCustomer.icFrontDocument && existingLeadCustomer.icFrontDocument.key) {
        customerAdd.leadICFrontURL = existingLeadCustomer.icFrontDocument.key;
      }
      if (existingLeadCustomer.icBackDocument && existingLeadCustomer.icBackDocument.key) {
        customerAdd.leadICBackURL = existingLeadCustomer.icBackDocument.key;
      }
      customerAdd.maritalStatus = this.getMaritalStatus(existingLeadCustomer.customerDetail.maritalStatus);
    }
    this.setState({
      identityType,
      identity,
      customerAdd,
      customerAddArea: true,
    }, () => {
      // Scroll
      const body = document.getElementsByTagName('body')[0];
      const customerAddGrid = document.getElementsByClassName('customer add');
      if (customerAddGrid.length > 0) {
        window.scrollTo(0, body.scrollHeight - customerAddGrid[0].scrollHeight - 190);
      }
    });
  }
  handleEditCustomer = (data) => {
    const editingCustomer = Object.assign({}, this.state.bookingCustomerDefaultData, data);
    editingCustomer.race = this.getRace(data.race);
    editingCustomer.raceOther = editingCustomer.race === 'Others' ? data.race : '';
    editingCustomer.maritalStatus = this.getMaritalStatus(editingCustomer.maritalStatus);
    editingCustomer.identityTypeID = data.customer.identityTypeID;
    editingCustomer.himsKodPoskod = editingCustomer.himsKodPoskod || editingCustomer.postcode;
    this.setState({
      isEditingCustomer: data.customerID,
      editingCustomer,
      customerAddArea: false,
    });
  }

  handleCustomerSelectChange = (event, data) => {
    if (isPRS) return;
    const { editingCustomer } = this.state;
    editingCustomer[data.name] = data.value;
    normalizeMobileFields(editingCustomer, this.state.phoneValidationPresets);
    this.setState({ editingCustomer }, () => {
      if (data.name === 'mobilePrefix') {
        this.validation.mobile.current.validate(editingCustomer.mobile);
      }
      if (data.name === 'phonePrefix') {
        this.validation.phone.current.validate(editingCustomer.phone);
      }
      // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
      if (data.name === 'identityTypeID') {
        if (this.validation.name && this.validation.name.current && editingCustomer.name) {
          this.validation.name.current.validate(editingCustomer.name);
        }
        if (this.validation.preferredName && this.validation.preferredName.current && editingCustomer.preferredName) {
          this.validation.preferredName.current.validate(editingCustomer.preferredName);
        }
      }
      this.handleCheckChanges('customerChanges');
    });
  }
  handleCustomerSelectHimsDistrict = (himsDistrict) => {
    const { editingCustomer } = this.state;
    editingCustomer.himsKodDaerah = himsDistrict ? himsDistrict.value : '';

    this.setState({ editingCustomer }, () => {
      this.handleCheckChanges('customerChanges');
    });
  }
  handleCustomerSelectHimsPostcode = (himsPostcode) => {
    const { editingCustomer } = this.state;
    const { addressSettings } = this.props;

    editingCustomer.himsKodPoskod = himsPostcode ? himsPostcode.value : '';
    editingCustomer.himsKodBandar = himsPostcode ? himsPostcode.kod_bandar_id : '';
    editingCustomer.himsKodNegeri = himsPostcode ? himsPostcode.kod_negeri_id : '';

    // update postcode, city and state as well based on the HIMS postcode
    const enabledAddressSettings = addressSettings.data.filter(as => as.enabled);
    const addressFields = enabledAddressSettings.reduce((acc, as) => {
      const labelKey = as.label.toLowerCase();
      return {
        ...acc,
        ...(labelKey === 'postcode' && { postcode: as }),
        ...(labelKey === 'city' && { city: as }),
        ...(labelKey === 'state' && { state: as }),
      };
    }, {});
    if (addressFields.postcode && addressFields.postcode.columnName !== '') {
      const key = _.camelCase(addressFields.postcode.columnName);
      editingCustomer[key] = himsPostcode ? himsPostcode.value : '';
    }

    if (addressFields.city && addressFields.city.columnName !== '') {
      const key = _.camelCase(addressFields.city.columnName);
      editingCustomer[key] = himsPostcode ? himsPostcode.bandar : '';
    }

    if (addressFields.state && addressFields.state.columnName !== '') {
      const himsState = himsPostcode ? himsPostcode.kod_negeri_id : '';
      const srState = STATES.find(s => s.kod_negeri_id === himsState);
      const key = _.camelCase(addressFields.state.columnName);
      editingCustomer[key] = srState ? srState.value : '';
    }

    this.setState({ editingCustomer }, () => {
      this.handleCheckChanges('customerChanges');
    });
  }
  handleCustomerInputChange = (event) => {
    if (isPRS) return;
    const { editingCustomer } = this.state;
    editingCustomer[event.target.name] = event.target.name.toLowerCase().includes('email') ? event.target.value : this.toUppercaseFormat(event.target.value);
    normalizeMobileFields(editingCustomer, this.state.phoneValidationPresets);
    this.setState({ editingCustomer }, () => {
      this.handleCheckChanges('customerChanges');
    });
  }
  handleTinInput = (e, target) => {
    const customerObj = clone(this.state[target]);
    const { auth } = this.props;
    const isIndonesia = auth && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      customerObj.customer.taxIdentificationNo = e.target.value;
      this.setState({ [target]: customerObj }, () => {
        this.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
      });
      return;
    }

    const tinInput = this.toUppercaseFormat(e.target.value);
    const tinFound = e.target.tinFound;
    const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);
    const tinErrField = target === 'customerAdd' ? 'tinErrorAdd' : 'tinErrorEdit';
    const tinFoundField = target === 'customerAdd' ? 'tinAddFound' : 'tinEditFound';

    if (tinInput === '') {
      customerObj.customer.taxIdentificationNo = '';
      this.setState({ [target]: customerObj, [tinErrField]: false, [tinFoundField]: false, tinMessage: null });
      return;
    }

    if (isAlphanumeric) {
      customerObj.customer.taxIdentificationNo = tinInput;
      this.setState({ [target]: customerObj, [tinErrField]: tinFound === false, [tinFoundField]: tinFound, tinMessage: tinFound ? null : this.state.tinMessage }, () => {
        this.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
      });

      if (tinFound) {
        this.setState({
          [tinErrField]: false,
          [tinFoundField]: true,
          tinMessage: null,
        });
        return;
      }

      const matched = REGEX_TIN_VALID.test(tinInput);
      const customerID = target === 'editingCustomer' ? customerObj.customer.id : null;
      const bookingID = this.state.data.id;
      const identityTypeID = target === 'customerAdd' ? this.state.identityType : customerObj.customer.identityTypeID;
      const identityValue = target === 'customerAdd' ? this.state.identity : customerObj.customer.identity;
      const isForeignCompanyValue = customerObj.customer.isForeignCompany;
      const genericTin = getGenericTinByIdTypeAndTinNo(identityTypeID, tinInput, isForeignCompanyValue);

      this.setLoading(true, 'validatingTIN');
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout);

      this.debounceTimeout = setTimeout(() => {
        if (matched) {
          if (tinInput === GOVERNMENT_GENERIC_TIN) {
            const isForeign = !isForeignIdType(identityTypeID, identityTypeID === IDENTITY_TYPE_BRN && isForeignCompanyValue);
            this.setState({
              [tinErrField]: !isForeign,
              tinAddFound: target === 'customerAdd' ? !isForeign : null,
              tinEditFound: target === 'editingCustomer' ? !isForeign : null,
              tinMessage: !isForeign ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
            () => {
              this.setLoading(false, 'validatingTIN');
            });
          } else if (GENERIC_TIN_VALUES.includes(tinInput)) {
            this.setState({
              [tinErrField]: !isGenericTinFound(genericTin),
              tinAddFound: target === 'customerAdd' ? isGenericTinFound(genericTin) : null,
              tinEditFound: target === 'editingCustomer' ? isGenericTinFound(genericTin) : null,
              tinMessage: !isGenericTinFound(genericTin) ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
            () => {
              this.setLoading(false, 'validatingTIN');
            });
          } else {
            this.validateTIN(tinInput, identityTypeID, identityValue, tinErrField, customerID, bookingID, target).finally(() => {
              this.setLoading(false, 'validatingTIN');
            });
          }
        } else {
          this.setState({ [tinErrField]: true }, () => {
            this.setLoading(false, 'validatingTIN');
          });
        }
      }, 3000);
    }
  }

  async validateTIN(tinInput, identityTypeID, identity, tinErrField, customerID, bookingID, target) {
    if (!tinInput || !identityTypeID || !identity) {
      return;
    }
    const idType = getIdentityTypeOpts().find(i => i.value === identityTypeID).tin_code;
    const query = Object.assign({
      tin: tinInput,
      idType,
      idValue: identity,
      customerID,
      bookingID,
    });
    const { store } = this.context;
    try {
      const res = await store.dispatch(fetchM(`/tin/validate/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
          'X-Origin': this.state.origin,
        },
      }));

      if (res && res.ok) {
        if (target === 'customerAdd') {
          this.setState({
            [tinErrField]: false,
            tinAddFound: true,
            tinMessage: null,
          });
        } else if (target === 'editingCustomer') {
          this.setState({
            [tinErrField]: false,
            tinEditFound: true,
            tinMessage: null,
          });
        }
      } else {
        const errorMessage = await res.text();
        if (target === 'customerAdd') {
          this.setState({
            [tinErrField]: true,
            tinAddFound: false,
            tinMessage: errorMessage,
          });
        } else if (target === 'editingCustomer') {
          this.setState({
            [tinErrField]: true,
            tinEditFound: false,
            tinMessage: errorMessage,
          });
        }
        return;
      }
    } catch (err) {
      if (err.res) {
        const errorMessage = await err.res.text();
        if (target === 'customerAdd') {
          this.setState({
            [tinErrField]: true,
            tinAddFound: false,
            tinMessage: errorMessage,
          });
        } else if (target === 'editingCustomer') {
          this.setState({
            [tinErrField]: true,
            tinEditFound: false,
            tinMessage: errorMessage,
          });
        }
      }
    }
  }
  handleSubmitCustomer = (event) => {
    event.preventDefault();
    const { data } = this.state;
    if (this.isBULeaderRestrictedEdit(data)) {
      this.setState({ showSoldConfirmation: true });
    } else {
      this.updateBookingCustomer();
    }
  }
  handleConfirmSoldUpdate = () => {
    this.setState({ showSoldConfirmation: false }, () => {
      this.updateBookingCustomer();
    });
  }
  handleCancelSoldUpdate = () => {
    this.setState({ showSoldConfirmation: false });
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.submitCustomer();
  }
  hasResetIdentityIcon = () => {
    if (!this.state.searchingID &&
      this.state.identity !== '' &&
      this.state.identityLock) {
      return true;
    }
    return false;
  }
  hasResetMobileIcon = (mobile) => {
    if (!this.state.searchingIDByMobile &&
      mobile !== '' &&
      this.state.mobileLock) {
      return true;
    }
    return false;
  }
  handleResetAutofill = () => {
    const customerAdd = Object.assign({}, this.state.bookingCustomerDefaultData);
    customerAdd.customer.taxIdentificationNo = '';
    customerAdd.customerDetailID = null;
    customerAdd.customerID = null;
    this.setState({
      customerAdd,
      autofillOptions: [],
      existingCustomer: {},
      externalCustomer: {},
      leadCustomer: {},
      identity: '',
      identityLock: false,
      mobileLock: false,
      prsID: '',
    }, () => {
      if (this.identityInputRef.current) {
        this.identityInputRef.current.focus();
      }
    });
  }
  handleBookingStatusChange = (event, value) => {
    const { data, oriData } = this.state;
    data[value.name] = value.value;
    if (data[value.name] !== oriData[value.name]) {
      this.setState({ data, bookingStatusModal: true });
    }
  }
  handleNotesChange = (bnEncoded) => {
    const { data } = this.state;
    data.newBookingNoteEncoded = bnEncoded;
    data.remarkInternal = '';
    this.setState({ data });
  }
  handleCheckboxChange = (event, { checked }) => {
    const { data } = this.state;
    data.isCancelPending = checked;
    this.setState({ data });
  }
  handleConfirmBookingStatus = () => {
    const { data } = this.state;
    const booking = {
      statusID: data.statusID,
      newBookingNoteEncoded: data.newBookingNoteEncoded,
    };
    if (data.statusID === 'sold_spa_signed' || data.statusID === 'cancelled_developer') {
      booking.isCancelPending = data.isCancelPending;
    }
    this.setState({ bookingStatusModal: false }, () => {
      this.updateBooking(booking, 'update');
    });
  }
  handleCancelBookingStatus = () => {
    const { data, oriData } = this.state;
    data.statusID = oriData.statusID;
    data.remarkInternal = oriData.remarkInternal;
    this.setState({ data, bookingStatusModal: false });
  }
  handleBirthdateSelectAdd = (day) => {
    const { customerAdd } = this.state;
    customerAdd.birthdate = day;
    this.setState({ customerAdd }, () => {
      this.handleCheckChanges('customerAddChanges');
    });
  }
  handleBirthdateSelectEdit = (day) => {
    const { editingCustomer } = this.state;
    editingCustomer.birthdate = day;
    this.setState({ editingCustomer }, () => {
      this.handleCheckChanges('customerChanges');
    });
  }
  handleOpenHTML = (e, data, isBuyer = false) => {
    const { customer } = data;
    e.preventDefault();
    if (isBuyer || (customer && (customer.icFrontDocumentID || customer.icBackDocumentID))) {
      let url = `${config.get('bookApiURL')}/bookings/${data.bookingID}/customers/${customer.id}/identity/`;
      if (isBuyer) {
        url += '?isBuyer=true';
      }
      window.open(url, `identity-${customer.id}`, '');
    }
  }
  // CPI-1332: in a Vietnamese isolated-purchaser booking, book-api says per purchaser whether they
  // are linked to a CRM Customer. A linked purchaser shows that customer's current identity
  // pictures; an unlinked one keeps Showroom's own. While the answer is pending, or when it failed,
  // no picture is shown, so an older Showroom picture never stands in for the current one.
  crmIdentityApplies = () => {
    const { auth } = this.props;
    const { data } = this.state;
    return isCountryVietnam(auth && auth.company && auth.company.countryCode) && !!data && !!data.purchasersIsolated;
  }
  crmIdentityOf = (customerID) => {
    if (!this.crmIdentityApplies()) return { source: 'local' };
    const info = this.state.crmIdentities[customerID];
    if (!info || info.status === 'error') return { source: 'pending', failed: !!info };
    return { source: info.status === 'shared' ? 'shared' : 'local', info };
  }
  revokeCRMIdentityImages = (crmIdentities) => {
    Object.values(crmIdentities).forEach(info => Object.values((info && info.images) || {}).forEach(url => URL.revokeObjectURL(url)));
  }
  fetchCRMIdentities = async () => {
    this.crmIdentityLoad = (this.crmIdentityLoad || 0) + 1;
    const load = this.crmIdentityLoad;
    const { data } = this.state;
    const { store } = this.context;
    const customers = this.crmIdentityApplies() && data.id ? (data.bookingCustomers || []) : [];
    if (customers.length === 0 && _.isEmpty(this.state.crmIdentities)) return;
    // ignoreNotFound / ignoreForbidden: a failed lookup is shown on the card, not by leaving the page.
    const options = { credentials: 'include', method: 'GET', ignoreNotFound: true, ignoreForbidden: true };
    const answers = await Promise.all(customers.map(async ({ customerID }) => {
      const path = `/bookings/${data.id}/customers/${customerID}/crm_identity/`;
      try {
        const res = await store.dispatch(fetchM(path, options));
        const info = { ...(await res.json()), images: {} };
        const sides = ['front', 'back'].filter(side => info.status === 'shared' && info[side] && info[side].available);
        await Promise.all(sides.map(async (side) => {
          const image = await store.dispatch(fetchM(`${path}${side}/?v=${encodeURIComponent(info[side].version || '')}`, { ...options, cache: 'no-store' }));
          if (!image.ok) throw new Error(`CRM identity ${side} could not be loaded`);
          info.images[side] = URL.createObjectURL(await image.blob());
        }));
        return [customerID, info];
      } catch (err) {
        return [customerID, { status: 'error' }];
      }
    }));
    const crmIdentities = _.fromPairs(answers);
    if (load !== this.crmIdentityLoad) {
      this.revokeCRMIdentityImages(crmIdentities);
      return;
    }
    this.revokeCRMIdentityImages(this.state.crmIdentities);
    await this.setComponentState({ crmIdentities });
  }
  // CPI-1426: in a Vietnamese isolated-purchaser booking every identity upload must be an image,
  // linked or not, and also while the link is still unknown. A linked purchaser's replaces the CRM
  // Customer's picture (book-api refuses a PDF); an unlinked one's is copied there later, which
  // skips a PDF.
  identityAcceptProps = () => (this.crmIdentityApplies() ? { accept: VN_IDENTITY_ACCEPT } : {})
  // The picture an edit form starts from.
  identityPictureProps = (bookingCustomer, side) => {
    const { customer } = bookingCustomer;
    const { source, info } = this.crmIdentityOf(bookingCustomer.customerID);
    if (source === 'shared') {
      const src = info.images[side] || '';
      return { picture: src ? { name: info[side].name || '' } : null, pictureSrc: src, ...this.identityAcceptProps() };
    }
    const documentID = source === 'local' && customer && (side === 'front' ? customer.icFrontDocumentID : customer.icBackDocumentID);
    return {
      picture: documentID && documentID.length > 0 ? customer[side === 'front' ? 'icFrontDocument' : 'icBackDocument'] : null,
      ...this.identityAcceptProps(),
    };
  }
  identityDocumentComplete = (bookingCustomer, isVietnam) => {
    const { source, info } = this.crmIdentityOf(bookingCustomer.customerID);
    if (source === 'shared') {
      return !!info.images.front && (idDocumentSides(bookingCustomer.customer.identityTypeID, isVietnam) === 1 || !!info.images.back);
    }
    return source === 'local' && idDocumentComplete(bookingCustomer.customer, isVietnam);
  }
  handleOnChangeLPPSA = (customerData, idx = 0) => {
    const { data } = this.state;
    data.bookingCustomers[idx].customer = customerData;
    this.setState({ data }, () => {
      this.updateLPPSA(customerData);
    });
  }
  handleCancelEditCustomer = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const callback = () => {
      this.setState({
        errMessages: [],
        isEditingCustomer: 0,
        editingCustomer: Object.assign(
          {}, this.state.bookingCustomerDefaultData,
        ),
      }, () => {
        this.handleResetCheck('customerChanges');
      });
    };
    if (this.props.checkHasChanges()) {
      store.dispatch(promptChangesMessage({ message: CANCEL_PROMPT, samePage: true, callback }));
    } else {
      callback();
    }
  }
  handleCopyAddressFromPrimaryPurchaser = (e) => {
    e.preventDefault();
    const { data, customerAdd } = this.state;
    const primaryCustomer = this.getPrimaryBookingCustomer(data);
    customerAdd.address1 = primaryCustomer.address1;
    customerAdd.address2 = primaryCustomer.address2;
    customerAdd.address3 = primaryCustomer.address3;
    customerAdd.address4 = primaryCustomer.address4;
    customerAdd.address5 = primaryCustomer.address5;
    customerAdd.address6 = primaryCustomer.address6;
    customerAdd.address7 = primaryCustomer.address7;
    customerAdd.address8 = primaryCustomer.address8;
    customerAdd.address9 = primaryCustomer.address9;
    customerAdd.address10 = primaryCustomer.address10;
    customerAdd.country = primaryCustomer.country;

    // copy hims field as well
    customerAdd.himsKodPoskod = primaryCustomer.himsKodPoskod;
    customerAdd.himsKodBandar = primaryCustomer.himsKodBandar;
    customerAdd.himsKodDaerah = primaryCustomer.himsKodDaerah;
    customerAdd.himsKodNegeri = primaryCustomer.himsKodNegeri;
    customerAdd.himsKodNegara = primaryCustomer.himsKodNegara;

    this.setState({ customerAdd });
  }
  saveSignature = async (event, customerData) => {
    event.preventDefault();
    const { store } = this.context;
    const { t } = this.props;
    if (this.signatureModal.isEmpty()) {
      store.dispatch(flashErrorMessage({ header: t('Error', { ns: TRANSLATION_FILES.translation }), message: t('Please sign the consent', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    const bookingCustomer = Object.assign({}, this.state.bookingCustomerDefaultData, customerData);
    const signature = this.signatureModal.signData().replace(/^data:image\/(png|jpg);base64,/, '');
    this.updateBookingCustomerSignature(bookingCustomer.bookingID, bookingCustomer.customerID, signature);
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  sortPrimaryCustomer = (x, y) => {
    if (x.customerID === this.state.data.customerID) return -1;
    if (y.customerID === this.state.data.customerID) return 1;
    return 0;
  }
  formatAutofill = (customer) => {
    const purchaserInputFields = [
      'name',
      'preferredName',
      'jobTitle',
      'emergencyContactName',
      'emergencyContactRelation',
      'emergencyContactIdentity',
      'identity',
      'taxIdentificationNo',
    ];
    const { addressSettings } = this.props;
    const enabledAddressSettings = addressSettings.data.filter(as => as.enabled);
    enabledAddressSettings.forEach((as) => {
      const key = _.camelCase(as.columnName);
      const label = as.label.toLowerCase();
      if (label !== 'postcode' && label !== 'state') {
        purchaserInputFields.push(key);
      }
    });
    const formattedCustomer = { ...customer };
    purchaserInputFields.forEach((pf) => {
      if (formattedCustomer[pf]) {
        formattedCustomer[pf] = this.toUppercaseFormat(formattedCustomer[pf]);
      }
    });
    return formattedCustomer;
  }
  replaceWithAutofill = (type, field = 'identity') => {
    const { externalCustomer, existingCustomer, leadCustomer, identityPresets } = this.state;
    const { auth } = this.props;
    let customerAdd = this.state.customerAdd;
    const isMalaysia = auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    if (type === 'existing') {
      customerAdd = Object.assign(this.state.customerAdd, existingCustomer.customerDetail);
      customerAdd.race = this.getRace(existingCustomer.customerDetail.race);
      customerAdd.raceOther = customerAdd.race === 'Others' ? existingCustomer.customerDetail.race : '';
      customerAdd.customerDetailID = existingCustomer.customerDetailID;
      customerAdd.customerID = existingCustomer.id;
      customerAdd.identity = existingCustomer.identity.trim();
      customerAdd.identityTypeID = existingCustomer.identityTypeID;
      customerAdd.identityPresetID = existingCustomer.identityPresetID;
      customerAdd.identityPresetLabel = existingCustomer.identityPresetLabel;
      customerAdd.identityPresetRegex = existingCustomer.identityPresetRegex;
      if (existingCustomer.taxIdentificationNo) {
        customerAdd.customer.taxIdentificationNo = existingCustomer.taxIdentificationNo;
      }
      customerAdd.birthdate = this.getBirthDate(existingCustomer.customerDetail.birthdate, this.state.identityType === 1 ? this.state.identity : '');
      customerAdd.customerSpecification = existingCustomer.specifications;
      customerAdd.maritalStatus = this.getMaritalStatus(existingCustomer.customerDetail.maritalStatus);
    }
    if (type === 'external') {
      customerAdd = Object.assign(this.state.customerAdd, externalCustomer.customerDetail);
      customerAdd.identity = externalCustomer.identity.trim();
      customerAdd.identityTypeID = externalCustomer.identityTypeID;
    }
    if (type === 'lead') {
      const customer = leadCustomer.customer;
      customerAdd = Object.assign(this.state.customerAdd, customer.customerDetail);
      customerAdd.leadCustomerID = leadCustomer.id;
      customerAdd.race = this.getRace(customer.customerDetail.race);
      customerAdd.raceOther = customerAdd.race === 'Others' ? customer.customerDetail.race : '';
      customerAdd.identity = customer.identity.trim();
      customerAdd.identityTypeID = customer.identityTypeID;
      customerAdd.identityPresetID = this.state.identityPresetID;
      customerAdd.identityPresetLabel = this.state.identityPresetLabel;
      customerAdd.identityPresetRegex = this.state.identityPresetRegex;
      if (isMalaysia) {
        customerAdd.customer.taxIdentificationNo = leadCustomer.contacts[0].tin || '';
      } else if (isIndonesia) {
        customerAdd.customer.taxIdentificationNo = leadCustomer.contacts[0].npwp || '';
        if (leadCustomer.details.ktp) {
          const matched = identityPresets.find(i => i.label === 'Kartu Tanda Penduduk');
          if (matched) {
            customerAdd.identityTypeID = matched.id;
            customerAdd.identityPresetID = matched.id;
            customerAdd.identityPresetLabel = matched.label;
            customerAdd.identityPresetRegex = matched.regex;
          }
        }
      }
      customerAdd.birthdate = this.getBirthDate(customer.customerDetail.birthdate, this.state.identityType === 1 ? this.state.identity : '');
      customerAdd.customerSpecification = customer.specifications;
      customerAdd.jobTitle = leadCustomer.details && leadCustomer.details.occupation ? leadCustomer.details.occupation : '';
      customerAdd.address1 = leadCustomer.details && leadCustomer.details.address_1 ? leadCustomer.details.address_1 : '';
      customerAdd.address2 = leadCustomer.details && leadCustomer.details.address_2 ? leadCustomer.details.address_2 : '';
      customerAdd.maritalStatus = this.getMaritalStatus(customer.customerDetail.maritalStatus);
      if (customer.icFrontDocument && customer.icFrontDocument.key) {
        customerAdd.leadICFrontURL = customer.icFrontDocument.key;
      }
      if (customer.icBackDocument && customer.icBackDocument.key) {
        customerAdd.leadICBackURL = customer.icBackDocument.key;
      }
    }
    customerAdd.taxIdentificationNo = customerAdd.customer.taxIdentificationNo;
    this.setState({
      customerAdd: this.formatAutofill(customerAdd),
      identity: customerAdd.identity,
      identityType: customerAdd.identityTypeID,
      identityPresetID: customerAdd.identityPresetID,
      identityPresetLabel: customerAdd.identityPresetLabel,
      identityPresetRegex: customerAdd.identityPresetRegex,
      taxIdentificationNo: customerAdd.customer.taxIdentificationNo,
    }, () => {
      // The identity type rule reads `identityType`, but the autofilled customer only carries
      // `identityTypeID`. Without this the rule saw nothing, painted "Identity Type is required"
      // on a field that was locked a moment later, and nothing ever cleared it. Same shape as
      // submitCustomer, which validates `{ ...customerAdd, identityType }`.
      AppForm.validate(this.validation, { ...customerAdd, identityType: customerAdd.identityTypeID })
        .then((validations) => {
          this.setState({
            errMessages: validations.filter(v => !v.isValid),
            identityLock: field === 'identity',
            mobileLock: field === 'msisdn',
          });
        });
    });
  }
  checkUnitIsSold = data => data && (data.statusID === 'sold_spa_signed')
  isBULeader = () => {
    const { auth } = this.props;
    return auth.isBranchLeaderSupervisor || auth.isBranchLeaderSupervisorII || auth.isBranchLeader;
  }
  isBULeaderRestrictedEdit = (data) => {
    return this.checkUnitIsSold(data) && this.isBULeader() && !this.hasAccess(false, true, true, false, false);
  }
  disableEditAfterSold = data => {
    if (this.checkUnitIsSold(data) && data.project && !data.project.allowPurchaserEditAfterSold) {
      if (this.hasAccess() || this.isBULeader()) {
        return false;
      }
      return true;
    }
    return false;
  }
  checkICIsImage = (customer, type = '') => {
    let isImage = true;
    if (
      (
        !type || type === 'front'
      ) &&
      customer.icFrontDocumentID !== ''
    ) {
      if (customer.icFrontDocument && customer.icFrontDocument.name) {
        // NOTE: this checking will not work if filename don't hav extension
        if (customer.icFrontDocument.name.toLowerCase().includes('.pdf')) isImage = false;
      }
    }
    if (
      (
        !type || type === 'back'
      ) &&
      customer.icBackDocumentID !== ''
    ) {
      if (customer.icBackDocument && customer.icBackDocument.name) {
        // NOTE: this checking will not work if filename don't hav extension
        if (customer.icBackDocument.name.toLowerCase().includes('.pdf')) isImage = false;
      }
    }
    return isImage;
  }
  customerDropdownOptions = (customerData, data, idx) => {
    const { t } = this.props;
    const customerDropdownOptions = [];
    if (
      customerData.customerID !== data.customerID &&
      (this.hasAccess() ||
      this.hasChangePrimaryPurchaserAccess(data.project.allowAgentChangePrimaryPurchaser, data.statusID))
    ) {
      customerDropdownOptions.push({
        key: 'primary',
        icon: 'star',
        text: t('Make Primary'),
        onClick: () => {
          this.handleOpenModal(
            customerData.name,
            customerData.customerID,
            customerData.id,
            data.id,
            'star',
            `${t('Change Primary Purchaser')}?`,
            `${t('{{name}} will be set as primary purchaser', { name: customerData.name })}.`,
            'primary');
        },
      });
    }
    if (!isPRS) customerDropdownOptions.push({ key: 'edit', icon: 'edit', text: t('Edit', { ns: TRANSLATION_FILES.translation }), onClick: () => { this.handleEditCustomer(customerData); } });
    if (customerData.customerID !== data.customerID) {
      customerDropdownOptions.push({
        key: 'remove',
        icon: 'x',
        text: t('Remove'),
        onClick: () => {
          this.handleOpenModal(
            customerData.name,
            customerData.customerID,
            customerData.id,
            data.id,
            'remove',
            `${t('Remove Purchaser')} ${idx + 1}?`,
            `${t('Purchaser {{name}} will be removed', { name: customerData.name })}.`,
            'remove');
        },
      });
    }
    return customerDropdownOptions;
  }
  valueToText = (array, value, returnRaw = false) => {
    const element = array.find(a => a.value === value);
    if (element && element.text) {
      return element.text;
    }
    if (returnRaw) return value;
    return '';
  }
  validateIdentityType = () => {
    const { identityType } = this.state;
    switch (identityType) {
      case 1:
        return 'ic_number';
      case 2:
        return 'passport';
      case 3:
        return 'military_police';
      case 5:
        return 'id_number';
      default:
        return 'other';
    }
  }
  identityValidation = () => {
    const { auth, t } = this.props;
    const { identityType, identityPresetRegex } = this.state;
    if (identityType === 6 || !isNumeric(identityType)) {
      return {
        validRegex: identityPresetRegex,
      };
    }
    // CPI-974: the shared CCCD rule, now the CRM's 12-digit one, with the CRM's wording. It
    // replaces the structured pattern CPI-149 wrote here in March.
    const vn = vnIdentityValidation(auth, identityType, t);
    if (vn) {
      return vn;
    }
    return {
      countryCode: 'MY',
      identityType: this.validateIdentityType(),
    };
  }
  checkAddDataAttributeBCF = (name) => {
    const bdfNames = ['nationality', 'birthdate', 'gender', 'maritalStatus', 'race'];
    if (bdfNames.includes(name)) {
      return true;
    }
    return false;
  };
  checkIsEmailRequired = () => {
    const { projectBookingCustomFields } = this.state;
    const { auth } = this.props;
    // CPI-976: the purchaser's email is always mandatory for Vietnam (G3-D6); MY/ID unchanged.
    if (isCountryVietnam(auth && auth.company && auth.company.countryCode)) return true;
    if (projectBookingCustomFields && projectBookingCustomFields.length > 0 && projectBookingCustomFields.filter(p => p.name === 'email').length > 0) {
      return projectBookingCustomFields.find(p => p.name === 'email').isRequired;
    }
    return false;
  }
  // CPI-976: Citizenship (Vietnam only), stored on the booking customer as 'local' | 'foreigner';
  // "Country of Citizen" reuses `nationality`. A row predating the column derives it from that.
  getCitizenship = (customer) => {
    if (!customer) return '';
    const stored = String(customer.citizenship || '').toLowerCase();
    if (stored === 'local' || stored === 'foreigner') return stored;
    const nationality = String(customer.nationality || '').toLowerCase();
    if (nationality === 'vn') return 'local';
    if (nationality && nationality !== 'not applicable') return 'foreigner';
    return '';
  }
  getCitizenshipOptions = () => {
    const { t } = this.props;
    return [
      { text: t('Local'), value: 'local' },
      { text: t('Foreigner'), value: 'foreigner' },
    ];
  }
  getCountryOfCitizenOptions = () => {
    const { t } = this.props;
    return [
      ...SELECT_COUNTRIES.filter(c => c.value !== 'vn'),
      { text: t('Others'), value: CITIZEN_COUNTRY_OTHERS },
    ];
  }
  getCountryOfCitizenText = (customer) => {
    const { t } = this.props;
    const nationality = customer && customer.nationality;
    if (!nationality) return '';
    if (String(nationality).toUpperCase() === CITIZEN_COUNTRY_OTHERS) return t('Others');
    return getCountryName(String(nationality).toLowerCase()) || nationality;
  }
  handleCitizenshipChange = (target, e, { value }) => {
    if (isPRS) return;
    const customer = this.state[target];
    customer.citizenship = value;
    if (value === 'local') {
      customer.nationality = 'vn';
    } else if (value === 'foreigner') {
      const nationality = String(customer.nationality || '').toLowerCase();
      if (!nationality || nationality === 'vn' || nationality === 'not applicable') {
        customer.nationality = CITIZEN_COUNTRY_OTHERS; // "Others by default"
      }
    }
    this.setState({ [target]: customer }, () => {
      this.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
    });
  }
  handleCountryOfCitizenChange = (target, e, { value }) => {
    if (isPRS) return;
    const customer = this.state[target];
    customer.nationality = value;
    this.setState({ [target]: customer }, () => {
      this.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
    });
  }
  // target = 'editingCustomer' (primary / related purchaser edit form) or 'customerAdd' (add form)
  renderCitizenshipInputs = (target) => {
    const { t, auth } = this.props;
    if (!isCountryVietnam(auth && auth.company && auth.company.countryCode)) return null;
    const customer = this.state[target];
    const citizenship = this.getCitizenship(customer);
    const disabled = target === 'editingCustomer' && this.isBULeaderRestrictedEdit(this.state.data);
    // Related purchaser only: Citizenship | [Country of Citizen] | Relationship Type; else a spacer keeps Citizenship half-width.
    const relationshipTypeSelect = this.renderRelationshipTypeSelect(target);
    return (
      <Form.Group widths="equal">
        <Form.Select
          disabled={disabled}
          label={t('Citizenship')}
          name="citizenship"
          onChange={(e, d) => this.handleCitizenshipChange(target, e, d)}
          options={this.toUppercaseOptions(this.getCitizenshipOptions())}
          placeholder={t('Select {{title}}', { title: t('Citizenship') })}
          selectOnBlur={false}
          value={citizenship}
        />
        {citizenship === 'foreigner' && (
          <Form.Select
            disabled={disabled}
            label={t('Country of Citizen')}
            name="nationality"
            onChange={(e, d) => this.handleCountryOfCitizenChange(target, e, d)}
            options={this.toUppercaseOptions(this.getCountryOfCitizenOptions())}
            placeholder={t('Select {{title}}', { title: t('Country of Citizen') })}
            search
            selectOnBlur={false}
            noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
            value={customer.nationality || ''}
          />
        )}
        {relationshipTypeSelect || (citizenship !== 'foreigner' && <span style={{ flex: '1 1 auto', width: '100%' }} />)}
      </Form.Group>
    );
  }
  // Relationship type of a related purchaser to the primary purchaser (Vietnam only). Stored on
  // the booking customer as relationshipType, prefilled from the CRM related customer's
  // `relationship_type`; the value set is RELATIONSHIP_TYPE (matched case-insensitively).
  getRelationshipType = (customer) => {
    if (!customer || !customer.relationshipType) return '';
    const stored = String(customer.relationshipType).trim().toLowerCase();
    const preset = RELATIONSHIP_TYPE.find(o => o.value.toLowerCase() === stored);
    return preset ? preset.value : '';
  }
  getRelationshipTypeOptions = () => {
    const { t } = this.props;
    return RELATIONSHIP_TYPE.map(o => ({ ...o, text: t(o.text, { ns: TRANSLATION_FILES.constants }) }));
  }
  isRelatedPurchaser = (customer) => {
    const { data } = this.state;
    return !!(customer && data && customer.customerID && customer.customerID !== data.customerID);
  }
  queryAfterDeferredPurchaserSave = (customer) => {
    const query = decodeSearch(this.props.location.search);
    const { data, reviewedDeferredPurchaserIDs } = this.state;
    const { auth } = this.props;
    if (!isCountryVietnam(auth && auth.company && auth.company.countryCode) ||
      query.reviewPurchasers !== '1' || !data.purchasersIsolated || !this.isRelatedPurchaser(customer)) {
      return query;
    }

    // A successful PUT is evidence that this purchaser passed the normal edit-form validation.
    // Keep the reminder while another related purchaser still needs the same validated save.
    const reviewed = [...new Set([...reviewedDeferredPurchaserIDs, customer.customerID])];
    const relatedPurchasers = (data.bookingCustomers || []).filter(c => this.isRelatedPurchaser(c));
    this.setState({ reviewedDeferredPurchaserIDs: reviewed });
    if (relatedPurchasers.length > 0 && relatedPurchasers.every(c => reviewed.includes(c.customerID))) {
      delete query.reviewPurchasers;
    }
    return query;
  }
  handleRelationshipTypeChange = (target, e, { value }) => {
    if (isPRS) return;
    const customer = this.state[target];
    customer.relationshipType = value;
    this.setState({ [target]: customer }, () => {
      this.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
    });
  }
  // Rendered inside the Citizenship row (renderCitizenshipInputs), beside Citizenship. Vietnam only.
  // target = 'editingCustomer' (related purchaser edit form) or 'customerAdd' (add form; always a related purchaser)
  renderRelationshipTypeSelect = (target) => {
    const { t, auth } = this.props;
    if (!isCountryVietnam(auth && auth.company && auth.company.countryCode)) return null;
    const customer = this.state[target];
    if (target === 'editingCustomer' && !this.isRelatedPurchaser(customer)) return null;
    const disabled = target === 'editingCustomer' && this.isBULeaderRestrictedEdit(this.state.data);
    return (
      <Form.Select
        disabled={disabled}
        label={t('Relationship Type')}
        name="relationshipType"
        onChange={(e, d) => this.handleRelationshipTypeChange(target, e, d)}
        options={this.toUppercaseOptions(this.getRelationshipTypeOptions())}
        placeholder={t('Select {{title}}', { title: t('Relationship Type') })}
        selectOnBlur={false}
        value={this.getRelationshipType(customer)}
      />
    );
  }
  renderRelationshipTypeView = (customerData, idx) => {
    const { t, auth } = this.props;
    if (!isCountryVietnam(auth && auth.company && auth.company.countryCode)) return null;
    if (!this.isRelatedPurchaser(customerData)) return null;
    const relationshipType = this.getRelationshipType(customerData);
    const option = this.getRelationshipTypeOptions().find(o => o.value === relationshipType);
    return (
      <Grid.Column mobile={16} tablet={8} computer={8}>
        <Grid>
          <Grid.Column textAlign="left" width={8}>
            <b>{t('Relationship Type')}</b>
          </Grid.Column>
          <Grid.Column textAlign="right" width={8} {...this.getDataAttributes(idx, 'relationshiptype', relationshipType)}>
            {this.toUppercaseFormat(option ? option.text : '-')}
          </Grid.Column>
        </Grid>
        <Divider style={{ margin: '0.5em 0' }} />
      </Grid.Column>
    );
  }
  renderCitizenshipView = (customerData, idx) => {
    const { t, auth } = this.props;
    if (!isCountryVietnam(auth && auth.company && auth.company.countryCode)) return null;
    const citizenship = this.getCitizenship(customerData);
    const isForeigner = citizenship === 'foreigner';
    const country = this.getCountryOfCitizenText(customerData);
    let citizenshipText = '-';
    if (citizenship === 'local') {
      citizenshipText = t('Local');
    } else if (isForeigner) {
      citizenshipText = t('Foreigner', { country: country || 'N/A', ns: TRANSLATION_FILES.translation });
    }
    return (
      <Grid.Column mobile={16} tablet={8} computer={8}>
        <Grid>
          <Grid.Column textAlign="left" width={8}>
            <b>{t('Citizenship')}</b>
          </Grid.Column>
          <Grid.Column textAlign="right" width={8} {...this.getDataAttributes(idx, 'citizenship', citizenship)}>
            {this.toUppercaseFormat(citizenshipText)}
          </Grid.Column>
        </Grid>
        <Divider style={{ margin: '0.5em 0' }} />
        {isForeigner && (
          <React.Fragment>
            <Grid>
              <Grid.Column textAlign="left" width={8}>
                <b>{t('Country of Citizen')}</b>
              </Grid.Column>
              <Grid.Column textAlign="right" width={8} {...this.getDataAttributes(idx, 'nationality', country)}>
                {this.toUppercaseFormat(country || '-')}
              </Grid.Column>
            </Grid>
            <Divider style={{ margin: '0.5em 0' }} />
          </React.Fragment>
        )}
      </Grid.Column>
    );
  }
  updateTinFieldState = () => {
    const { editingCustomer } = this.state;
    let disableTinField = false;
    let tinErrorEdit = true;
    if (editingCustomer && editingCustomer.customer && editingCustomer.customer.taxTinValidationStatus === 'success') {
      disableTinField = true;
      tinErrorEdit = false;
    }
    if (this.state.disableTinField !== disableTinField || this.state.tinErrorEdit !== tinErrorEdit) {
      this.setState({
        disableTinField,
        tinErrorEdit,
      });
    }
  }
  checkIfCompanyBranchAllowedToViewForm = (formAccessibility) => {
    const { auth } = this.props;
    // empty company branch IDs means accessible to all
    if (formAccessibility && (!formAccessibility.companyBranchIDs || formAccessibility.companyBranchIDs.length === 0)) {
      return true;
    }
    if (formAccessibility && formAccessibility.companyBranchIDs && auth.companyBranch && auth.companyBranch.id && formAccessibility.companyBranchIDs.includes(auth.companyBranch.id)) {
      return true;
    }
    return false;
  }

  checkIfBookingStatusAllowedToViewForm = (formAccessibility, booking) => {
    if (booking.statusID === 'expired') {
      return true;
    }
    switch (booking.statusID) {
      case 'reserved':
        return formAccessibility && formAccessibility.isEnabledOnReserved;
      case 'booked':
        return formAccessibility && formAccessibility.isEnabledOnBooked;
      case 'cancelled_developer':
      case 'cancelled_availability':
        return formAccessibility && formAccessibility.isEnabledOnCancelled;
      case 'sold_spa_signed':
        return formAccessibility && formAccessibility.isEnabledOnSold;
      default:
        return false;
    }
  }
  checkIfFormAccessibleToViewForm = (currentPFA, booking) => {
    const { data } = this.state;
    const formAccessibilities = data && data.project && data.project.projectFormAccessibilities ? data.project.projectFormAccessibilities : [];
    const pfaIdx = formAccessibilities.findIndex(fa => fa.templateID === currentPFA.templateID);
    if (pfaIdx !== -1) {
      const selectedPfa = formAccessibilities[pfaIdx];
      const isCompanyBranchAllowedToView = this.checkIfCompanyBranchAllowedToViewForm(selectedPfa);
      const isBookingStatusAllowedToView = this.checkIfBookingStatusAllowedToViewForm(selectedPfa, booking);
      return isCompanyBranchAllowedToView && isBookingStatusAllowedToView;
    }
    return false;
  }
  toUppercaseFormat = (val) => {
    const { appConfig } = this.props;
    const uppercasePurchaserInfoIsEnabled = appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.uppercasePurchaserInfoIsEnabled;
    return uppercasePurchaserInfoIsEnabled && val && typeof val === 'string' ? val.toUpperCase() : val;
  }
  toUppercaseOptions = opts => opts.map(opt => ({
    ...opt,
    text: this.toUppercaseFormat(opt.text),
  }))
  renderDefaultField(field, idx, isEditing, customer, customerIdx, isAddCustomer) {
    const data = field;
    const { t } = this.props;
    const isRestricted = !isAddCustomer && this.isBULeaderRestrictedEdit(this.state.data);
    // MS-6495 use data.label instead of data.name cause purchaser fields labels can be customized in project settings
    const formLabel = `${t(data.label, { ns: TRANSLATION_FILES.models.customer })}`;
    if (data.name === 'emergencyContactMobile') {
      const emergencyContactValidation = [mobileValidation({
        presets: this.state.phoneValidationPresets,
        prefix: customer.emergencyContactMobilePrefix,
        label: formLabel,
        t,
      })];
      if (data.isRequired && !data.isDisabled && !isRestricted) {
        emergencyContactValidation.push(required);
      }
      return (
        <Grid.Column key={idx} width={16}>
          {isEditing ?
            <Form.Group widths="equal">
              <AppForm.Validate
                ref={this.validation.emergencyContactMobilePrefix}
                onChange={isAddCustomer ? this.handleCustomerAddSelectChange : this.handleCustomerSelectChange}
                validateLabel={t('{{label}} Prefix', { label: data.label })}
              >
                <Form.Select
                  disabled={isRestricted}
                  label={t('{{label}} Prefix', { label: data.label })}
                  name="emergencyContactMobilePrefix"
                  onChange={isAddCustomer ? this.handleCustomerAddSelectChange : this.handleCustomerSelectChange}
                  options={this.toUppercaseOptions(INTL_CALL_CODES)}
                  search
                  selectOnBlur={false}
                  value={customer.emergencyContactMobilePrefix}
                  noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                />
              </AppForm.Validate>
              <PhoneInput
                disabled={isRestricted}
                autoComplete="off"
                label={`${formLabel}${data.isRequired ? '*' : ''}`}
                name="emergencyContactMobile"
                onChange={isAddCustomer ? this.handleCustomerAddInputChange : this.handleCustomerInputChange}
                placeholder={formLabel}
                prefix={customer.emergencyContactMobilePrefix}
                ref={this.validation.emergencyContactMobile}
                type="tel"
                validation={emergencyContactValidation}
                value={customer.emergencyContactMobile}
                validateLabel={data.label}
              />
            </Form.Group>
            :
            <div>
              <Grid>
                <Grid.Row>
                  <Grid.Column textAlign="left" width={6}>
                    <b>{formLabel}</b>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={10}>
                    <Phone
                      mobilePrefix={customer.emergencyContactMobilePrefix}
                      mobile={customer.emergencyContactMobile}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider style={{ margin: '0.5em 0' }} />
            </div>
          }
        </Grid.Column>
      );
    }
    if (data.name === 'birthdate') {
      return (
        <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
          {isEditing ?
            <Form.Group widths="equal">
              <InputBirthdate
                date={customer.birthdate}
                onSelectDay={isAddCustomer ? this.handleBirthdateSelectAdd : this.handleBirthdateSelectEdit}
                label={`${formLabel}${data.isRequired ? '*' : ''}`}
                disabled={isRestricted || isPRS || customer.identityTypeID === 4}
              />
            </Form.Group>
            :
            <div>
              <Grid stretched>
                <Grid.Row>
                  <Grid.Column textAlign="left" width={6}>
                    <b>{formLabel}</b>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={10} {...this.getDataAttributes(customerIdx, 'birthdate', customer.birthdate)}>
                    {customer.birthdate || '-'}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider style={{ margin: '0.5em 0' }} />
            </div>
          }
        </Grid.Column>
      );
    }
    if (data.name === 'race') {
      const raceOptions = RACE.map(o => ({
        ...o,
        text: t(o.text, { ns: TRANSLATION_FILES.constants }),
      }));
      let optionText = customer[data.name];
      const option = raceOptions.find(d => d.value === customer[data.name]);
      if (option) {
        optionText = option.text;
      }
      return (
        <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
          {isEditing ?
            <Form.Group widths="equal">
              <AppForm.Validate
                validation={(data.isRequired && !data.isDisabled && !isRestricted) ? [required] : null}
                ref={this.validation.race}
                onChange={(e, d) => (isAddCustomer ? this.handleCustomerAddSelectChange(e, d, raceOptions) : this.handleCustomerSelectChange(e, d, raceOptions))}
                validateLabel={data.label}
              >
                <Form.Select
                  disabled={isRestricted}
                  name="race"
                  fluid
                  options={this.toUppercaseOptions(raceOptions)}
                  placeholder={data.label}
                  label={`${formLabel}${data.isRequired ? '*' : ''}`}
                  search
                  selectOnBlur={false}
                  value={customer[data.name]}
                  noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                />
              </AppForm.Validate>
              <AppForm.Input
                autoComplete="off"
                disabled={isRestricted || customer[data.name].toUpperCase() !== 'Others'.toUpperCase()}
                fluid
                name="raceOther"
                onChange={isAddCustomer ? this.handleCustomerAddInputChange : this.handleCustomerInputChange}
                placeholder={t('Fill in your Race')}
                label={translateModels(t, 'raceOther', 'booking')}
                value={customer.raceOther}
                validateLabel={translateModels(t, 'raceOther', 'booking')}
                ref={this.validation.raceOther}
                validation={customer[data.name].toUpperCase() === 'Others'.toUpperCase() && !isRestricted ? [required] : null}
              />
            </Form.Group>
          :
            <div>
              <Grid stretched>
                <Grid.Row>
                  <Grid.Column textAlign="left" width={6}>
                    <b>{formLabel}</b>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={10} {...this.checkAddDataAttributeBCF(data.name) && this.getDataAttributes(customerIdx, data.name.toLowerCase(), this.valueToText(raceOptions, customer[data.name]))}>
                    <div>{this.toUppercaseFormat(optionText || '-')}</div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider style={{ margin: '0.5em 0' }} />
            </div>
          }
        </Grid.Column>
      );
    }
    if (data.type === 'input') {
      return isEditing ?
        <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
          <Form.Group widths="equal">
            <AppForm.Input
              disabled={isRestricted || data.isDisabled}
              autoComplete="off"
              label={`${formLabel}${data.isRequired ? '*' : ''}`}
              name={data.name}
              onChange={isAddCustomer ? this.handleCustomerAddInputChange : this.handleCustomerInputChange}
              placeholder={data.placeholder}
              ref={this.validation[data.name]}
              validation={(data.isRequired && !data.isDisabled && !isRestricted) ?
              [required, {
                validate: value => checkRegex(value, data),
              }] : [{
                validate: value => checkRegex(value, data),
              }]}
              value={customer[data.name]}
              validateLabel={data.label}
            />
          </Form.Group>
        </Grid.Column>
        :
        <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
          <div>
            <Grid stretched>
              <Grid.Row>
                <Grid.Column textAlign="left" width={6}>
                  <b>{formLabel}</b>
                </Grid.Column>
                <Grid.Column textAlign="right" width={10} className="word_break_word">
                  {data.name !== 'emergencyContactEmail' ? this.toUppercaseFormat(customer[data.name]) : customer[data.name] || '-'}
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Divider style={{ margin: '0.5em 0' }} />
          </div>
        </Grid.Column>;
    }
    if (data.type === 'textarea') {
      return (
        <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
          {isEditing ?
            <Form.Group widths="equal">
              <AppForm.Validate
                validation={(data.isRequired && !data.isDisabled && !isRestricted) ? [required] : null}
                ref={this.validation[data.name]}
                onChange={isAddCustomer ? this.handleCustomerAddInputChange : this.handleCustomerInputChange}
                validateLabel={data.label}
              >
                <Form.TextArea
                  disabled={isRestricted || data.isDisabled}
                  autoComplete="off"
                  label={`${formLabel}${data.isRequired ? '*' : ''}`}
                  name={data.name}
                  placeholder={data.placeholder}
                  ref={this.validation[data.name]}
                  value={customer[data.name]}
                  style={{ minHeight: '6em', height: '6em' }}
                />
              </AppForm.Validate>
            </Form.Group>
            :
            <div>
              <Grid stretched>
                <Grid.Row>
                  <Grid.Column textAlign="left" width={6}>
                    <b>{formLabel}</b>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={10} className="word_break_word">
                    {this.toUppercaseFormat(customer[data.name] || '-')}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider style={{ margin: '0.5em 0' }} />
            </div>
          }
        </Grid.Column>
      );
    }
    if ((data.type === 'dropdown' || data.type === 'dropdown_multi')) {
      const renderLabel = label => ({
        content: label.text,
        circular: true,
      });
      let fieldOptions = [];
      if (field && field.projectBookingCustomFieldOptions) {
        field.projectBookingCustomFieldOptions.forEach((d) => {
          fieldOptions.push(
            { text: d.title, value: d.value, id: d.id },
          );
        });
      }
      if (data.isDefault) {
        switch (data.name) {
          case 'nationality':
            fieldOptions = SELECT_NATIONALITY;
            break;
          case 'gender':
            fieldOptions = GENDER.map(o => ({
              ...o,
              text: t(o.text, { ns: TRANSLATION_FILES.constants }),
            }));
            break;
          case 'bumi':
            fieldOptions = BUMI.map(o => ({
              ...o,
              text: t(o.text, { ns: TRANSLATION_FILES.constants }),
            }));
            break;
          case 'maritalStatus':
            fieldOptions = MARITAL_STATUS.map(o => ({
              ...o,
              text: t(o.text, { ns: TRANSLATION_FILES.constants }),
            }));
            break;
          default:
            break;
        }
      }
      let optionText = '';
      let value = customer[data.name];
      if (data.type === 'dropdown_multi') {
        if (customer[data.name]) {
          const selectedOptions = fieldOptions.filter((o) => {
            let match = false;
            customer[data.name].split(',').forEach((v) => {
              if (v === o.value) match = true;
            });
            return match;
          });
          optionText = selectedOptions.map((v, key) => (<Label key={key} circular size="small">{v.text}</Label>));
        }
        if (customer[data.name] && value !== '') {
          value = value.split(',');
        } else {
          value = [];
        }
      } else if (data.type === 'dropdown') {
        const option = fieldOptions.find(d => d.value === customer[data.name]);
        if (option) {
          optionText = option.text;
        }
      }
      return (
        <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
          {isEditing ?
            <Form.Group widths="equal">
              <AppForm.Validate
                key={idx}
                validation={(data.isRequired && !data.isDisabled && !isRestricted) ? [required] : null}
                ref={this.validation[data.name]}
                onChange={(e, d) => (isAddCustomer ? this.handleCustomerAddSelectChange(e, d, fieldOptions) : this.handleCustomerSelectChange(e, d, fieldOptions))}
                validateLabel={data.label}
              >
                <Form.Select
                  disabled={isRestricted || data.isDisabled}
                  label={`${formLabel}${data.isRequired ? '*' : ''}`}
                  name={data.name}
                  options={this.toUppercaseOptions(fieldOptions)}
                  placeholder={data.placeholder}
                  search
                  selectOnBlur={false}
                  value={value}
                  multiple={data.type === 'dropdown_multi'}
                  renderLabel={renderLabel}
                  noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                />
              </AppForm.Validate>
            </Form.Group>
            :
            <div>
              <Grid stretched>
                <Grid.Row>
                  <Grid.Column textAlign="left" width={6}>
                    <b>{formLabel}</b>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={10} className="word_break_word" {...this.checkAddDataAttributeBCF(data.name) && this.getDataAttributes(customerIdx, data.name.toLowerCase(), this.valueToText(fieldOptions, value))}>
                    <div>{this.toUppercaseFormat(optionText || '-')}</div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider style={{ margin: '0.5em 0' }} />
            </div>
          }
        </Grid.Column>
      );
    }
    return '';
  }
  renderDefaultFields(isEditing, customer, customerIdx, isAddCustomer = false) {
    const { projectBookingCustomFields } = this.state;
    const { auth } = this.props;
    const isVietnam = isCountryVietnam(auth && auth.company && auth.company.countryCode);
    let defaultFields = EXTRA_PURCHASER_CUSTOM_FIELDS;
    if (projectBookingCustomFields && projectBookingCustomFields.length > 0 && projectBookingCustomFields.filter(c => c.isDefault).length > 0) {
      defaultFields = projectBookingCustomFields.filter(c => c.isDefault);
    }
    if (isVietnam) {
      // CPI-976: no SST / race / bumi for Vietnam; Nationality is replaced by the Citizenship pair.
      defaultFields = defaultFields.filter(c => !['race', 'bumi', 'sstRegistrationNo', 'nationality'].includes(c.name));
    }
    return (
      <Grid>
        <Grid.Row>
          {defaultFields.filter(bcf => PURCHASER_CUSTOM_FIELDS.some(pf => bcf.name !== pf.name && !bcf.isHidden))
            .sort((a, b) => a.position - b.position).map((d, idx) => this.renderDefaultField(d, idx, isEditing, customer, customerIdx, isAddCustomer))}
        </Grid.Row>
      </Grid>
    );
  }
  render() {
    const { isMobile, addressSettings, t, appConfig, combinedPrintTmplOnly, auth } = this.props;
    const enabledAddressSettings = addressSettings.data.filter(as => as.enabled);
    const {
      bookingStatusModal,
      customerAddArea,
      data,
      editingCustomer,
      isEditingCustomer,
      isIOS,
      modal,
      widthIsLessThan1200,
      projectBookingCustomFields,
      shareESignData,
      screenWidth,
    } = this.state;
    const isIndonesia = auth.company.countryCode.toUpperCase() === 'ID';
    const isMalaysia = auth && auth.company.countryCode.toUpperCase() === 'MY';
    const isVietnam = isCountryVietnam(auth && auth.company && auth.company.countryCode);
    // CPI-1262 (7 Sep) hid the purchaser ID snapshot for Vietnam: the card was Malaysian in shape,
    // NRIC front and back with MyKad sample images. CPI-1332 item 1 (20 Sep) asks for it back, so a
    // buyer typed in on the swap flow can have their identity document attached. It returns in the
    // Vietnamese shape - two sides for a CCCD, one image for a passport or an Enterprise
    // Registration Certificate, no MyKad samples - and MY/ID keep exactly what they had. Stored
    // documents and purchaser identity fields are unchanged either way.
    const showsIDSnapshot = true;
    const editShape = this.idDocumentShape(
      (editingCustomer.customer && editingCustomer.customer.identityTypeID) || editingCustomer.identityTypeID,
    );
    const addShape = this.idDocumentShape(this.state.identityType);
    // Vietnam's current launch uses wet-sign only, so the E-Sign card remains hidden.
    const showsESignature = !isVietnam;
    const signatureColumnWidth = showsIDSnapshot ? (widthIsLessThan1200 ? 16 : 8) : 16;
    const isNewMalaysia = this.state.customerAdd.country.toUpperCase() === 'MY';
    const isEditMalaysia = editingCustomer.country.toUpperCase() === 'MY';
    const hideLabel = isIndonesia || this.state.customerAdd.customer.isForeignCompany;
    const requiredIdentityLabel = getRequiredIdentityLabel(isVietnam, this.state.identityType, t);
    const identityInputLabel = !hideLabel && isVietnam && this.state.identityType === IDENTITY_TYPE_NRIC
      ? `${requiredIdentityLabel} *`
      : this.getIdentityInputLabel(hideLabel);
    // add validateRef for all custom fields
    if (projectBookingCustomFields && projectBookingCustomFields.length > 0) {
      projectBookingCustomFields.filter(bcf => PURCHASER_CUSTOM_FIELDS.some(pf =>
        bcf.name !== pf.name && bcf.isDefault && !bcf.isHidden)).forEach((pcf) => {
          this.validation[pcf.name] = createRef();
        });
    }
    const constructIdentityTypeDropdown = () => (
      isPRS ?
        <AppForm.Input
          loading={this.state.searchingID}
          autoComplete="off"
          name="prsID"
          onChange={this.handlePRSIDChange}
          placeholder={`${t('PRS ID')}*`}
          ref={this.validation.prsID}
          readOnly={this.state.identityLock}
          validation={[required, {
            validate: stringLength,
            option: {
              min: 13,
            },
          }]}
          value={this.state.prsID}
          validateLabel={`${t('PRS ID')}*`}
        /> :
        <AppForm.Validate
          onChange={this.handleIDTypeChange}
          validation={[required]}
          ref={this.validation.identityType}
          validateLabel={t('Identity Type')}
        >
          <Dropdown
            disabled={this.state.identityLock}
            fluid
            name="identityType"
            options={this.toUppercaseOptions(this.state.identityTypeOpts).map(o => ({
              ...o,
              text: t(o.text, { ns: TRANSLATION_FILES.screens }),
            }))}
            placeholder={`${t('Select {{title}}', { title: t('Identity Type') })}*`}
            selection
            selectOnBlur={false}
            value={this.state.identityType}
          />
        </AppForm.Validate>
    );
    const constructIdentityInput = () => (
      <AppForm.Input
        className={`ui input
            ${this.state.searchingID ? 'loading circle notched icon ' : ''}
            ${this.hasResetIdentityIcon() ? 'icon ' : ''}
            ${this.state.identityError ? ' error' : ''}`}
        label={identityInputLabel}
        disabled={this.state.identityType === ''}
        name="identity"
        onChange={this.handleIdentityChange}
        placeholder={this.getIdentityPlaceholder(isIndonesia)}
        readOnly={this.state.identityLock}
        inputRef={this.identityInputRef}
        type="text"
        value={this.state.identity}
        icon={
          this.hasResetIdentityIcon() ? <Icon
            link
            name="x"
            onClick={this.handleResetAutofill}
            title={t('Clear Form')}
          /> : this.state.searchingID ? <Icon loading name="circle notch" /> : null
        }
        validation={[required, {
          validate: validateIdentity,
          option: this.identityValidation(),
        }]}
        validateRef={this.validation.identity}
        validateLabel={requiredIdentityLabel}
        onError={(identityError) => { this.setState({ identityError }); }}
      />
    );
    const isForeignCompanyCheckbox = currentAction => (
      <div style={{ display: 'flex', justifyContent: 'start', marginTop: '1em' }}>
        <Checkbox
          label="Foreign company"
          onChange={(e, d) => {
            this.setState(prevState => ({
              [currentAction]: {
                ...prevState[currentAction],
                customer: {
                  ...prevState[currentAction].customer,
                  taxIdentificationNo: d.checked ? FOREIGN_BUYER_GENERIC_TIN : '',
                  isForeignCompany: d.checked,
                },
              },
            }), () => {
              this.handleTinInput({ target: { value: d.checked ? this.state[currentAction].customer.taxIdentificationNo : '', tinAddFound: false, tinEditFound: false } }, currentAction);
            });
          }}
          checked={this.state[currentAction].customer.isForeignCompany}
        />
      </div>
    );
    const isMobileView = screenWidth <= 767;
    const isTabletView = screenWidth > 767 && screenWidth <= 991;
    const isComputerView = screenWidth > 991;
    const constructResponsiveIdentityTinInputs = () => {
      const constructTinInput = () => {
        const mustValidTinForMY = isMalaysia && this.state.identityType !== 2 && (this.state.identityType === 4 || (data.project && data.project.requireValidTinAtBookingCreation));
        let tinValidation = [];
        if (isIndonesia) {
          tinValidation = [
            {
              validate: matchRegex,
              option: {
                validRegex: REGEX_NPWP_ID,
              },
            },
          ];
        } else {
          tinValidation = mustValidTinForMY && !this.state.customerAdd.customer.isForeignCompany ? [required, {
            validate: matchRegex,
            option: { validRegex: REGEX_TIN_VALID },
          }] : [{
            validate: matchRegex,
            option: { validRegex: REGEX_TIN_VALID },
          }];
        }

        return (
          <TinFieldInput
            isIndonesia={isIndonesia}
            value={this.state.customerAdd.customer.taxIdentificationNo}
            errMessage={this.state.tinMessage}
            isLoading={this.state.validatingTin}
            tinError={isMalaysia && this.state.tinErrorAdd}
            required={isMalaysia && mustValidTinForMY && !this.state.customerAdd.customer.isForeignCompany}
            validation={tinValidation}
            ref={this.validation.taxIdentificationNo}
            onChange={e => this.handleTinInput(e, 'customerAdd')}
            identityType={this.state.identityType}
            identityValue={this.state.identity}
            // readOnly={this.state.tinAddFound}
            unitID={data.projectUnitID}
            bookingID={data.id}
          />
        );
      };

      return (
        <React.Fragment>
          {/* display only on mobile */}
          {isMobileView && <Grid.Row columns={1} centered>
            <Grid.Column style={{ marginBottom: identityInputLabel ? '1rem' : '1.5rem' }}>
              {constructIdentityTypeDropdown()}
              {(isMalaysia && this.state.identityType === IDENTITY_TYPE_BRN) && isForeignCompanyCheckbox('customerAdd')}
            </Grid.Column>
            <Grid.Column textAlign="left" style={{ marginBottom: '1rem' }}>
              {constructIdentityInput()}
            </Grid.Column>
            <Grid.Column>
              {(isMalaysia || isIndonesia) && constructTinInput()}
            </Grid.Column>
          </Grid.Row>}

          {/* display only on tablet */}
          {isTabletView && <Grid.Row columns={3} centered>
            <Grid.Column style={{ marginTop: identityInputLabel ? '2.2rem' : '1.9rem' }}>
              {constructIdentityTypeDropdown()}
              {(isMalaysia && this.state.identityType === IDENTITY_TYPE_BRN) && isForeignCompanyCheckbox('customerAdd')}
            </Grid.Column>
            <Grid.Column textAlign="left" style={{ marginTop: identityInputLabel ? '0.1rem' : '1.9rem' }}>
              {constructIdentityInput()}
            </Grid.Column>
            <Grid.Column style={{ marginTop: identityInputLabel ? '1.3rem' : '0rem' }}>
              {(isMalaysia || isIndonesia) && constructTinInput()}
            </Grid.Column>
          </Grid.Row>}

          {/* display only on computer */}
          {isComputerView && <Grid.Row columns={3} centered>
            <Grid.Column style={{ marginTop: '1.9rem' }}>
              {constructIdentityTypeDropdown()}
              {(isMalaysia && this.state.identityType === IDENTITY_TYPE_BRN) && isForeignCompanyCheckbox('customerAdd')}
            </Grid.Column>
            <Grid.Column textAlign="left" style={{ marginTop: identityInputLabel ? '0.1rem' : '1.9rem' }}>
              {constructIdentityInput()}
            </Grid.Column>
            <Grid.Column>
              {(isMalaysia || isIndonesia) && constructTinInput()}
            </Grid.Column>
          </Grid.Row>}
        </React.Fragment>
      );
    };

    const himsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled && data && data.project && data.project.himsIsEnabled;
    const reviewPurchasers = isVietnam && data.purchasersIsolated &&
      decodeSearch(this.props.location.search).reviewPurchasers === '1';

    return (
      <Container>
        <ESigningModal
          ref={(ref) => { this.signatureModal = ref; }}
          loading={this.state.loading}
          open={this.state.showSignModal}
          saveButton={
            <Button onClick={event => this.saveSignature(event, editingCustomer)} disabled={this.state.loading} positive color="green" content={t('Save', { ns: TRANSLATION_FILES.translation })} />
          }
          cancelButton={
            <Button onClick={this.handleOnCancel} disabled={this.state.loading} basic color="grey" content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
          }
        />
        <ShareESign
          data={shareESignData}
          bookingData={data}
          loading={this.state.loading}
          customerData={editingCustomer}
          open={showsESignature && this.state.showShareESignModal}
          isMobile={isMobile}
          onClose={this.handleOnCloseShareESign}
          onProceed={this.handleProceedShareESign}
          onRenew={this.handleRenewESign}
          onSend={this.handleSendESignToken}
          printTemplates={combinedPrintTmplOnly}
          isVietnam={isVietnam}
        />
        <BookingStatusNotes
          onNotesChange={this.handleNotesChange}
          onCheckboxChange={this.handleCheckboxChange}
          statusID={data.statusID}
          notes={data.remarkInternal}
          isCancelPending={data.isCancelPending}
          onClose={this.handleCancelBookingStatus}
          onConfirm={this.handleConfirmBookingStatus}
          open={bookingStatusModal}
        />
        <Modal closeOnDimmerClick={false} open={this.state.showSoldConfirmation} basic size="small">
          <Header icon="warning sign" content={t('Confirm Update', { ns: TRANSLATION_FILES.translation })} />
          <Modal.Content>
            <h4>{t('Check if any printed forms, receipts, or invoices have the old buyer\'s details instead of the new one.')}</h4>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleCancelSoldUpdate} basic color="grey" inverted>
              <Icon name="remove" /> {t('Cancel', { ns: TRANSLATION_FILES.translation })}
            </Button>
            <Button
              onClick={this.handleConfirmSoldUpdate}
              color="blue"
              inverted
            >
              <Icon name="checkmark" /> {t('Confirm', { ns: TRANSLATION_FILES.translation })}
            </Button>
          </Modal.Actions>
        </Modal>
        {/* Booking Customer Modal */}
        <Modal closeOnDimmerClick={false} open={modal.isOpen} basic size="small">
          <Header icon={modal.headerIcon} content={modal.header} />
          <Modal.Content>
            <h4>{modal.message}</h4>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleCloseModal} basic color="red" inverted>
              <Icon name="remove" /> {t('No', { ns: TRANSLATION_FILES.constants })}
            </Button>
            <Button
              onClick={this.handleConfirm}
              color="green"
              inverted
            >
              <Icon name="checkmark" /> {t('Yes', { ns: TRANSLATION_FILES.constants })}
            </Button>
          </Modal.Actions>
        </Modal>
        <BookingTitle isMobile={isMobile} data={data} />
        {reviewPurchasers && (
          <Message warning icon>
            <Icon name="warning sign" />
            <Message.Content>
              <Message.Header>{t('Review related purchasers')}</Message.Header>
              {t('The unit has been reserved. Edit and save every related purchaser with invalid or missing details before continuing.')}
            </Message.Content>
          </Message>
        )}
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
              <div>
                {
                  data.bookingCustomers && data.bookingCustomers.length > 0 ?
                    data.bookingCustomers
                      .sort(this.sortPrimaryCustomer)
                      .map((customerData, idx) => {
                        const customerDropdownOptions = this.customerDropdownOptions(customerData, data, idx);
                        const mustValidTinEdit = isMalaysia && editingCustomer.customer.identityTypeID !== 2 && (editingCustomer.customer.identityTypeID === 4 || (data.project && data.project.requireValidTinAtBookingCreation));
                        let tinValidation = [];
                        if (isIndonesia) {
                          tinValidation = [
                            {
                              validate: matchRegex,
                              option: { validRegex: REGEX_NPWP_ID }, // Regex for Indonesian NPWP
                            },
                          ];
                        } else if (isMalaysia) {
                          tinValidation = mustValidTinEdit && !editingCustomer.customer.isForeignCompany
                            ? [required, { validate: matchRegex, option: { validRegex: REGEX_TIN_VALID } }]
                            : [{ validate: matchRegex, option: { validRegex: REGEX_TIN_VALID } }];
                        }
                        return (
                          <div key={idx} id={customerData.id}>
                            {(customerData.customerID !== data.customerID) && <div />}
                            <Header className="new_title" as="h5" attached="top" textAlign="center">
                              <Grid>
                                <Grid.Column textAlign={isMobile ? 'left' : 'center'}>
                                  {
                                    customerData.customerID === data.customerID ? (
                                      (data.bookingCustomers && data.bookingCustomers.length > 1) ?
                                        <b>{t('Primary Purchaser').toUpperCase()} <Icon disabled name="star" /></b>
                                        : t('Purchaser').toUpperCase()
                                    ) : `${t('Purchaser').toUpperCase()} ${idx + 1}`
                                  }
                                  <div style={{ position: 'absolute', right: '1em', top: '1em' }}>
                                    {this.hasCustomerManageAccess(
                                      data.project.allowAgentManageBookingCustomer,
                                      data.statusID,
                                    ) ?
                                      (this.checkUnitIsSold(data) && !this.hasAccess() && !this.isBULeader()) ?
                                        '' :
                                        (isEditingCustomer === customerData.customerID ?
                                          <button
                                            className="a-button-gray"
                                            onClick={this.handleCancelEditCustomer}
                                          >
                                            <Icon name="x" fitted style={{ marginRight: '0.5rem' }} />
                                          </button>
                                          :
                                          (customerData.customerID === data.customerID ?
                                            (!isPRS &&
                                              <Popup
                                                trigger={
                                                  <div style={{ display: 'inline-block' }}>
                                                    <button
                                                      disabled={this.disableEditAfterSold(data) || isEditingCustomer !== 0 || customerAddArea}
                                                      className={`a-button-gray ${(this.disableEditAfterSold(data) || isEditingCustomer !== 0 || customerAddArea) && 'disabled'}`}
                                                      onClick={() => { this.handleEditCustomer(customerData); }}
                                                    >
                                                      <Icon name="edit" fitted style={{ marginRight: '0.5rem' }} />
                                                      {t('Edit', { ns: TRANSLATION_FILES.translation })}
                                                    </button>
                                                  </div>
                                                }
                                                disabled={!this.disableEditAfterSold(data)}
                                                content={t('Purchaser details are locked because the booking has been marked as Sold', { ns: TRANSLATION_FILES.translation })}
                                              />
                                            )
                                            :
                                            <Dropdown
                                              disabled={this.disableEditAfterSold(data) || isEditingCustomer !== 0 || customerAddArea}
                                              selectOnBlur={false}
                                              trigger={<Icon size="large" color="grey" name="ellipsis horizontal" />}
                                              icon={null}
                                              pointing="top right"
                                              options={customerDropdownOptions}
                                            />
                                          )
                                        )
                                      : ''
                                    }
                                  </div>
                                </Grid.Column>
                              </Grid>
                            </Header>
                            <Segment attached>
                              <Grid>
                                <Grid.Row>
                                  {
                                    isEditingCustomer || customerAddArea ?
                                      <Dimmer
                                        style={{ zIndex: 5, opacity: '0.75' }}
                                        active={isEditingCustomer !== customerData.customerID}
                                        inverted
                                      />
                                      : null
                                  }
                                  <Grid.Column width={16}>
                                    {isEditingCustomer === customerData.customerID ?
                                      <Grid>
                                        {showsIDSnapshot && (
                                        <Grid.Row>
                                          <Grid.Column>
                                            <Grid>
                                              <Grid.Row>
                                                {!this.isBULeaderRestrictedEdit(data) ? (
                                                  <React.Fragment>
                                                    <Grid.Column mobile={16} tablet={editShape.sides === 2 ? 8 : 16} computer={editShape.sides === 2 ? 8 : 16} textAlign="center">
                                                      <UploadForm
                                                        isCompress
                                                        title="Front"
                                                        ref={(ref) => { this.icFrontUpload = ref; }}
                                                        setLoading={this.setLoading}
                                                        loading={this.state.loading}
                                                        sampleURL={editShape.sample ? '/assets/images/samples/ic_front.svg' : ''}
                                                        tags={['IC Front']}
                                                        bucketName={this.getMPBucketName()}
                                                        {...this.identityPictureProps(editingCustomer, 'front')}
                                                        onChange={ic => this.handleGetIC(ic, 'Front', 'customerICChanges')}
                                                      />
                                                    </Grid.Column>
                                                    {editShape.sides === 2 && (
                                                    <Grid.Column mobile={16} tablet={8} computer={8} textAlign="center">
                                                      <UploadForm
                                                        isCompress
                                                        title="Back"
                                                        ref={(ref) => { this.icBackUpload = ref; }}
                                                        setLoading={this.setLoading}
                                                        loading={this.state.loading}
                                                        sampleURL={editShape.sample ? '/assets/images/samples/ic_back.svg' : ''}
                                                        tags={['IC Back']}
                                                        bucketName={this.getMPBucketName()}
                                                        {...this.identityPictureProps(editingCustomer, 'back')}
                                                        onChange={ic => this.handleGetIC(ic, 'Back', 'customerICChanges')}
                                                      />
                                                    </Grid.Column>
                                                    )}
                                                  </React.Fragment>
                                                ) : (
                                                  <Grid.Column mobile={16} tablet={16} computer={16} textAlign="center">
                                                    <div style={{ padding: '2em', color: '#999' }}>
                                                      <Icon name="lock" size="large" />
                                                      <p>{t('IC upload is locked for SOLD bookings')}</p>
                                                    </div>
                                                  </Grid.Column>
                                                )}
                                              </Grid.Row>
                                            </Grid>
                                          </Grid.Column>
                                        </Grid.Row>
                                        )}
                                        <Grid.Row>
                                          <Grid.Column>
                                            <AppForm
                                              error={this.state.errMessages.length > 0}
                                              onSubmit={this.handleSubmitCustomer}
                                              ref={(ref) => { this.form = ref; }}
                                              id="edit_purchaser_form"
                                            >
                                              <Grid.Row>
                                                <Grid.Column mobile={16} tablet={10} computer={editingCustomer.clientID ? 16 : 8}>
                                                  <Form.Group widths="equal">
                                                    <AppForm.Input
                                                      disabled
                                                      name="identityTypeID"
                                                      autoComplete="off"
                                                      label={this.getIdentityTypeText(
                                                        customerData.customer.identityTypeID,
                                                        customerData.customer.identityPresetID,
                                                        customerData.customer.identityPresetLabel,
                                                      )}
                                                      value={customerData.customer.identity}
                                                    />
                                                    {
                                                      editingCustomer.clientID ?
                                                        <AppForm.Input
                                                          disabled
                                                          autoComplete="off"
                                                          label={translateModels(t, 'clientID', 'booking')}
                                                          name="clientID"
                                                          onChange={this.handleCustomerInputChange}
                                                          placeholder={translateModels(t, 'clientID', 'booking')}
                                                          value={editingCustomer.clientID}
                                                        /> : null
                                                    }
                                                    {(isMalaysia || isIndonesia) && (
                                                      <TinFieldInput
                                                        disabled={this.isBULeaderRestrictedEdit(data)}
                                                        isIndonesia={isIndonesia}
                                                        // readOnly={isMalaysia && this.state.tinEditFound}
                                                        value={editingCustomer.customer.taxIdentificationNo}
                                                        errMessage={this.state.tinMessage}
                                                        isLoading={this.state.validatingTin}
                                                        tinError={isMalaysia && this.state.tinErrorEdit}
                                                        required={isMalaysia && mustValidTinEdit && !editingCustomer.customer.isForeignCompany}
                                                        validation={tinValidation}
                                                        ref={this.validation.taxIdentificationNo}
                                                        onChange={e => this.handleTinInput(e, 'editingCustomer')}
                                                        identityType={editingCustomer.customer.identityTypeID}
                                                        identityValue={editingCustomer.customer.identity}
                                                        unitID={data.projectUnitID}
                                                        bookingID={data.id}
                                                      />
                                                    )}
                                                  </Form.Group>
                                                </Grid.Column>
                                              </Grid.Row>
                                              {
                                                (isMalaysia && editingCustomer.customer.identityTypeID === IDENTITY_TYPE_BRN) && (
                                                  <Grid.Row style={{ marginBottom: '1em' }}>
                                                    <Grid.Column>
                                                      {isForeignCompanyCheckbox('editingCustomer')}
                                                    </Grid.Column>
                                                  </Grid.Row>
                                                )
                                              }
                                              <Grid.Row>
                                                <Grid.Column width={16}>
                                                  <Form.Group widths="equal">
                                                    {
                                                      this.state.hideTitle ? null : (
                                                        <AppForm.Validate
                                                          validation={[required]}
                                                          ref={this.validation.title}
                                                          onChange={this.handleCustomerSelectChange}
                                                          validateLabel={translateModels(t, 'title', 'booking')}
                                                        >
                                                          <Form.Select
                                                            disabled={this.isBULeaderRestrictedEdit(data)}
                                                            label={`${translateModels(t, 'title', 'booking')}*`}
                                                            name="title"
                                                            onChange={this.handleCustomerSelectChange}
                                                            options={this.toUppercaseOptions(CUSTOMER_TITLES).map(o => ({
                                                              ...o,
                                                              text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                                                            }))}
                                                            placeholder={`${t('Select {{title}}', { title: translateModels(t, 'title', 'booking') })}*`}
                                                            search
                                                            selectOnBlur={false}
                                                            noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                                            value={editingCustomer.title}
                                                          />
                                                        </AppForm.Validate>
                                                      )
                                                    }
                                                    <AppForm.Input
                                                      disabled={this.isBULeaderRestrictedEdit(data)}
                                                      autoComplete="off"
                                                      label={`${t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')}*`}
                                                      name="name"
                                                      onChange={this.handleCustomerInputChange}
                                                      placeholder={`${t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')}*`}
                                                      ref={this.validation.name}
                                                      validation={[required, ...vnFullNameValidations(auth, editingCustomer.identityTypeID, t)]}
                                                      value={editingCustomer.name}
                                                      validateLabel={t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')}
                                                    />
                                                    <AppForm.Input
                                                      disabled={this.isBULeaderRestrictedEdit(data)}
                                                      autoComplete="off"
                                                      label={`${t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')}*`}
                                                      name="preferredName"
                                                      onChange={this.handleCustomerInputChange}
                                                      placeholder={`${t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')}*`}
                                                      ref={this.validation.preferredName}
                                                      validation={
                                                        editingCustomer.identityTypeID === 4
                                                          ? [required, ...vnPreferredNameValidations(auth, t)]
                                                          : [
                                                            required,
                                                            {
                                                              validate: stringLength,
                                                              option: {
                                                                max: 15,
                                                              },
                                                            },
                                                            ...vnPreferredNameValidations(auth, t),
                                                          ]
                                                      }
                                                      value={editingCustomer.preferredName}
                                                      validateLabel={t(editingCustomer.identityTypeID === 4 ? 'Contact Person' : 'Preferred Name')}
                                                    />
                                                    <AppForm.Input
                                                      autoComplete="off"
                                                      label={`${translateModels(t, 'email', 'booking')}${this.checkIsEmailRequired() ? '*' : ''}`}
                                                      name="email"
                                                      type="email"
                                                      onChange={this.handleCustomerInputChange}
                                                      placeholder={translateModels(t, 'email', 'booking')}
                                                      value={editingCustomer.email}
                                                      ref={this.validation.email}
                                                      validation={this.getEmailValidation()}
                                                      validateLabel={translateModels(t, 'email', 'booking')}
                                                    />
                                                  </Form.Group>
                                                  <Form.Group widths="equal">
                                                    <AppForm.Validate
                                                      validation={[required]}
                                                      ref={this.validation.mobilePrefix}
                                                      onChange={this.handleCustomerSelectChange}
                                                      validateLabel={translateModels(t, 'mobilePrefix', 'booking')}
                                                    >
                                                      <Form.Select
                                                        label={`${translateModels(t, 'mobilePrefix', 'booking')}*`}
                                                        name="mobilePrefix"
                                                        disabled={data.origin && data.origin.includes('marketplace_') && editingCustomer.originCustomerID !== ''}
                                                        onChange={this.handleCustomerSelectChange}
                                                        options={this.toUppercaseOptions(INTL_CALL_CODES)}
                                                        search
                                                        selectOnBlur={false}
                                                        noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                                        value={editingCustomer.mobilePrefix}
                                                      />
                                                    </AppForm.Validate>
                                                    <PhoneInput
                                                      autoComplete="off"
                                                      label={`${t('Mobile')}*`}
                                                      name="mobile"
                                                      disabled={data.origin && data.origin.includes('marketplace_') && editingCustomer.originCustomerID !== ''}
                                                      onChange={this.handleCustomerInputChange}
                                                      placeholder="e.g. 196756118"
                                                      prefix={editingCustomer.mobilePrefix}
                                                      ref={this.validation.mobile}
                                                      type="tel"
                                                      validation={[required, mobileValidation({
                                                        presets: this.state.phoneValidationPresets,
                                                        prefix: editingCustomer.mobilePrefix,
                                                        label: t('Mobile'),
                                                        t,
                                                      })]}
                                                      value={editingCustomer.mobile}
                                                      validateLabel={t('Mobile')}
                                                    />
                                                  </Form.Group>
                                                  <Form.Group widths="equal">
                                                    <Form.Select
                                                      label={t('House/Office Phone prefix')}
                                                      name="phonePrefix"
                                                      onChange={this.handleCustomerSelectChange}
                                                      options={this.toUppercaseOptions(INTL_CALL_CODES)}
                                                      search
                                                      selectOnBlur={false}
                                                      noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                                      value={editingCustomer.phonePrefix}
                                                    />
                                                    <PhoneInput
                                                      autoComplete="off"
                                                      label={t('House/Office Phone')}
                                                      name="phone"
                                                      onChange={this.handleCustomerInputChange}
                                                      placeholder="e.g. 378317749"
                                                      prefix={editingCustomer.phonePrefix}
                                                      ref={this.validation.phone}
                                                      type="tel"
                                                      value={editingCustomer.phone}
                                                      validation={[{
                                                        validate: phoneNumber,
                                                        option: editingCustomer.phonePrefix === 'other' ? {} : {
                                                          phonePrefix: editingCustomer.phonePrefix,
                                                          validRegex: getPhoneValidRegex(
                                                            this.state.phoneValidationPresets,
                                                            editingCustomer.phonePrefix,
                                                            'phone',
                                                          ),
                                                        },
                                                      }]}
                                                      validateLabel={t('House/Office Phone')}
                                                    />
                                                  </Form.Group>
                                                  {this.renderCitizenshipInputs('editingCustomer')}
                                                  {
                                                    // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
                                                    _.chunk(enabledAddressSettings.map((as, iidx) => {
                                                      const key = _.camelCase(as.columnName);
                                                      let addressLabel = as.label.toLowerCase();
                                                      let isRequired = as.required;
                                                      let errMessage = null;
                                                      const validations = [{
                                                        validate: stringLength,
                                                        option: {
                                                          max: 256,
                                                        },
                                                      }];

                                                      // Determine behavior based on selected country in the form
                                                      const selectedCountry = (editingCustomer.country || '').toUpperCase();
                                                      const isSelectedCountryMalaysia = selectedCountry === 'MY';

                                                      // When company is Vietnam: apply country-dependent logic for state field
                                                      if (isVietnam && addressLabel === 'state') {
                                                        if (isSelectedCountryMalaysia) {
                                                          // Malaysia selected: keep as "State", required
                                                          isRequired = true;
                                                        } else {
                                                          // Non-Malaysia selected: change to "City/Province", optional
                                                          addressLabel = 'cityOrProvince';
                                                          isRequired = false;
                                                        }
                                                      } else if (isVietnam && addressLabel === 'city' && !isSelectedCountryMalaysia) {
                                                        addressLabel = 'ward';
                                                        isRequired = false;
                                                      } else if (isVietnam && addressLabel === 'postcode' && !isSelectedCountryMalaysia) {
                                                        addressLabel = 'postalCode';
                                                        isRequired = false;
                                                      }

                                                      if (isRequired) {
                                                        validations.push(required);
                                                      }
                                                      if (!himsIsEnabled && isSelectedCountryMalaysia && as.label.toLowerCase() === 'postcode') {
                                                        validations.push({
                                                          validate: matchRegex,
                                                          option: {
                                                            validRegex: REGEX_POSTCODE_MY,
                                                          },
                                                        });
                                                        errMessage = 'Invalid MY postcode format';
                                                      }

                                                      const label = `${translateModels(t, addressLabel, 'booking')}${isRequired ? '*' : ''}`;

                                                      if (!isPRS && isSelectedCountryMalaysia && as.label.toLowerCase() === 'state') {
                                                        return (
                                                          <AppForm.Validate
                                                            key={iidx}
                                                            validation={isRequired ? [required] : null}
                                                            ref={this.validation[key]}
                                                            onChange={this.handleCustomerSelectChange}
                                                            validateLabel={as.label.toLowerCase() === 'state' ? translateModels(t, 'state', 'booking') : as.label}
                                                          >
                                                            <Form.Select
                                                              name={key}
                                                              fluid
                                                              options={this.toUppercaseOptions(STATES)}
                                                              placeholder={t('Select {{title}}', { title: label.toLowerCase() })}
                                                              label={label}
                                                              search
                                                              selectOnBlur={false}
                                                              noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                                              value={editingCustomer[key]}
                                                            />
                                                          </AppForm.Validate>
                                                        );
                                                      }

                                                      if (himsIsEnabled && isSelectedCountryMalaysia && as.label.toLowerCase() === 'postcode') {
                                                        return (
                                                          <SearchHimsPostcodes
                                                            key={iidx}
                                                            validateRef={this.validation.himsKodPoskod}
                                                            name="himsKodPoskod"
                                                            onSelect={this.handleCustomerSelectHimsPostcode}
                                                            state={editingCustomer.address7}
                                                            value={editingCustomer.himsKodPoskod}
                                                          />
                                                        );
                                                      }

                                                      return (
                                                        <AppForm.Input
                                                          key={iidx}
                                                          autoComplete="off"
                                                          name={key}
                                                          onChange={this.handleCustomerInputChange}
                                                          placeholder={label}
                                                          label={label}
                                                          ref={this.validation[key]}
                                                          validation={validations}
                                                          value={editingCustomer[key]}
                                                          validateLabel={as.label}
                                                          message={errMessage}
                                                        />
                                                      );
                                                    }).concat([(
                                                      <AppForm.Validate
                                                        key="country"
                                                        validation={[required]}
                                                        ref={this.validation.country}
                                                        onChange={(e, countryData) => {
                                                          // Reset state input field
                                                          if (!isPRS) {
                                                            const as = enabledAddressSettings.find(a => a.label.toLowerCase() === 'state');
                                                            if (as) {
                                                              const key = _.camelCase(as.columnName);
                                                              if (editingCustomer[key]) {
                                                                editingCustomer[key] = '';
                                                                this.setState({ editingCustomer });
                                                              }
                                                            }
                                                          }
                                                          this.handleCustomerSelectChange(e, countryData);
                                                        }}
                                                        validateLabel={translateModels(t, 'country', 'booking')}
                                                      >
                                                        <Form.Select
                                                          disabled={this.isBULeaderRestrictedEdit(data)}
                                                          autoComplete="off"
                                                          fluid
                                                          label={`${translateModels(t, 'country', 'booking')}*`}
                                                          name="country"
                                                          options={this.toUppercaseOptions(SELECT_COUNTRIES)}
                                                          placeholder={`${t('Select {{title}}', { title: translateModels(t, 'country', 'booking') })}*`}
                                                          search
                                                          selectOnBlur={false}
                                                          noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                                          value={editingCustomer.country}
                                                        />
                                                      </AppForm.Validate>
                                                    )]), 2).map((p, iidx) => (
                                                      <Form.Group widths="equal" key={`group_${iidx}`}>
                                                        {p}
                                                      </Form.Group>
                                                    ))
                                                  }
                                                  {
                                                    himsIsEnabled && isEditMalaysia ? (
                                                      <Form.Group widths="equal">
                                                        <SearchHimsDistricts
                                                          validateRef={this.validation.himsKodDaerah}
                                                          name="himsKodDaerah"
                                                          onSelect={this.handleCustomerSelectHimsDistrict}
                                                          state={editingCustomer.address7}
                                                          value={editingCustomer.himsKodDaerah}
                                                        />
                                                        <span style={{ flex: '1 1 auto', width: '100%' }} />
                                                      </Form.Group>
                                                    ) : null
                                                  }
                                                  <br />
                                                  {this.renderDefaultFields(true, editingCustomer, idx)}
                                                </Grid.Column>
                                              </Grid.Row>
                                            </AppForm>
                                          </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                          <Grid.Column>
                                            <Grid>
                                              <Grid.Row>
                                                <Grid.Column width={16} textAlign="center">
                                                  <Button
                                                    type="button"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      if (this.icFrontUpload) this.icFrontUpload.resetFiles();
                                                      if (this.icBackUpload) this.icBackUpload.resetFiles();
                                                      this.setState({
                                                        icFront: null,
                                                        icBack: null,
                                                        errMessages: [],
                                                        isEditingCustomer: 0,
                                                        editingCustomer: Object.assign(
                                                          {}, this.state.bookingCustomerDefaultData,
                                                        ),
                                                      }, () => {
                                                        this.handleResetCheck('customerChanges');
                                                      });
                                                    }}
                                                  >
                                                    <Icon name="remove" /> {t('Cancel', { ns: TRANSLATION_FILES.translation })}
                                                  </Button>
                                                  <Button
                                                    color="blue"
                                                    disabled={this.state.validatingTin}
                                                    onClick={e => this.form.handleSubmit(e)}
                                                  >
                                                    <Icon name="save" /> {t('Update', { ns: TRANSLATION_FILES.translation })}
                                                  </Button>
                                                </Grid.Column>
                                              </Grid.Row>
                                            </Grid>
                                          </Grid.Column>
                                        </Grid.Row>
                                      </Grid>
                                      :
                                      <Grid>
                                        <Grid.Row>
                                          <Grid.Column mobile={16} tablet={16} computer={6}>
                                            <Grid>
                                              {showsIDSnapshot && (
                                              <Grid.Column textAlign="left" width={getIDSnapshotColumnWidth(showsESignature, widthIsLessThan1200)} style={!widthIsLessThan1200 && showsESignature ? { paddingRight: '0.2em' } : { paddingBottom: '0.5em' }}>
                                                { // check if is IOS and conditional rendering  ( NRIC snapshot )
                                                !isIOS ? (
                                                  <Container className="nric-signature-container">
                                                    {
                                                    customerData && ((
                                                      this.identityDocumentComplete(customerData, isVietnam)
                                                    ) || (
                                                      !!customerData.buyerProfileID &&
                                                      !!customerData.buyerICFront &&
                                                      !!customerData.buyerICBack
                                                    )) ? (
                                                      <Icon name="check circle" style={{ color: 'green', float: 'right', fontSize: '1.5em', margin: '0.1em' }} />
                                                    ) : null
                                                  }
                                                    <Grid style={{ justifyContent: 'center', paddingTop: '0.5em' }}>
                                                      <Icon name="id card outline" />
                                                      <Header className="icSignStyle" as="h4">{t('{{name}} Snapshot', { name: isVietnam ? this.idDocumentShape(customerData.customer.identityTypeID).label : (customerData.customer.identityTypeID === 1 ? t('NRIC') : 'ID') })}</Header>
                                                    </Grid>
                                                    <Grid style={{ justifyContent: 'center', paddingTop: '0.8em' }}>
                                                      <div>
                                                        {
                                                        customerData && !!customerData.buyerProfileID &&
                                                        !!customerData.buyerICFront && !!customerData.buyerICBack && (
                                                          <Label size="mini" as="a" color="blue" onClick={e => this.handleOpenHTML(e, customerData, true)}>
                                                            <Icon name="print" />
                                                            {t('Buyer App')}
                                                          </Label>
                                                        )
                                                      }
                                                        {
                                                        this.hasCustomerManageAccess(
                                                          data.project.allowAgentManageBookingCustomer,
                                                          data.statusID,
                                                        ) && customerData && customerData.customer &&
                                                        (customerData.customer.icFrontDocumentID !== '' ||
                                                        customerData.customer.icBackDocumentID !== '') && (
                                                        this.checkICIsImage(customerData.customer) ?
                                                          <Label size="mini" as="a" color="blue" onClick={e => this.handleOpenHTML(e, customerData)}>
                                                            <Icon name="print" />
                                                            {t('Print')}
                                                          </Label>
                                                          :
                                                          <div style={{ display: 'inline-block' }}>
                                                            {
                                                              customerData.customer.icFrontDocument && customerData.customer.icFrontDocument.key ? (
                                                                <Label
                                                                  size="mini"
                                                                  as="a"
                                                                  color="blue"
                                                                  href={`${config.get('bookApiURL')}/customers/${customerData.customer.id}/documents/${customerData.customer.icFrontDocument.id}/view/`}
                                                                  target="_blank"
                                                                >
                                                                  {t('View Front')}
                                                                </Label>
                                                              ) : null
                                                            }
                                                            {
                                                              customerData.customer.icBackDocument && customerData.customer.icBackDocument.key ? (
                                                                <Label
                                                                  size="mini"
                                                                  as="a"
                                                                  color="blue"
                                                                  href={`${config.get('bookApiURL')}/customers/${customerData.customer.id}/documents/${customerData.customer.icBackDocument.id}/view/`}
                                                                  target="_blank"
                                                                >
                                                                  {t('View Back')}
                                                                </Label>
                                                              ) : null
                                                            }
                                                          </div>
                                                        )
                                                      }
                                                        {
                                                        customerData && this.crmIdentityOf(customerData.customerID).failed && (
                                                          <p style={{ color: '#9f3a38', margin: '0.3em 0' }}>
                                                            {t('The current CRM identity pictures could not be loaded. Reload the page to try again.')}
                                                          </p>
                                                        )
                                                      }
                                                        {
                                                        this.hasCustomerManageAccess(
                                                          data.project.allowAgentManageBookingCustomer,
                                                          data.statusID,
                                                        ) && (
                                                          <Popup
                                                            trigger={
                                                              <Label
                                                                size="mini"
                                                                as="a"
                                                                color="blue"
                                                                onClick={() => {
                                                                  if (!this.disableEditAfterSold(data)) {
                                                                    this.handleEditCustomer(customerData);
                                                                  }
                                                                }}
                                                                style={
                                                                  customerData && this.identityDocumentComplete(customerData, isVietnam) ? {
                                                                    marginLeft: '0.3em',
                                                                  } : null
                                                                }
                                                              >
                                                                {
                                                                  customerData && this.identityDocumentComplete(customerData, isVietnam) ?
                                                                  (<div><Icon name="pencil" /> {t('Edit', { ns: TRANSLATION_FILES.translation })}</div>)
                                                                  : `${t('Upload', { ns: TRANSLATION_FILES.translation })} ${isVietnam ? this.idDocumentShape(customerData.customer.identityTypeID).label : t(customerData.customer.identityTypeID === 1 ? 'IC' : 'Identification')}`
                                                                }
                                                              </Label>
                                                            }
                                                            disabled={!this.disableEditAfterSold(data)}
                                                            content={t('Purchaser details are locked because the booking has been marked as Sold', { ns: TRANSLATION_FILES.translation })}
                                                          />
                                                        )
                                                      }
                                                      </div>
                                                    </Grid>
                                                  </Container>
                                                ) : (
                                                  <Container className="nric-signature-container">
                                                    {
                                                    customerData && ((
                                                      this.identityDocumentComplete(customerData, isVietnam)
                                                    ) || (
                                                      !!customerData.buyerProfileID &&
                                                      !!customerData.buyerICFront &&
                                                      !!customerData.buyerICBack
                                                    )) ? (
                                                      <Icon name="check circle" style={{ color: 'green', float: 'right', fontSize: '1.5em', margin: '0.1em' }} />
                                                    ) : null
                                                  }
                                                    <Grid style={{ justifyContent: 'center', paddingTop: '0.5em', margin: '0' }}>
                                                      <Icon name="id card outline" />
                                                      <Header className="icSignStyle" as="h4">{t('{{name}} Snapshot', { name: isVietnam ? this.idDocumentShape(customerData.customer.identityTypeID).label : t('NRIC') })}</Header>
                                                    </Grid>
                                                    <Grid style={{ justifyContent: 'center', paddingTop: '0.8em', marginTop: '0' }}>
                                                      <div>
                                                        {
                                                        customerData && !!customerData.buyerProfileID &&
                                                        !!customerData.buyerICFront && !!customerData.buyerICBack && (
                                                          <Label size="mini" as="a" color="blue" onClick={e => this.handleOpenHTML(e, customerData, true)}>
                                                            <Icon name="print" />
                                                            {t('Buyer App')}
                                                          </Label>
                                                        )
                                                      }
                                                        {
                                                        this.hasCustomerManageAccess(
                                                          data.project.allowAgentManageBookingCustomer,
                                                          data.statusID,
                                                        ) && customerData && customerData.customer &&
                                                        (customerData.customer.icFrontDocumentID !== '' ||
                                                        customerData.customer.icBackDocumentID !== '') && (
                                                        this.checkICIsImage(customerData.customer) ?
                                                          <Label size="mini" as="a" color="blue" onClick={e => this.handleOpenHTML(e, customerData)}>
                                                            <Icon name="print" />
                                                            {t('Print')}
                                                          </Label>
                                                          :
                                                          <div style={{ display: 'inline-block' }}>
                                                            {
                                                              customerData.customer.icFrontDocument && customerData.customer.icFrontDocument.key ? (
                                                                <Label
                                                                  size="mini"
                                                                  as="a"
                                                                  color="blue"
                                                                  href={`${config.get('bookApiURL')}/customers/${customerData.customer.id}/documents/${customerData.customer.icFrontDocument.id}/view/`}
                                                                  target="_blank"
                                                                >
                                                                  {t('View Front')}
                                                                </Label>
                                                              ) : null
                                                            }
                                                            {
                                                              customerData.customer.icBackDocument && customerData.customer.icBackDocument.key ? (
                                                                <Label
                                                                  size="mini"
                                                                  as="a"
                                                                  color="blue"
                                                                  href={`${config.get('bookApiURL')}/customers/${customerData.customer.id}/documents/${customerData.customer.icBackDocument.id}/view/`}
                                                                  target="_blank"
                                                                >
                                                                  {t('View Back')}
                                                                </Label>
                                                              ) : null
                                                            }
                                                          </div>
                                                        )
                                                      }
                                                        {
                                                        customerData && this.crmIdentityOf(customerData.customerID).failed && (
                                                          <p style={{ color: '#9f3a38', margin: '0.3em 0' }}>
                                                            {t('The current CRM identity pictures could not be loaded. Reload the page to try again.')}
                                                          </p>
                                                        )
                                                      }
                                                        {
                                                        this.hasCustomerManageAccess(
                                                          data.project.allowAgentManageBookingCustomer,
                                                          data.statusID,
                                                        ) && (
                                                          <Popup
                                                            trigger={
                                                              <Label
                                                                size="mini"
                                                                as="a"
                                                                color="blue"
                                                                onClick={() => {
                                                                  if (!this.disableEditAfterSold(data)) {
                                                                    this.handleEditCustomer(customerData);
                                                                  }
                                                                }}
                                                                disabled={this.disableEditAfterSold(data)}
                                                                style={
                                                                  customerData && this.identityDocumentComplete(customerData, isVietnam) ? {
                                                                    marginLeft: '0.3em',
                                                                  } : null
                                                                }
                                                              >
                                                                {
                                                                  customerData && this.identityDocumentComplete(customerData, isVietnam) ?
                                                                  (<div><Icon name="pencil" /> {t('Edit', { ns: TRANSLATION_FILES.translation })}</div>)
                                                                  : `${t('Upload', { ns: TRANSLATION_FILES.translation })} ${isVietnam ? this.idDocumentShape(customerData.customer.identityTypeID).label : t(customerData.customer.identityTypeID === 1 ? 'IC' : 'Identification')}`
                                                                }
                                                              </Label>
                                                            }
                                                            disabled={!this.disableEditAfterSold(data)}
                                                            content={t('Purchaser details are locked because the booking has been marked as Sold', { ns: TRANSLATION_FILES.translation })}
                                                          />
                                                        )
                                                      }
                                                      </div>
                                                    </Grid>
                                                  </Container>
                                                 // check if is ios and conditional rendering ( NRIC snapshot )
                                                )}
                                              </Grid.Column>
                                              )}
                                              {showsESignature && (
                                                // check if is IOS and conditional rendering ( E-Signature )
                                                !isIOS ? (
                                                  <Grid.Column textAlign="right" width={signatureColumnWidth} style={!widthIsLessThan1200 ? { paddingLeft: showsIDSnapshot ? '0.2em' : '1rem' } : { paddingTop: 0 }}>
                                                    <Container className="nric-signature-container e-signature-container">
                                                      {
                                                        customerData && customerData.signAt ? (
                                                          <Icon name="check circle" style={{ color: 'green', float: 'right', fontSize: '1.5em', margin: '0.1em' }} />
                                                        ) : null
                                                      }
                                                      <Grid style={{ justifyContent: 'center', paddingTop: '0.5em' }}>
                                                        <Icon name="pencil" />
                                                        <Header className="icSignStyle" as="h4">
                                                          {t('E-Signature')}
                                                          {this.renderSignPadUnavailableTooltip()}
                                                        </Header>
                                                      </Grid>
                                                      <Grid style={{ justifyContent: 'center', paddingTop: '0.8em' }}>
                                                        {
                                                          customerData && customerData.signAt ? (
                                                            <div style={{ display: 'flex', marginTop: '0.2em' }}>
                                                              Signed on&nbsp;
                                                              <Timestamp
                                                                timestamp={customerData.signAt}
                                                              />&nbsp;
                                                              {
                                                                this.hasPurchaserSignPadAccess(
                                                                  data.project.allowAgentManageBookingCustomer,
                                                                  data.statusID,
                                                                ) &&
                                                                <button onClick={e => this.handleShowSign(e, customerData)} className="a-button-blue" style={{ marginLeft: '0.2em' }}><Icon name="edit" /></button>
                                                              }
                                                              {this.hasShareESignAccess() &&
                                                                <button disabled={this.state.loading} onClick={e => this.handleShowShareESign(e, customerData)} className="a-button-blue" style={{ marginLeft: '0.2em' }}><Icon name="share square" /></button>
                                                              }
                                                            </div>
                                                          ) : (
                                                            <div className="e-signature-actions">
                                                              {this.hasPurchaserSignPadAccess(
                                                                data.project.allowAgentManageBookingCustomer,
                                                                data.statusID,
                                                              ) ? (
                                                                <Label
                                                                  size="mini"
                                                                  as="a"
                                                                  color="blue"
                                                                  onClick={e => this.handleShowSign(e, customerData)}
                                                                >
                                                                  {t('Sign')}
                                                                </Label>
                                                              ) : null}
                                                              {this.hasShareESignAccess() && (
                                                                <Label
                                                                  size="mini"
                                                                  as="a"
                                                                  color="blue"
                                                                  onClick={e => this.handleShowShareESign(e, customerData)}
                                                                  disabled={this.state.loading}
                                                                >
                                                                  {t('Share')}
                                                                </Label>
                                                              )}
                                                            </div>
                                                          )
                                                        }
                                                      </Grid>
                                                    </Container>
                                                  </Grid.Column>
                                                ) : (
                                                  <Grid.Column textAlign="right" width={signatureColumnWidth} style={!widthIsLessThan1200 ? { paddingLeft: showsIDSnapshot ? '0.2em' : '1rem' } : { paddingTop: 0 }}>
                                                    <Container className="nric-signature-container e-signature-container">
                                                      {
                                                        customerData && customerData.signAt ? (
                                                          <Icon name="check circle" style={{ color: 'green', float: 'right', fontSize: '1.5em', margin: '0.1em' }} />
                                                        ) : null
                                                      }
                                                      <Grid style={{ justifyContent: 'center', paddingTop: '0.5em', margin: '0' }}>
                                                        <Icon name="pencil" />
                                                        <Header className="icSignStyle" as="h4">
                                                          {t('E-Signature')}
                                                          {this.renderSignPadUnavailableTooltip()}
                                                        </Header>
                                                      </Grid>
                                                      <Grid style={{ justifyContent: 'center', paddingTop: '0.8em', marginTop: '0' }}>
                                                        {
                                                          customerData && customerData.signAt ? (
                                                            <div style={{ display: 'flex', marginTop: '0.2em' }}>
                                                              Signed on&nbsp;
                                                              <Timestamp
                                                                timestamp={customerData.signAt}
                                                              />&nbsp;
                                                              {
                                                                this.hasPurchaserSignPadAccess(
                                                                  data.project.allowAgentManageBookingCustomer,
                                                                  data.statusID,
                                                                ) &&
                                                                <button onClick={e => this.handleShowSign(e, customerData)} className="a-button-blue" style={{ marginLeft: '0.2em' }}><Icon name="edit" /></button>
                                                              }
                                                              {this.hasShareESignAccess() &&
                                                                <button disabled={this.state.loading} onClick={e => this.handleShowShareESign(e, customerData)} className="a-button-blue" style={{ marginLeft: '0.2em' }}><Icon name="share square" /></button>
                                                              }
                                                            </div>
                                                          ) : (
                                                            <div className="e-signature-actions">
                                                              {this.hasPurchaserSignPadAccess(
                                                                data.project.allowAgentManageBookingCustomer,
                                                                data.statusID,
                                                              ) ? (
                                                                <Label
                                                                  size="mini"
                                                                  as="a"
                                                                  color="blue"
                                                                  onClick={e => this.handleShowSign(e, customerData)}
                                                                >
                                                                  {t('Sign')}
                                                                </Label>
                                                              ) : null}
                                                              {this.hasShareESignAccess() && (
                                                                <Label
                                                                  size="mini"
                                                                  as="a"
                                                                  color="blue"
                                                                  onClick={e => this.handleShowShareESign(e, customerData)}
                                                                  disabled={this.state.loading}
                                                                >
                                                                  {t('Share')}
                                                                </Label>
                                                              )}
                                                            </div>
                                                          )
                                                        }
                                                      </Grid>
                                                    </Container>
                                                  </Grid.Column>
                                              // check if is IOS and conditional rendering ( E-Signature )
                                              ))}
                                            </Grid>
                                            {(showsIDSnapshot || showsESignature) && <Divider style={{ margin: '0.5em 0' }} />}
                                            <Grid style={showsIDSnapshot || showsESignature ? null : { marginTop: '1.0em' }}>
                                              <Grid.Column textAlign="left" width={8} {...this.getDataAttributes(idx, 'identitytype', this.getIdentityTypeText(customerData.customer.identityTypeID, customerData.customer.identityPresetID, customerData.customer.identityLabel))}>
                                                <b>
                                                  {
                                                    this.getIdentityTypeText(
                                                      customerData.customer.identityTypeID,
                                                      customerData.customer.identityPresetID,
                                                      customerData.customer.identityPresetLabel,
                                                    )
                                                  }
                                                </b>
                                              </Grid.Column>
                                              <Grid.Column {...this.getDataAttributes(idx, 'identity', customerData.customer.identity)} textAlign="right" width={8}>
                                                {customerData.customer.identity}
                                              </Grid.Column>
                                            </Grid>
                                            <Divider style={{ margin: '0.5em 0' }} />
                                            {
                                              isMalaysia && customerData.customer.identityTypeID === IDENTITY_TYPE_BRN && (
                                                <React.Fragment>
                                                  <Grid>
                                                    <Grid.Column textAlign="left" width={8}>
                                                      <b>
                                                        {t('Foreign Company', { ns: TRANSLATION_FILES.screens })}
                                                      </b>
                                                    </Grid.Column>
                                                    <Grid.Column {...this.getDataAttributes(idx, 'isForeignCompany', customerData.customer.isForeignCompany)} textAlign="right" width={8}>
                                                      {t(customerData.customer.isForeignCompany ? 'Yes' : 'No')}
                                                    </Grid.Column>
                                                  </Grid>
                                                  <Divider style={{ margin: '0.5em 0' }} />
                                                </React.Fragment>
                                              )
                                            }
                                            {(isMalaysia || isIndonesia) && (
                                              <React.Fragment>
                                                <Grid>
                                                  <Grid.Column textAlign="left" width={6}>
                                                    <b>
                                                      {isMalaysia && 'Tax Identification Number (TIN)'}
                                                      {isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'}
                                                    </b>
                                                  </Grid.Column>
                                                  <Grid.Column textAlign="right" width={10} {...this.getDataAttributes(idx, 'taxIdentificationNo', customerData.customer.taxIdentificationNo)}>
                                                    <span style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                      {
                                                        customerData && customerData.customer && customerData.customer.taxIdentificationNo ? (
                                                          isMalaysia ? (
                                                            <div>
                                                              <Icon
                                                                name={customerData.customer.taxTinValidationStatus === 'success' ? 'check circle' : 'remove circle'}
                                                                color={customerData.customer.taxTinValidationStatus === 'success' ? 'green' : 'red'}
                                                                style={{ marginLeft: '0.5em' }}
                                                              />
                                                              {customerData.customer.taxIdentificationNo}
                                                            </div>
                                                          ) : (
                                                            <div>
                                                              {customerData.customer.taxIdentificationNo}
                                                            </div>
                                                          )
                                                        ) : (
                                                          '-'
                                                        )
                                                      }
                                                    </span>
                                                  </Grid.Column>
                                                </Grid>
                                                <Divider style={{ margin: '0.5em 0' }} />
                                              </React.Fragment>
                                            )}
                                            {
                                              customerData.clientID && (
                                                <React.Fragment>
                                                  <Grid>
                                                    <Grid.Column textAlign="left" width={8}>
                                                      <b>{translateModels(t, 'clientID', 'booking')}</b>
                                                    </Grid.Column>
                                                    <Grid.Column textAlign="right" width={8}>
                                                      {customerData.clientID}
                                                    </Grid.Column>
                                                  </Grid>
                                                  <Divider style={{ margin: '0.5em 0' }} />
                                                </React.Fragment>
                                              )
                                            }
                                            <Grid>
                                              <Grid.Column textAlign="left" width={8}>
                                                <b>{t(customerData.customer.identityTypeID === 4 ? 'Company Name' : 'Name')}</b>
                                              </Grid.Column>
                                              <Grid.Column textAlign="right" width={8} className="word_break_word" {...this.getDataAttributes(idx, 'title', customerData.title)} {...this.getDataAttributes(idx, 'name', customerData.name)}>
                                                {this.toUppercaseFormat(customerData ? `${customerData.title === 'Not Applicable' ? '' : t(customerData.title, { ns: TRANSLATION_FILES.constants })} ${customerData.name}` : '-')}
                                              </Grid.Column>
                                            </Grid>
                                            <Divider style={{ margin: '0.5em 0' }} />
                                            <Grid>
                                              <Grid.Column textAlign="left" width={8}>
                                                <b>{t(customerData.customer.identityTypeID === 4 ? 'Contact Person' : 'Preferred Name')}</b>
                                              </Grid.Column>
                                              <Grid.Column textAlign="right" width={8} className="word_break_word">
                                                {this.toUppercaseFormat(customerData ? customerData.preferredName : '-')}
                                              </Grid.Column>
                                            </Grid>
                                            <Divider style={{ margin: '0.5em 0' }} />
                                            <Grid>
                                              <Grid.Column textAlign="left" width={8}>
                                                <b>{translateModels(t, 'email', 'booking')}</b>
                                              </Grid.Column>
                                              <Grid.Column textAlign="right" width={8} className="word_break_all" {...this.getDataAttributes(idx, 'email', customerData.email.toLowerCase())}>
                                                {customerData ? customerData.email.toLowerCase() : '-'}
                                              </Grid.Column>
                                            </Grid>
                                            <Divider style={{ margin: '0.5em 0' }} />
                                            <Grid>
                                              <Grid.Column textAlign="left" width={8}>
                                                <b>{t('Mobile')}</b>
                                              </Grid.Column>
                                              <Grid.Column textAlign="right" width={8} {...this.getDataAttributes(idx, 'mobile', customerData.mobile && customerData.mobilePrefix ? `${customerData.mobilePrefix}${customerData.mobile}` : '')}>
                                                {
                                                  (customerData && customerData.mobile) ?
                                                    <Phone
                                                      mobilePrefix={customerData.mobilePrefix}
                                                      mobile={customerData.mobile}
                                                    />
                                                    : ''
                                                }
                                              </Grid.Column>
                                            </Grid>
                                            <Divider style={{ margin: '0.5em 0' }} />
                                            <Grid>
                                              <Grid.Column textAlign="left" width={8}>
                                                <b>{t('Phone')}</b>
                                              </Grid.Column>
                                              <Grid.Column textAlign="right" width={8} {...this.getDataAttributes(idx, 'phone', customerData.phone && customerData.phonePrefix ? `${customerData.phonePrefix}${customerData.phone}` : '')}>
                                                {
                                                  (customerData && customerData.phone) ?
                                                    <Phone
                                                      mobilePrefix={customerData.phonePrefix}
                                                      mobile={customerData.phone}
                                                    />
                                                    : '-'
                                                }
                                              </Grid.Column>
                                            </Grid>
                                            <Divider style={{ margin: '0.5em 0' }} className="large-hide small-hide" />
                                          </Grid.Column>
                                          <Grid.Column mobile={16} tablet={16} computer={10}>
                                            {
                                              _.flatMap(enabledAddressSettings.map((as, asixd) => {
                                                const key = _.camelCase(as.columnName);
                                                let addressLabel = as.label.toLowerCase();
                                                if (!as.required && (!customerData || !(customerData && customerData[key]))) {
                                                  return null;
                                                }

                                                let dattr = as.columnName.replace('_', 'line');
                                                let value = customerData[key];
                                                if (isMalaysia) {
                                                  switch (as.columnName) {
                                                    case 'address_5':
                                                      addressLabel = 'postcode';
                                                      dattr = 'postcode';
                                                      break;
                                                    case 'address_6':
                                                      addressLabel = 'city';
                                                      dattr = 'city';
                                                      break;
                                                    case 'address_7':
                                                      addressLabel = 'state';
                                                      dattr = 'state';
                                                      value = this.valueToText(STATES, customerData[key], true).toString().toUpperCase();
                                                      break;
                                                    default:
                                                      break;
                                                  }
                                                }

                                                // for Skyworld Vietnam, we update the label name for state/city/postcode to province/ward/postalCode
                                                if (isVietnam && addressLabel === 'state') {
                                                  addressLabel = 'cityOrProvince';
                                                  dattr = 'province';
                                                } else if (isVietnam && addressLabel === 'city') {
                                                  addressLabel = 'ward';
                                                  dattr = 'ward';
                                                } else if (isVietnam && addressLabel === 'postcode') {
                                                  addressLabel = 'postalCode';
                                                  dattr = 'postalCode';
                                                }

                                                return (
                                                  <Grid key={asixd}>
                                                    <Grid.Column mobile={8} tablet={6} computer={5} textAlign="left">
                                                      <b>{translateModels(t, addressLabel, 'booking')}</b>
                                                    </Grid.Column>
                                                    <Grid.Column textAlign="right" width={11} className="word_break_word" {...this.getDataAttributes(idx, dattr, value)}>
                                                      {this.toUppercaseFormat(customerData ? value : '-')}
                                                    </Grid.Column>
                                                  </Grid>
                                                );
                                              }).filter(p => !!p), (value, iidx) => [value, <Divider key={`divider_${iidx}`} style={{ margin: '0.5em 0' }} />])
                                            }
                                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                              <Grid>
                                                <Grid.Column textAlign="left" width={8}>
                                                  <b>{translateModels(t, 'country', 'booking')}</b>
                                                </Grid.Column>
                                                <Grid.Column textAlign="right" width={8} {...this.getDataAttributes(idx, 'country', getCountryName(customerData.country))}>
                                                  {this.toUppercaseFormat(
                                                    getCountryName(
                                                      customerData ?
                                                        customerData.country : null,
                                                    ),
                                                  )}
                                                </Grid.Column>
                                              </Grid>
                                              <Divider style={{ margin: '0.5em 0' }} />
                                            </Grid.Column>
                                            {this.renderCitizenshipView(customerData, idx)}
                                            {this.renderRelationshipTypeView(customerData, idx)}
                                            {this.renderDefaultFields(false, customerData, idx)}
                                          </Grid.Column>
                                        </Grid.Row>
                                        {
                                          this.props.auth.creditCheckAccess ?
                                            <Grid.Row style={{ paddingTop: '0' }}>
                                              <Grid.Column mobile={16}>
                                                <Divider style={{ marginTop: '0' }} />
                                                <Grid>
                                                  <BookingCreditCheck
                                                    auth={this.props.auth}
                                                    customerData={customerData}
                                                    data={data}
                                                  />
                                                </Grid>
                                              </Grid.Column>
                                            </Grid.Row> :
                                            null
                                        }
                                        {
                                          (isPRS && data.paymentMethodID === 'government_loan') ?
                                            <Grid.Row style={{ paddingTop: '0' }}>
                                              <Grid.Column mobile={16}>
                                                <Divider style={{ margin: '0.5em 0' }} />
                                                <LPPSAChecker
                                                  bookingID={data.id}
                                                  data={customerData.customer}
                                                  token={this.props.token}
                                                  type="booking"
                                                  loading={this.state.loading}
                                                  onChange={lppsaData => this.handleOnChangeLPPSA(lppsaData, idx)}
                                                />
                                              </Grid.Column>
                                            </Grid.Row>
                                            : ''
                                        }
                                      </Grid>
                                    }
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                            </Segment>
                          </div>
                        );
                      }) : null
                }
                {
                  this.hasCustomerManageAccess(
                    data.project.allowAgentManageBookingCustomer,
                    data.statusID,
                  ) && !this.state.customerAddArea && isEditingCustomer < 1 ?
                    this.checkUnitIsSold(data) && !this.hasAccess() ?
                      '' :
                      <Segment style={{ marginTop: '2em' }}>
                        <Grid>
                          <Grid.Row>
                            <Grid.Column width={16} textAlign="center">
                              <Popup
                                trigger={
                                  <div style={{ display: 'inline-block' }}>
                                    <Button
                                      onClick={this.handleOpenCustomerAddArea}
                                      size="large"
                                      disabled={this.disableEditAfterSold(data)}
                                    >
                                      {t('Add Purchaser')}
                                    </Button>
                                  </div>
                                }
                                disabled={!this.disableEditAfterSold(data)}
                                content={t('Purchaser details are locked because the booking has been marked as Sold', { ns: TRANSLATION_FILES.translation })}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Segment>
                    : ''
                }
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            {this.state.customerAddArea ?
              <Grid.Column width={16} className="customer add">
                <Header className="new_title" as="h5" attached="top" textAlign="center">
                  {t('Add Purchaser').toUpperCase()} {data.bookingCustomers && data.bookingCustomers.length + 1}
                </Header>
                <Segment attached>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <AppForm
                          error={this.state.errMessages.length > 0}
                          onSubmit={this.handleSubmit}
                          ref={(ref) => { this.form = ref; }}
                          id="add_purchaser_form"
                        >
                          <Grid>
                            <Grid.Row>
                              <Grid.Column width={16}>
                                <br />
                                <Grid>
                                  {constructResponsiveIdentityTinInputs()}
                                  <Grid.Row centered>
                                    {this.state.showNoAutofill &&
                                      <Grid.Column width={16}>
                                        <Segment secondary>
                                          <b>
                                            {
                                              isPRS ?
                                                this.state.fetchDataErrorMessage :
                                                isVietnam ?
                                                  `${t('No existing details found')}. ${t('A new customer will be created in the CRM when you save')}.` :
                                                  `${t('No existing details found')}.`
                                            }
                                          </b>
                                        </Segment>
                                      </Grid.Column>
                                    }
                                    {(!isPRS && (this.state.autofillOptions && this.state.autofillOptions.length > 0)) &&
                                      <Grid.Column width={16}>
                                        <Segment secondary>
                                          <b>{t('Customer details found')}. &nbsp;</b><br className="large-hide small-hide" />
                                          {
                                            (this.state.autofillOptions && this.state.autofillOptions.length > 0) && (
                                              <Dropdown
                                                trigger={(
                                                  <button
                                                    className="a-button-blue"
                                                    onClick={e => e.preventDefault()}
                                                  >
                                                    {t('Autofill')}
                                                  </button>
                                                )}
                                                options={this.state.autofillOptions}
                                              >
                                                <Dropdown.Menu>
                                                  <Dropdown.Header content={t('Autofill from')} />
                                                  {this.state.autofillOptions.map(item => <Dropdown.Item {...item} />)}
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            )
                                          }
                                        </Segment>
                                      </Grid.Column>
                                    }
                                  </Grid.Row>
                                  <Grid.Row>
                                    <Grid.Column width={16}>
                                      <Form.Group widths="equal">
                                        {
                                          this.state.hideTitle ? null : (
                                            <AppForm.Validate
                                              validation={[required]}
                                              ref={this.validation.title}
                                              onChange={this.handleCustomerAddSelectChange}
                                              validateLabel={translateModels(t, 'title', 'booking')}
                                            >
                                              <Form.Select
                                                label={`${translateModels(t, 'title', 'booking')}*`}
                                                name="title"
                                                options={this.toUppercaseOptions(CUSTOMER_TITLES).map(o => ({
                                                  ...o,
                                                  text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                                                }))}
                                                placeholder={`${t('Select {{title}}', { title: translateModels(t, 'title', 'booking') })}*`}
                                                search
                                                selectOnBlur={false}
                                                noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                                value={this.state.customerAdd.title}
                                              />
                                            </AppForm.Validate>
                                          )
                                        }
                                        <AppForm.Input
                                          autoComplete="off"
                                          label={`${t(this.state.identityType === 4 ? 'Company Name' : 'Full Name')}*`}
                                          name="name"
                                          onChange={this.handleCustomerAddInputChange}
                                          placeholder={`${t(this.state.identityType === 4 ? 'Company Name' : 'Full Name')}*`}
                                          ref={this.validation.name}
                                          validation={[required, ...vnFullNameValidations(auth, this.state.identityType, t)]}
                                          value={this.state.customerAdd.name}
                                          validateLabel={t(this.state.identityType === 4 ? 'Company Name' : 'Full Name')}
                                        />
                                        <AppForm.Input
                                          autoComplete="off"
                                          label={`${t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name')}*`}
                                          name="preferredName"
                                          onChange={this.handleCustomerAddInputChange}
                                          placeholder={`${t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name')}*`}
                                          ref={this.validation.preferredName}
                                          validation={
                                            this.state.identityType === 4
                                              ? [required, ...vnPreferredNameValidations(auth, t)]
                                              : [
                                                required,
                                                {
                                                  validate: stringLength,
                                                  option: {
                                                    max: 15,
                                                  },
                                                },
                                                ...vnPreferredNameValidations(auth, t),
                                              ]
                                          }
                                          value={this.state.customerAdd.preferredName}
                                          validateLabel={t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name')}
                                        />
                                        <AppForm.Input
                                          autoComplete="off"
                                          label={`${translateModels(t, 'email', 'booking')}${this.checkIsEmailRequired() ? '*' : ''}`}
                                          name="email"
                                          type="email"
                                          onChange={this.handleCustomerAddInputChange}
                                          placeholder={translateModels(t, 'email', 'booking')}
                                          validation={this.getEmailValidation()}
                                          validateLabel={translateModels(t, 'email', 'booking')}
                                          ref={this.validation.email}
                                          value={this.state.customerAdd.email}
                                        />
                                      </Form.Group>
                                      <Form.Group widths="equal">
                                        <AppForm.Validate
                                          validation={[required]}
                                          ref={this.validation.mobilePrefix}
                                          onChange={this.handleCustomerAddSelectChange}
                                          validateLabel={translateModels(t, 'mobilePrefix', 'booking')}
                                        >
                                          <Form.Select
                                            label={`${translateModels(t, 'mobilePrefix', 'booking')}*`}
                                            name="mobilePrefix"
                                            disabled={this.state.mobileLock}
                                            onChange={this.handleCustomerAddSelectChange}
                                            options={this.toUppercaseOptions(INTL_CALL_CODES)}
                                            search
                                            selectOnBlur={false}
                                            noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                            value={this.state.customerAdd.mobilePrefix}
                                          />
                                        </AppForm.Validate>
                                        <PhoneInput
                                          className={`ui fluid
                                            ${this.state.customerAdd.mobilePrefix}
                                            ${this.state.searchingIDByMobile ? 'loading icon' : ''}
                                            ${this.hasResetMobileIcon(this.state.customerAdd.mobile) ? 'icon ' : ''}input
                                          `}
                                          autoComplete="off"
                                          icon={this.getPhoneInputIcon(this.state.customerAdd.mobile)}
                                          iconPosition="right"
                                          label={`${t('Mobile')}*`}
                                          name="mobile"
                                          onChange={this.handleCustomerAddInputChange}
                                          placeholder="e.g. 196756118"
                                          prefix={this.state.customerAdd.mobilePrefix}
                                          readOnly={this.state.mobileLock}
                                          ref={this.validation.mobile}
                                          type="tel"
                                          validation={[required, mobileValidation({
                                            presets: this.state.phoneValidationPresets,
                                            prefix: this.state.customerAdd.mobilePrefix,
                                            label: t('Mobile'),
                                            t,
                                          })]}
                                          value={this.state.customerAdd.mobile}
                                          validateLabel={t('Mobile')}
                                        />
                                        <Form.Select
                                          label={t('House/Office Phone prefix')}
                                          name="phonePrefix"
                                          onChange={this.handleCustomerAddSelectChange}
                                          options={this.toUppercaseOptions(INTL_CALL_CODES)}
                                          search
                                          selectOnBlur={false}
                                          noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                          value={this.state.customerAdd.phonePrefix}
                                        />
                                        <PhoneInput
                                          autoComplete="off"
                                          label={t('House/Office Phone')}
                                          name="phone"
                                          onChange={this.handleCustomerAddInputChange}
                                          placeholder="e.g. 378317749"
                                          prefix={this.state.customerAdd.phonePrefix}
                                          ref={this.validation.phone}
                                          type="tel"
                                          value={this.state.customerAdd.phone}
                                          validation={[{
                                            validate: phoneNumber,
                                            option: this.state.customerAdd.phonePrefix === 'other' ? {} : {
                                              phonePrefix: this.state.customerAdd.phonePrefix,
                                              validRegex: getPhoneValidRegex(
                                                this.state.phoneValidationPresets,
                                                this.state.customerAdd.phonePrefix,
                                                'phone',
                                              ),
                                            },
                                          }]}
                                          validateLabel={t('House/Office Phone')}
                                        />
                                      </Form.Group>
                                      {this.renderCitizenshipInputs('customerAdd')}
                                      {
                                        // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
                                        _.chunk(enabledAddressSettings.map((as, iidx) => {
                                          const key = _.camelCase(as.columnName);
                                          let addressLabel = as.label.toLowerCase();
                                          let isRequired = as.required;
                                          let errMessage = null;
                                          const validations = [{
                                            validate: stringLength,
                                            option: {
                                              max: 256,
                                            },
                                          }];

                                          // Determine behavior based on selected country in the form
                                          const selectedCountry = (this.state.customerAdd.country || '').toUpperCase();
                                          const isSelectedCountryMalaysia = selectedCountry === 'MY';

                                          // When company is Vietnam: apply country-dependent logic for state field
                                          if (isVietnam && addressLabel === 'state') {
                                            if (isSelectedCountryMalaysia) {
                                              // Malaysia selected: keep as "State", required
                                              isRequired = true;
                                            } else {
                                              // Non-Malaysia selected: change to "City/Province", optional
                                              addressLabel = 'cityOrProvince';
                                              isRequired = false;
                                            }
                                          } else if (isVietnam && addressLabel === 'city' && !isSelectedCountryMalaysia) {
                                            addressLabel = 'ward';
                                            isRequired = false;
                                          } else if (isVietnam && addressLabel === 'postcode' && !isSelectedCountryMalaysia) {
                                            addressLabel = 'postalCode';
                                            isRequired = false;
                                          }

                                          if (isRequired) {
                                            validations.push(required);
                                          }
                                          if (!himsIsEnabled && isSelectedCountryMalaysia && as.label.toLowerCase() === 'postcode') {
                                            validations.push({
                                              validate: matchRegex,
                                              option: {
                                                validRegex: REGEX_POSTCODE_MY,
                                              },
                                            });
                                            errMessage = 'Invalid MY postcode format';
                                          }

                                          const label = `${translateModels(t, addressLabel, 'booking')}${isRequired ? '*' : ''}`;

                                          if (!isPRS && isSelectedCountryMalaysia && as.label.toLowerCase() === 'state') {
                                            return (
                                              <AppForm.Validate
                                                key={iidx}
                                                validation={isRequired ? [required] : null}
                                                ref={this.validation[key]}
                                                onChange={this.handleCustomerAddSelectChange}
                                                validateLabel={as.label.toLowerCase() === 'state' ? translateModels(t, 'state', 'booking') : as.label}
                                              >
                                                <Form.Select
                                                  name={key}
                                                  fluid
                                                  options={this.toUppercaseOptions(STATES)}
                                                  placeholder={t('Select {{title}}', { title: label.toLowerCase() })}
                                                  label={label}
                                                  search
                                                  selectOnBlur={false}
                                                  noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                                  value={this.state.customerAdd[key]}
                                                />
                                              </AppForm.Validate>
                                            );
                                          }

                                          if (himsIsEnabled && isSelectedCountryMalaysia && as.label.toLowerCase() === 'postcode') {
                                            return (
                                              <SearchHimsPostcodes
                                                key={iidx}
                                                validateRef={this.validation.himsKodPoskod}
                                                name="himsKodPoskod"
                                                onSelect={this.handleCustomerAddSelectHimsPostcode}
                                                state={this.state.customerAdd.address7}
                                                value={this.state.customerAdd.himsKodPoskod}
                                              />
                                            );
                                          }

                                          return (
                                            <AppForm.Input
                                              key={iidx}
                                              autoComplete="off"
                                              name={key}
                                              onChange={this.handleCustomerAddInputChange}
                                              placeholder={label}
                                              label={label}
                                              ref={this.validation[key]}
                                              validation={validations}
                                              value={this.state.customerAdd[key]}
                                              validateLabel={addressLabel}
                                              message={errMessage}
                                            />
                                          );
                                        }).concat([(
                                          <AppForm.Validate
                                            validation={[required]}
                                            ref={this.validation.country}
                                            onChange={(e, stateData) => {
                                              // Reset state input field
                                              if (!isPRS) {
                                                const as = enabledAddressSettings.find(a => a.label.toLowerCase() === 'state');
                                                if (as) {
                                                  const key = _.camelCase(as.columnName);
                                                  const { customerAdd } = this.state;
                                                  if (customerAdd[key]) {
                                                    customerAdd[key] = '';
                                                    this.setState({ customerAdd });
                                                  }
                                                }
                                              }
                                              this.handleCustomerAddSelectChange(e, stateData);
                                            }}
                                            validateLabel={translateModels(t, 'country', 'booking')}
                                          >
                                            <Form.Select
                                              autoComplete="off"
                                              fluid
                                              label={`${translateModels(t, 'country', 'booking')}*`}
                                              name="country"
                                              options={this.toUppercaseOptions(SELECT_COUNTRIES)}
                                              placeholder={`${t('Select {{title}}', { title: translateModels(t, 'country', 'booking') })}*`}
                                              search
                                              noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                              selectOnBlur={false}
                                              value={this.state.customerAdd.country}
                                            />
                                          </AppForm.Validate>
                                        )]), 2).map((p, iidx) => (
                                          <Form.Group widths="equal" key={`new_group_${iidx}`}>
                                            {p}
                                          </Form.Group>
                                        ))
                                      }
                                      {
                                        himsIsEnabled && isNewMalaysia ? (
                                          <Form.Group widths="equal">
                                            <SearchHimsDistricts
                                              validateRef={this.validation.himsKodDaerah}
                                              name="himsKodDaerah"
                                              onSelect={this.handleCustomerAddSelectHimsDistrict}
                                              state={this.state.customerAdd.address7}
                                              value={this.state.customerAdd.himsKodDaerah}
                                            />
                                            <span style={{ flex: '1 1 auto', width: '100%' }} />
                                          </Form.Group>
                                        ) : null
                                      }
                                      {!isPRS &&
                                        <div style={{ textAlign: 'center' }}>
                                          <button
                                            className="a-button-blue"
                                            onClick={this.handleCopyAddressFromPrimaryPurchaser}
                                          >
                                            {t('Copy Address from Primary Purchaser')}
                                          </button>
                                        </div>
                                      }
                                      <br />
                                      {this.renderDefaultFields(true, this.state.customerAdd, 0, true)}
                                    </Grid.Column>
                                  </Grid.Row>
                                </Grid>
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </AppForm>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <Grid>
                          {showsIDSnapshot && (
                          <Grid.Row>
                            <Grid.Column mobile={16} tablet={addShape.sides === 2 ? 8 : 16} computer={addShape.sides === 2 ? 8 : 16} textAlign="center">
                              <UploadForm
                                isCompress
                                title="Front"
                                ref={(ref) => { this.icFrontUploadAddCustomer = ref; }}
                                setLoading={this.setLoading}
                                loading={this.state.loading}
                                sampleURL={addShape.sample ? '/assets/images/samples/ic_front.svg' : ''}
                                tags={['IC Front']}
                                picture={this.state.customerAdd.customer && this.state.customerAdd.customer.icFrontDocumentID && this.state.customerAdd.customer.icFrontDocumentID.length > 0 ?
                                  this.state.customerAdd.customer.icFrontDocument : null}
                                {...this.identityAcceptProps()}
                                onChange={ic => this.handleGetIC(ic, 'FrontAddCustomer', 'addCustomerICChanges')}
                              />
                            </Grid.Column>
                            {addShape.sides === 2 && (
                            <Grid.Column width={16} tablet={8} computer={8} textAlign="center">
                              <UploadForm
                                isCompress
                                title="Back"
                                ref={(ref) => { this.icBackUploadAddCustomer = ref; }}
                                setLoading={this.setLoading}
                                loading={this.state.loading}
                                sampleURL={addShape.sample ? '/assets/images/samples/ic_back.svg' : ''}
                                tags={['IC Back']}
                                picture={this.state.customerAdd.customer && this.state.customerAdd.customer.icBackDocumentID && this.state.customerAdd.customer.icBackDocumentID.length > 0 ?
                                  this.state.customerAdd.customer.icBackDocument : null}
                                {...this.identityAcceptProps()}
                                onChange={ic => this.handleGetIC(ic, 'BackAddCustomer', 'addCustomerICChanges')}
                              />
                            </Grid.Column>
                            )}
                          </Grid.Row>
                          )}
                          <Grid.Row>
                            <Grid.Column width={16} textAlign="center">
                              <Button onClick={this.handleCloseCustomerAddArea} content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
                              <Button
                                disabled={this.state.loading || this.state.validatingTin}
                                loading={this.state.loading}
                                primary
                                content={t('Add Purchaser')}
                                onClick={e => this.form.handleSubmit(e)}
                              />
                              <Divider style={{ margin: '0.5rem' }} hidden />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
              : ''
            }
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.booking,
  TRANSLATION_FILES.models.customer,
])(connect(Purchaser.mapStateToProps)(Purchaser));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Overview/Purchaser.jsx